webpackJsonp([1],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "09GF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0jK8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1izC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2MJW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4N50":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiAyOC41MDEzMzNBNDgzLjU1NTU1NiA0ODMuNTU1NTU2IDAgMSAwIDk5NS41NTU1NTYgNTEyIDQ4My41NTU1NTYgNDgzLjU1NTU1NiAwIDAgMCA1MTIgMjguNTAxMzMzeiIgZmlsbD0iIzAwODQ3RiIgLz48cGF0aCBkPSJNNDA3LjYwODg4OSA3NzIuMzIzNTU2bC0yMTAuNDg4ODg5LTIxMC40ODg4ODkgODAuNDQwODg5LTgwLjQ0MDg4OSAxMzAuMDQ4IDEzMC4wNDggMzMzLjAyNzU1NS0zMzMuMDI3NTU2IDgwLjQ0MDg4OSA4MC40NDA4ODl6IiBmaWxsPSIjRkZGRkZGIiAvPjwvc3ZnPg=="

/***/ }),

/***/ "887/":
/***/ (function(module, exports) {

module.exports = [{"bankCode":"HBBJ","bankName":"北京密云汇丰村镇银行"},{"bankCode":"HBCD","bankName":"重庆大足汇丰村镇银行"},{"bankCode":"HBCF","bankName":"重庆丰都汇丰村镇银行"},{"bankCode":"HBCQ","bankName":"重庆荣昌汇丰村镇银行"},{"bankCode":"HBDP","bankName":"大连普兰店汇丰村镇银行"},{"bankCode":"HBFU","bankName":"福建永安汇丰村镇银行"},{"bankCode":"HBMC","bankName":"湖北麻城汇丰村镇银行"},{"bankCode":"HBCB","bankName":"湖北随州曾都汇丰村镇银行"},{"bankCode":"HBHT","bankName":"湖北天门汇丰村镇银行"},{"bankCode":"HBHU","bankName":"湖南平江汇丰村镇银行"},{"bankCode":"HBSD","bankName":"山东荣成汇丰村镇银行"},{"bankCode":"HBGD","bankName":"广东恩平汇丰村镇银行"}]

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("PU+M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CVgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D6Ou":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FPiP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyBjbGFzcz0iaWNvbiIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjIwMC4wMHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiAyOC41MDEzMzNBNDgzLjU1NTU1NiA0ODMuNTU1NTU2IDAgMSAwIDk5NS41NTU1NTYgNTEyIDQ4My41NTU1NTYgNDgzLjU1NTU1NiAwIDAgMCA1MTIgMjguNTAxMzMzeiIgZmlsbD0iIzI1MjUyNSIgLz48cGF0aCBkPSJNNTY4Ljg4ODg4OSA3NjcuOTQzMTExSDQ1NS4xMTExMTFWNDU1LjkwNzU1NmgxMTMuNzc3Nzc4ek01MTIgMzUxLjk3MTU1NmE3MS4xMTExMTEgNzEuMTExMTExIDAgMSAxIDAtMTQyLjIyMjIyMyA3MS4xMTExMTEgNzEuMTExMTExIDAgMCAxIDAgMTQyLjIyMjIyM3oiIGZpbGw9IiNGRkZGRkYiIC8+PC9zdmc+"

/***/ }),

/***/ "FfCt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KzIr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAAD4/042AAACaElEQVRoBe2YMU8CMRTHOXGAwKqbbpAA5gyTrjL4CYwL38lvQWLQT+Ags3FAibCwGE0cdDIhgYWc712upint9dJ77R3hmhw92vP193/v9dmjVCpa4YHd9oCnkt9oNALVnI3x+XyuZIlbby9uMss53/cPu93ugY5BqZpFwNQzuoXj5hF8sVg8wjNevV6/GI/HP6rncxcBDv4EoDsgZBQXiVwJiOBHAI7wb3BNdSJyI4DzfAfhIXV61Wq1pxORCwEcfOh5hMe8n0wm3zoRmQtQwYPnZW2jtGcqQAePpXS5XGI1+k8rsSJlJoACHkOUiQAqeBSwjx8uWwSPpVKaFknShud1GgFqeBTiTIANeGcCbME7EWAT3roACng8FbOTMQKLzdoeoIAXYWXfrQhwBY+CyAVgHcczPNgmqfMyr/NjpAJ0/4R08zxY0nsyATo4YX7KjsxJQVXPkQgQ4MKXEf7UKMwjfOx7rgpWNp5agADnFB4FpRIQBIG3Wq0ewE7SDUvmeRaNVKfRdrt9BiJOPc/7qtVq4WsgMyxEhiznmX3Wp4rAer2+jgzdusp5Bs56YwGYPnBdoSHoh8ygxPPkacPWwt5YAKYP/P0RXB/9fv+51WqdN5vNG9gTLzCGe4K02oA9aTPeA1z6lAaDwTtYRzFhgz3xWqlULvm0YnPUvZEATB/wdpg+AHQcQX0C+H25XB7OZrMnuN/4CYQaHu0ZCYhAfqEPIug7HhrGokfsd0YC0LvQfMRjnnYJzbvFSAAPzhvL4t64CmUBK1uzECDzisuxrY+AdhPH/SLg0tOqtbY+AiphxXjhgV3xwB+97OqMI/2okAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "N5GO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/date-picker.css
var date_picker = __webpack_require__("isgN");
var date_picker_default = /*#__PURE__*/__webpack_require__.n(date_picker);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/base.css
var base = __webpack_require__("+BTi");
var base_default = /*#__PURE__*/__webpack_require__.n(base);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/date-picker.js
var lib_date_picker = __webpack_require__("tLa+");
var lib_date_picker_default = /*#__PURE__*/__webpack_require__.n(lib_date_picker);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/mobile-detect/mobile-detect.js
var mobile_detect = __webpack_require__("UMwo");
var mobile_detect_default = /*#__PURE__*/__webpack_require__.n(mobile_detect);

// CONCATENATED MODULE: ./src/assets/dbs/hashmap.js


/**
* 键名为字符的hashmap存储
* 贷款类型 lend 01定期贷款 02循环贷款
* 贷款id application_id 
* 本地ip createdIp
* 经度 createdLongitude
* 纬度 createdLatitude
* 区域 createdAddress
*/

var map = {
    '_map': {},
    'has': function has(key) {
        return !!map._map[key.toString()];
    },
    'get': function get(key) {
        return map._map[key.toString()];
    },
    'set': function set(key, value) {
        return map._map[key.toString()] = value;
    }
};

/* harmony default export */ var hashmap = (map);
// CONCATENATED MODULE: ./src/assets/utils/utils.js

//获取移动端系统版本号ios1.0 设备名称 小米


/*设置cookie*/
var utils = {
    cookie: {
        // 设置cookie
        setCookie: function setCookie(name, value, expire) {
            var date = new Date();
            if (!expire) {
                expire = 20 * 60;
            }
            date.setSeconds(date.getSeconds() + expire);
            document.cookie = name + '=' + escape(value) + '; expires=' + date.toGMTString() + ';path=/';
        },
        /*获取cookie*/
        getCookie: function getCookie(name) {
            if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(name + '=');
                if (start !== -1) {
                    start = start + name.length + 1;
                    var end = document.cookie.indexOf(';', start);
                    if (end === -1) {
                        end = document.cookie.length;
                    }
                    return unescape(document.cookie.substring(start, end));
                }
            }
            return '';
        },
        /*删除cookie*/
        delCookie: function delCookie(name) {
            this.setCookie(name, '', -1);
        }
    },
    storage: {
        // 获取本地存储
        fetchStorage: function fetchStorage(key) {
            return JSON.parse(window.localStorage.getItem(key || '[]'));
        },
        // 保存localStorage的数据
        setStorage: function setStorage(key, items) {
            window.localStorage.setItem(key, stringify_default()(items));
        },
        // 清除所有的的存储
        clearStorage: function clearStorage() {
            window.localStorage.clear();
        }
    },
    // 字符串
    strUtil: {
        /*
         * 判断字符串是否为空
         * @param str 传入的字符串
         * @returns {}
         */
        isEmpty: function isEmpty(str) {
            if (str !== undefined && str !== null && str.length > 0) {
                return false;
            }
            return true;
        },
        /*
         * 判断两个字符串子否相同
         * @param str1
         * @param str2
         * @returns {Boolean}
         */
        isEquals: function isEquals(str1, str2) {
            if (str1 === str2) {
                return true;
            }
            return false;
        },
        /*
         * 忽略大小写判断字符串是否相同
         * @param str1
         * @param str2
         * @returns {Boolean}
         */
        isEqualsIgnorecase: function isEqualsIgnorecase(str1, str2) {
            if (str1.toUpperCase() === str2.toUpperCase()) {
                return true;
            }
            return false;
        },
        /**
         * 判断是否是数字
         * @param value
         * @returns {Boolean}
         */
        isNum: function isNum(value) {
            if (value !== null && value.length > 0 && isNaN(value) === false) {
                return true;
            }
            return false;
        },
        /**
         * 判断是否是中文
         * @param str
         * @returns {Boolean}
         */
        isChine: function isChine(str) {
            var reg = /^([u4E00-u9FA5]|[uFE30-uFFA0])*$/;
            if (reg.test(str)) {
                return false;
            }
            return true;
        },
        ifNullThen: function ifNullThen(str, value) {
            return this.isEmpty(str) ? value : str;
        }
    },
    // 日期
    dateUtil: {
        /*
         * 方法作用：【取传入日期是星期几】
         * 使用方法：dateUtil.nowFewWeeks(new Date());
         * @param date{date} 传入日期类型
         * @returns {星期四，...}
         */
        nowFewWeeks: function nowFewWeeks(date) {
            if (date instanceof Date) {
                var dayNames = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                return dayNames[date.getDay()];
            }
            return 'Param error,date type!';
        },
        /*
         * 方法作用：【字符串转换成日期】
         * 使用方法：dateUtil.strTurnDate('2010-01-01');
         * @param str {String}字符串格式的日期，传入格式：yyyy-mm-dd(2015-01-31)
         * @return {Date}由字符串转换成的日期
         */
        strTurnDate: function strTurnDate(str) {
            var re = /^(\d{4})\S(\d{1,2})\S(\d{1,2})$/;
            var dt;
            if (re.test(str)) {
                dt = new Date(RegExp.$1, RegExp.$2 - 1, RegExp.$3);
            }
            return dt;
        },
        //20180101转成2018-01-01
        strToDate: function strToDate(str, space) {
            if (str.length !== 8) {
                return false;
            }
            if (!space) {
                space = '.';
            }
            return str.slice(0, 4) + space + str.slice(4, 6) + space + str.slice(6, 8);
        },
        /**
         * 方法作用：【格式化时间】
         * 使用方法
         *      date：需要为时间格式
         *
         *      format：为时间格式
         *      'yyyy年MM月dd日';
         *      'MM/dd/yyyy';
         *      'yyyyMMdd';
         *      'yyyy-MM-dd hh:mm:ss';
         */
        dateFormat: function dateFormat(date, format) {
            var o = {
                'M+': date.getMonth() + 1, //month
                'd+': date.getDate(), //day
                'h+': date.getHours(), //hour
                'm+': date.getMinutes(), //minute
                's+': date.getSeconds(), //second
                'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
                'S': date.getMilliseconds() //millisecond
            };
            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length));
            }
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length));
                }
            }
            return format;
        },
        /*
         * 方法作用：【计算2个日期之间的天数】
         * 传入格式：yyyy-mm-dd(2015-01-31)
         * 使用方法：dateUtil.dayMinus(startDate,endDate)
         * @startDate {Date}起始日期
         * @endDate {Date}结束日期
         * @return endDate - startDate的天数差
         */
        dayMinus: function dayMinus(startDate, endDate) {
            if (startDate instanceof Date && endDate instanceof Date) {
                var days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));
                return days;
            }
            return 'Param error,date type!';
        },
        add0: function add0(m) {
            return m < 10 ? '0' + m : m;
        },
        format: function format(shijianchuo, ymr) {
            //shijianchuo是整数，否则要parseInt转换
            var time = new Date(shijianchuo);
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            var d = time.getDate();
            var h = time.getHours();
            var mm = time.getMinutes();
            var s = time.getSeconds();
            if (ymr) {
                return y + '-' + this.add0(m) + '-' + this.add0(d);
            }
            return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
        }

    },
    tools: {
        // 获取url的参数
        getUrlParam: function getUrlParam(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
            var r = window.location.search.substr(1).match(reg); //匹配目标参数
            if (r !== null) {
                return decodeURIComponent(r[2]);
            }
            return ''; //返回参数值
        },
        IdentityCodeValid: function IdentityCodeValid(code) {
            var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外'
                // var tip = ''
            };var pass = true;

            if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
                // tip = '身份证号格式错误'
                pass = false;
            } else if (!city[code.substr(0, 2)]) {
                // tip = '地址编码错误'
                pass = false;
            } else if (code.length === 18) {
                //18位身份证需要验证最后一位校验位
                code = code.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                    ai = code[i];
                    wi = factor[i];
                    sum += ai * wi;
                }
                if (parity[sum % 11] !== code[17]) {
                    // tip = '校验位错误'
                    pass = false;
                }
            }
            return pass;
        },
        isPhone: function isPhone(mobilePhone) {
            var past = /^1[3-9]\d{9}$/;
            return past.test(mobilePhone);
        },
        //汉字校验
        nameValid: function nameValid(name) {
            var reg = /^[\u4e00-\u9fa5]+$/;
            return reg.test(name);
        },
        numAlphaValid: function numAlphaValid(str) {
            if (!str.match('^[A-Za-z0-9]+$')) {
                return false;
            }
            return true;
        },
        redirectUrl: function redirectUrl(url) {
            var el = document.createElement('a');
            document.body.appendChild(el);
            el.href = url;
            el.target = '_blank';
            el.click();
            document.body.removeChild(el);
        },
        //邮箱校验
        checkEmail: function checkEmail(email) {
            if (!email.match('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')) {
                return false;
            }
            return true;
        },
        // 只能输入数字-#*
        checkTelp: function checkTelp(telp) {
            var reg = /^[\d-*#]+$/;
            return reg.test(telp);
        }
    },
    getInfomation: {
        init: function init() {
            if (this.isWeiXin()) {
                hashmap.set('terminalType', 'Mobile');
                hashmap.set('messageChannel', 'WeChatWebBrowser');
                console.log('您的浏览设备为：Mobile,信息抓去渠道：WeChatWebBrowser');
            } else {
                this.browserRedirect();
            }
        },
        isWeiXin: function isWeiXin() {
            //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
            var ua = window.navigator.userAgent.toLowerCase();
            //通过正则表达式匹配ua中是否含有MicroMessenger字符串
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        },
        mobileInfo: function mobileInfo() {
            Array.prototype.contains = function (needle) {
                for (i in this) {
                    if (this[i].indexOf(needle) > 0) return i;
                }
                return -1;
            };
            var device_type = navigator.userAgent; //获取userAgent信息  
            var md = new mobile_detect_default.a(device_type); //初始化mobile-detect 
            var os = md.os(); //获取系统 
            var model = "";
            if (os == "iOS") {
                //ios系统的处理 
                os = md.os() + md.version("iPhone");
                model = md.mobile();
            } else if (os == "AndroidOS") {
                //Android系统的处理 
                os = md.os() + md.version("Android");
                var sss = device_type.split(";");
                var i = sss.contains("Build/");
                if (i > -1) {
                    model = sss[i].substring(0, sss[i].indexOf("Build/"));
                }
            }
            hashmap.set('systemVersion', os);
            hashmap.set('equipmentType', model);
            console.log('移动端设备类型：' + os + "，设备名称型号：" + model);
        },
        browserRedirect: function browserRedirect() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (bIsIphoneOs || bIsUc || bIsUc7 || bIsAndroid || bIsCE) {
                hashmap.set('terminalType', 'Mobile');
                hashmap.set('messageChannel', 'H5WebBrowser');
                console.log('您的浏览设备为：Mobile,信息抓去渠道：H5WebBrowser');
                this.mobileInfo();
            } else if (bIsIpad || bIsMidp || bIsWM) {
                hashmap.set('terminalType', 'iPad');
                hashmap.set('messageChannel', 'iPadWebBrowser');
                console.log('您的浏览设备为：iPad,信息抓去渠道：iPadWebBrowser');
                this.mobileInfo();
            } else {
                hashmap.set('terminalType', 'PC');
                hashmap.set('messageChannel', 'PCWebBrowser');
                console.log('您的浏览设备为：PC，信息抓取渠道：PCWebBrowser');
                this.driveInfo();
            }
        },
        driveInfo: function driveInfo() {
            var BrowserMatch = {
                init: function init() {
                    this.browser = this.getBrowser().browser || "未知浏览器"; //获取浏览器名
                    this.version = this.getBrowser().version || "未知浏览器版本号"; //获取浏览器版本
                    this.OS = this.getOS() + " " + this.getDigits() || "未知操作系统"; //系统版本号 
                },
                getOS: function getOS() {
                    //判断所处操作系统
                    var sUserAgent = navigator.userAgent.toLowerCase();

                    var isWin = navigator.platform == "Win32" || navigator.platform == "Win64" || navigator.platform == "wow64";

                    var isMac = navigator.platform == "Mac68K" || navigator.platform == "MacPPC" || navigator.platform == "Macintosh" || navigator.platform == "MacIntel";
                    if (isMac) return "Mac";
                    var isUnix = navigator.platform == "X11" && !isWin && !isMac;
                    if (isUnix) return "Unix";
                    var isLinux = String(navigator.platform).indexOf("Linux") > -1;
                    var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";
                    if (isLinux) {
                        if (bIsAndroid) return "Android";else return "Linux";
                    }
                    if (isWin) {

                        var isWin2K = sUserAgent.indexOf("Windows nt 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
                        if (isWin2K) return "Win2000";
                        var isWinXP = sUserAgent.indexOf("Windows nt 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
                        sUserAgent.indexOf("Windows XP") > -1;
                        if (isWinXP) return "WinXP";
                        var isWin2003 = sUserAgent.indexOf("Windows nt 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
                        if (isWin2003) return "Win2003";
                        var isWinVista = sUserAgent.indexOf("Windows nt 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
                        if (isWinVista) return "WinVista";
                        var isWin7 = sUserAgent.indexOf("Windows nt 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
                        if (isWin7) return "Win7";
                        var isWin8 = sUserAgent.indexOf("windows nt 6.2") > -1 || sUserAgent.indexOf("Windows 8") > -1;
                        if (isWin8) return "Win8";
                        var isWin10 = sUserAgent.indexOf("windows nt 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1;
                        if (isWin10) return "Win10";
                    }
                    return "其他";
                },
                getDigits: function getDigits() {
                    //判断当前操作系统的版本号 
                    var sUserAgent = navigator.userAgent.toLowerCase();
                    var is64 = sUserAgent.indexOf("win64") > -1 || sUserAgent.indexOf("wow64") > -1;
                    if (is64) {
                        return "64位";
                    } else {
                        return "32位";
                    }
                },
                getBrowser: function getBrowser() {
                    // 获取浏览器名
                    var rMsie = /(msie\s|trident\/7)([\w\.]+)/;
                    var rTrident = /(trident)\/([\w.]+)/;
                    var rEdge = /(chrome)\/([\w.]+)/; //IE

                    var rFirefox = /(firefox)\/([\w.]+)/; //火狐
                    var rOpera = /(opera).+version\/([\w.]+)/; //旧Opera
                    var rNewOpera = /(opr)\/(.+)/; //新Opera 基于谷歌
                    var rChrome = /(chrome)\/([\w.]+)/; //谷歌 
                    var rUC = /(chrome)\/([\w.]+)/; //UC
                    var rMaxthon = /(chrome)\/([\w.]+)/; //遨游
                    var r2345 = /(chrome)\/([\w.]+)/; //2345
                    var rQQ = /(chrome)\/([\w.]+)/; //QQ
                    //var rMetasr =  /(metasr)\/([\w.]+)/;//搜狗
                    var rSafari = /version\/([\w.]+).*(safari)/;

                    var ua = navigator.userAgent.toLowerCase();

                    var matchBS, matchBS2;

                    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                        return {
                            browser: "微信浏览器",
                            version: "微信版本" + ua.match(/MicroMessenger\/([\d\.]+)/i)[1]
                        };
                    }
                    //IE 低版
                    matchBS = rMsie.exec(ua);
                    if (matchBS != null) {
                        matchBS2 = rTrident.exec(ua);
                        if (matchBS2 != null) {
                            switch (matchBS2[2]) {
                                case "4.0":
                                    return {
                                        browser: "Microsoft IE",
                                        version: "IE: 8" //内核版本号
                                    };
                                    break;
                                case "5.0":
                                    return {
                                        browser: "Microsoft IE",
                                        version: "IE: 9"
                                    };
                                    break;
                                case "6.0":
                                    return {
                                        browser: "Microsoft IE",
                                        version: "IE: 10"
                                    };
                                    break;
                                case "7.0":
                                    return {
                                        browser: "Microsoft IE",
                                        version: "IE: 11"
                                    };
                                    break;
                                default:
                                    return {
                                        browser: "Microsoft IE",
                                        version: "Undefined"
                                    };
                            }
                        } else {
                            return {
                                browser: "Microsoft IE",
                                version: "IE:" + matchBS[2] || "0"
                            };
                        }
                    }
                    //IE最新版
                    matchBS = rEdge.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "Microsoft Edge",
                            version: "Chrome/" + matchBS[2] || "0"
                        };
                    }
                    //UC浏览器					  
                    matchBS = rUC.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "UC",
                            version: "Chrome/" + matchBS[2] || "0"
                        };
                    }
                    //火狐浏览器
                    matchBS = rFirefox.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "火狐",
                            version: "Firefox/" + matchBS[2] || "0"
                        };
                    }
                    //Oper浏览器					 
                    matchBS = rOpera.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "Opera",
                            version: "Chrome/" + matchBS[2] || "0"
                        };
                    }
                    //遨游
                    matchBS = rMaxthon.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "遨游",
                            version: "Chrome/" + matchBS[2] || "0"
                        };
                    }
                    //2345浏览器					  
                    matchBS = r2345.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "2345",
                            version: "Chrome/ " + matchBS[2] || "0"
                        };
                    }
                    //QQ浏览器					  
                    matchBS = rQQ.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        return {
                            browser: "QQ",
                            version: "Chrome/" + matchBS[2] || "0"
                        };
                    }
                    //Safari（苹果）浏览器
                    matchBS = rSafari.exec(ua);
                    if (matchBS != null && !window.attachEvent && !window.chrome && !window.opera) {
                        return {
                            browser: "Safari",
                            version: "Safari/" + matchBS[1] || "0"
                        };
                    }

                    //谷歌浏览器
                    matchBS = rChrome.exec(ua);
                    if (matchBS != null && !window.attachEvent) {
                        matchBS2 = rNewOpera.exec(ua);
                        if (matchBS2 == null) {
                            return {
                                browser: "谷歌",
                                version: "Chrome/" + matchBS[2] || "0"
                            };
                        } else {
                            return {
                                browser: "Opera",
                                version: "opr/" + matchBS2[2] || "0"
                            };
                        }
                    }
                }
            };
            BrowserMatch.init();
            hashmap.set('browserTypeVersion', BrowserMatch.version);
            hashmap.set('systemVersion', BrowserMatch.OS);
            console.log("当前浏览器为：" + BrowserMatch.browser + "\n版本为：" + BrowserMatch.version + "\n所处操作系统为：" + BrowserMatch.OS);
        }
    },
    routerJump: {
        returnUrl: function returnUrl(code) {
            var params = {
                url: '',
                title: '',
                message: '',
                code: '',
                showbutton: [] // 1 返回汇丰 2.重新认证 3.立即登录  4 重试  5返回 6 立即注册
            };
            switch (code) {
                case "0001":
                    params.url = 'index';
                    break;
                case "0002":
                    params.url = 'questionnaire';
                    break;
                case "0003":
                    params.url = 'additionalMaterials';
                    break;
                case "0004":
                    // 四要素
                    params.url = 'stepDescription';
                    break;
                case "0043":
                    params.url = 'reVerified';
                    break;
                case "0041":
                    //007_3 请勿重复提交
                    params.url = 'cupLoginTip';
                    break;
                case "0005":
                    params.url = 'loanChannel';
                    break;
                case "0006":
                    params.url = 'peopleVerification';
                    break;
                case "0007":
                    params.url = 'loanConfirmation';
                    break;
                case "0008":
                    params.url = 'login';
                    break;
                case "0009":
                    params.url = 'loanLoops';
                    break;
                case "0010":
                    params.url = 'loanPurpose';
                    break;
                case "0011":
                    params.url = 'acceptLoan';
                    break;
                case "0012":
                    params.url = 'entityKYC';
                    break;
                case "0013":
                    params.url = 'loanLoops';
                    break;
                case "0015":
                    params.url = 'loanPurpose';
                    break;
                case "0016":
                    params.url = 'stepDescription';
                    break;
                case "0017":
                    params.url = 'loanPaymentType';
                    break;
                case "0018":
                    params.url = 'linkPeople';
                    break;
                case "0019":
                    params.url = 'informationConfirmed';
                    break;
                case "0020":
                    //007_1 后台返回 四要素信息不匹配
                    params.url = 'corpLegalFail';
                    break;
                // case "0022"://007_1 后台返回 四要素信息不匹配
                //     params.url = 'feedBack';
                //     params.title = '非常抱歉！';
                //     params.message = '关联人不存在！';
                //     break;
                case "0023":
                    //问卷调查不符合规则 003_2
                    params.url = 'feedBack';
                    params.title = '非常抱歉！';
                    params.message = '感谢您选择汇丰中国。很抱歉，您暂未符合个人经营性贷款申请条件，如需了解其他产品和服务，请致电汇丰汇融客户服务热线400-820-1177。 ';
                    params.code = code;
                    break;
                case "0024":
                    //005
                    params.url = 'authorizationResult';
                    params.title = '税务信息授权成功';
                    params.message = '请点按下一步继续进行申请。';
                    params.code = code;
                    break;
                case "0040":
                    //005_3 有手机尾号返回
                    params.url = 'authorizationResult';
                    params.title = '税务信息授权成功';
                    params.message = '';
                    params.code = code;
                    break;
                case "0025":
                    //005_2
                    params.url = 'authorizationResult';
                    params.title = '税务信息授权失败';
                    params.message = '您可选择再次授权或返回个人经营性贷款平台首页';
                    params.code = code;
                    break;
                case "0026":
                    //通用网络连接超时
                    params.url = 'feedBack';
                    params.title = '网络连接超时！';
                    params.message = '网络连接超时，请稍后再试。';
                    params.code = code;
                    params.showbutton = ['4'];
                    break;
                case "0028":
                    //015  036
                    params.url = 'editAgain';
                    break;
                case "0029":
                    //015  036
                    params.url = 'acceptLoan';
                    break;
                case "0030":
                    //登录后 审批拒绝 034 043 023 040_1 040
                    params.url = 'approvalRefuse';

                    break;
                case "0031":
                    //015  036
                    params.url = 'feedBack';
                    params.title = '提交审核中';
                    params.message = '我们已经收到并正在审核您提交的前述信息，审查结果将以短信形式告知，请注意查收。如审查通过，请登录本平台继续贷款申请流程。';
                    params.code = code;
                    params.showbutton = ['1'];
                    break;

                case "0032":
                    //选择放弃原因 放弃申请 024
                    params.url = 'feedBack';
                    params.title = '申请已关闭';
                    // params.message = '抱歉，您已放弃申请。感谢您对汇丰小企业银行服务的关注和支持。如需了解其他产品和服务，请致电汇丰汇融客户服务热线400-820-1177或访问汇丰汇融官网https://www.hsbc.com.cn/fusion/。如果您想退出申请流程，请直接关闭当前浏览器页面；如果您想再次申请，请点击“重新申请”，您将回到首页重新开始申请流程。';
                    params.message = '抱歉，您已放弃申请。感谢您对汇丰小企业银行服务的关注和支持。如需了解其他产品和服务，请致电汇丰汇融客户服务热线400-820-1177或访问汇丰汇融官网https://www.hsbc.com.cn/fusion/。如果您想退出申请流程，请直接关闭当前浏览器页面。';
                    // params.showbutton = ['8'];
                    break;
                case "0033":
                    // kyc未填写 offer未接收 贷款未提交 银行流水未上传 035
                    params.url = 'feedBack';
                    params.title = '申请已关闭';
                    params.message = '抱歉，由于您的贷款申请已超时，我们已为您自动取消此申请。如您对汇丰银行个人经营性贷款感兴趣，请点击下方“重新申请”再次提交申请。';
                    params.code = code;
                    params.showbutton = ['7'];
                    break;
                case "0042":
                    // 微众税银没有拿到结果超时 022
                    params.url = 'feedBack';
                    params.title = '申请已关闭';
                    params.message = '抱歉，由于您的贷款申请已超时，我们已为您自动取消此次申请。如您对汇丰银行个人经营性贷款感兴趣，请点击下方“重新申请”再次提交申请。';
                    params.code = code;
                    params.showbutton = ['7'];
                    break;
                case "0034":
                    //027
                    params.url = 'feedBack';
                    params.title = '尚未注册';
                    params.message = '请完成注册后继续预申请。';
                    params.code = code;
                    params.showbutton = ['6'];
                    break;
                case "0035":
                    //007_4 etb 四要素认证返回 不满足申请条件
                    params.url = 'feedBack';
                    params.title = '抱歉，您尚未满足申请条件';
                    params.message = '感谢您对汇丰村镇银行服务的关注和支持。如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/';
                    params.code = code;
                    params.showbutton = ['1'];
                    break;
                case "0037":
                    //0037 etb 认证失败
                    params.url = 'feedBack';
                    params.title = '抱歉，您未能完成个人身份验证及征信信息查询授权。';
                    params.messages = '请重试或告知借款申请人相关情况，我们的客户经理将与您或借款申请人联系。';
                    params.message = '感谢您对汇丰村镇银行服务的关注和支持。如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/';
                    params.code = code;
                    params.showbutton = ['1'];
                    break;
                case "0036":
                    //企业信息认证达到上限
                    params.url = 'feedBack';
                    params.title = '抱歉，企业信息认证已达上限!';
                    params.message = '当天认证已达上限，请您24小时后重试。';
                    params.code = code;
                    params.showbutton = ['1'];
                    break;
                case "0039":
                    //登录失效
                    params.url = 'feedBack';
                    params.title = '登录失效!';
                    params.message = '当前登录失效，请重新登录';
                    params.code = code;
                    params.showbutton = ['3'];
                    break;
                case "0044":
                    //pcwk 已登录
                    params.url = 'feedBack';
                    params.title = '申请已关闭!';
                    params.message = '抱歉，您存在未完成的其他产品贷款申请。感谢您对汇丰小企业银行服务的关注和支持。如需了解，请致电汇丰汇融客户服务热线400-820-1177或访问汇丰汇融官网https://www.hsbc.com.cn/fusion/。如果您想退出申请流程，请直接关闭当前浏览器页面。';
                    params.code = code;
                    break;
                case "0045":
                    // 
                    params.url = 'feedBack';
                    params.title = '重新登录!';
                    params.message = '请由商户指定链接重新登录继续您的申请！';
                    params.code = code;
                    break;
                case "0046":
                    // 
                    params.url = 'feedBack';
                    params.title = '重新登录!';
                    params.message = '抱歉，您存在未完成的贷款申请。请重新登录！';
                    params.code = code;
                    params.showbutton = ['3'];
                    break;
                case "0047":
                    // 
                    params.url = 'complete';
                    break;
                case "0048":
                    // 
                    params.url = 'feedBack';
                    params.title = '重新登录!';
                    params.message = '抱歉，您存在未完成的贷款申请。请重新登录！';
                    params.code = code;
                    params.showbutton = ['3'];
                    break;
            }
            return params;
        }
    }
};


// EXTERNAL MODULE: ./src/assets/api/bank.json
var bank = __webpack_require__("887/");
var bank_default = /*#__PURE__*/__webpack_require__.n(bank);

// EXTERNAL MODULE: ./src/assets/api/text.json
var api_text = __webpack_require__("oyZ0");
var text_default = /*#__PURE__*/__webpack_require__.n(api_text);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_alert = ({
    components: {},
    directives: {
        focus: {
            componentUpdated: function componentUpdated(el) {
                el.focus();
                // console.log(document.activeElement)
            }
        }
    },
    data: function data() {
        return {
            isAnimate: false,
            isAlertShow: false,
            isLoanChannel: false,
            prevBodyStyle_scrollTop: '',
            prevBodyStyle_top: '',
            prevBodyStyle_position: '',
            prevBodyStyle_width: ''

        };
    },


    methods: {
        showAlert: function showAlert() {
            this.isAlertShow = true;
            this.isAnimate = true;
            this.beforeMount(); //弹出框之后页面不可滚动
        },
        closeAlert: function closeAlert() {
            this.isAnimate = false;
            this.isAlertShow = false;
            this.beforeDestroy(); //页面可以滚动
        },
        sureAlert: function sureAlert(callb) {
            var callback = callb;
            if (callback && typeof callback == 'function') {
                callback();
            }
        },
        beforeMount: function beforeMount() {
            // 获取原来的scrollTop 并将body的top修改为对应的值
            this.prevBodyStyle_scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            this.prevBodyStyle_top = window.getComputedStyle(document.body, null).getPropertyValue('top');
            document.body.style.top = '-' + this.prevBodyStyle_scrollTop + 'px';
            // 获取原来body的position 为了解决iOS上光标漂移的问题 将position修改为fixed
            this.prevBodyStyle_position = window.getComputedStyle(document.body, null).getPropertyValue('position');
            document.body.style.position = 'fixed';
            // 为了避免width空值的情况
            this.prevBodyStyle_width = window.getComputedStyle(document.body, null).getPropertyValue('width');
            document.body.style.width = '100%';
        },
        beforeDestroy: function beforeDestroy() {
            document.body.style.top = this.prevBodyStyle_top || '0px';
            document.body.style.position = this.prevBodyStyle_position;
            document.body.style.width = this.prevBodyStyle_width || '100%';
            document.body.scrollTop = document.documentElement.scrollTop = this.prevBodyStyle_scrollTop || 0;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_components_alert = ({
    components: {},
    directives: {
        focus: {
            componentUpdated: function componentUpdated(el) {
                el.focus();
                // console.log(document.activeElement)
            }
        }
    },
    data: function data() {
        return {
            isAnimate: false,
            isAlertShow: false,
            isLoanChannel: false,
            prevBodyStyle_scrollTop: '',
            prevBodyStyle_top: '',
            prevBodyStyle_position: '',
            prevBodyStyle_width: ''

        };
    },


    methods: {
        showAlert: function showAlert() {
            this.isAlertShow = true;
            this.isAnimate = true;
            this.beforeMount(); //弹出框之后页面不可滚动
        },
        closeAlert: function closeAlert() {
            this.isAnimate = false;
            this.isAlertShow = false;
            this.beforeDestroy(); //页面可以滚动
        },
        sureAlert: function sureAlert(callb) {
            var callback = callb;
            if (callback && typeof callback == 'function') {
                callback();
            }
        },
        beforeMount: function beforeMount() {
            // 获取原来的scrollTop 并将body的top修改为对应的值
            this.prevBodyStyle_scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            this.prevBodyStyle_top = window.getComputedStyle(document.body, null).getPropertyValue('top');
            document.body.style.top = '-' + this.prevBodyStyle_scrollTop + 'px';
            // 获取原来body的position 为了解决iOS上光标漂移的问题 将position修改为fixed
            this.prevBodyStyle_position = window.getComputedStyle(document.body, null).getPropertyValue('position');
            document.body.style.position = 'fixed';
            // 为了避免width空值的情况
            this.prevBodyStyle_width = window.getComputedStyle(document.body, null).getPropertyValue('width');
            document.body.style.width = '100%';
        },
        beforeDestroy: function beforeDestroy() {
            document.body.style.top = this.prevBodyStyle_top || '0px';
            document.body.style.position = this.prevBodyStyle_position;
            document.body.style.width = this.prevBodyStyle_width || '100%';
            document.body.scrollTop = document.documentElement.scrollTop = this.prevBodyStyle_scrollTop || 0;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b66de59","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAlertShow),expression:"isAlertShow"}],attrs:{"role":"dialog","tabindex":"0"}},[_c('div',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.isAlertShow),expression:"isAlertShow"}],staticClass:"alert_info",class:{'alert_info_animate':_vm.isAnimate,'alert_info_w': _vm.isLoanChannel}},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"alert_title"},[_vm._t("alert_title"),_vm._v(" "),_vm._t("close_icon")],2),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"alert_content"},[_vm._t("alert_content"),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})],2),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_vm._t("btn_sure"),_vm._v(" "),_c('button',{staticClass:"global-btn btn-default",attrs:{"type":"button"},on:{"click":_vm.closeAlert}},[_vm._t("btn_close")],2)],2),_vm._v(" "),_c('div',{staticClass:"global-unit-5"})]),_vm._v(" "),_c('div',{staticClass:"alert_mark_bg"})])}
var staticRenderFns = []
var esExports = { render: alert_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_alert = (esExports);
// CONCATENATED MODULE: ./src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("1izC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b66de59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_components_alert,
  selectortype_template_index_0_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_alert = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Index = ({
    components: { Alert: src_components_alert },
    data: function data() {
        return {
            data: '',
            that: this,
            isAlertShow: false,
            provinceBankJson: [],
            isAllRrquridSuccess: false,
            isBankCode: false,
            bankCode: '0',
            portalType: "",
            isProductCode: false,
            productCode: '6000', //贷款产品
            queryBankCode: '',

            stream: '', //stream
            querystream: '',
            // isstream:false, // 是否填写stream
            productList: [],
            textList: []
        };
    },
    created: function created() {
        this.provinceBankJson = bank_default.a;
        this.productListFun();
        localStorage.setItem('productCode', this.productCode);
        this.textList = text_default.a[0]; // 默认值 6000
    },
    mounted: function mounted() {
        var _this = this;

        var version = "2026-01-20 14:00 update";
        console.log(version);

        var arr = this.provinceBankJson;
        var newarr = arr.filter(function (item) {
            return item.bankCode !== 'HBCQ' && item.bankCode !== 'HBGD';
        });

        this.provinceBankJson = newarr;

        this.provinceBankJson.map(function (item, index) {
            if (_this.$route.query.bankCode === item.bankCode) {
                _this.queryBankCode = _this.$route.query.bankCode;
                return;
            }
            return;
        });
        this.bankCode = this.queryBankCode || "0";
        this.querystream = this.$route.query.stream;
        this.stream = this.querystream || null;
    },

    filters: {
        bankCodef: function bankCodef(val, that) {
            if (val) {
                var name = '';
                that.provinceBankJson.map(function (item, index) {
                    if (val == item.bankCode) {
                        name = item.bankName;
                    }
                });
                return name;
            } else {
                return '--';
            }
        }
    },
    methods: {
        changeProduct: function changeProduct() {
            var _this2 = this;

            localStorage.setItem('productCode', this.productCode);
            text_default.a.map(function (item, index) {
                if (_this2.productCode === item.code) {
                    _this2.textList = item;
                    return;
                }
                return;
            });
            console.log(this.textList);
        },
        productListFun: function productListFun() {
            var _this3 = this;

            var url = "/portal/" + 'prdList';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (_ref) {
                var data = _ref.data;

                if (data) {
                    _this3.productList = data.responseData.list;
                }
            });
        },
        start: function start() {
            var _this4 = this;

            index({
                productCode: this.productCode,
                portalType: this.portalType,
                bankCode: this.bankCode
            }).then(function (result) {
                if (result.responseCode == "000000") {
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    _this4.$router.push({
                        path: url
                    });
                }
            });
        },

        //开始申请
        apply: function apply(item) {
            this.isAllRrquridSuccess = false;
            // this.streamChange();
            this.bankCodeChange();
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                hashmap.set('productCode', this.productCode);
                this.$refs.isAlertShow.showAlert();
                this.data = item;
            } else {
                window.scrollTo(0, 0);
            }
        },
        closeAlertp: function closeAlertp(item) {
            this.$refs.isAlertShow.closeAlert();
            if (item == 'login') {
                this.$router.push({
                    path: "/login"
                });
            } else if (item == 'action') {
                this.portalType = "register";
                this.start();
            }
        },
        cancelInfop: function cancelInfop() {
            this.$refs.isAlertShow.closeAlert();
        },
        bankCodeChange: function bankCodeChange() {
            if (!this.bankCode || this.bankCode == '0') {
                this.isBankCode = true;
            } else {
                this.isBankCode = false;
                hashmap.set('bankCode', this.bankCode);
                if (this.stream) {
                    hashmap.set('stream', this.stream);
                }
            }
            this.isAllSuccess();
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isBankCode) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var view_Index = ({
    components: { Alert: src_components_alert },
    data: function data() {
        return {
            data: '',
            that: this,
            isAlertShow: false,
            provinceBankJson: [],
            isAllRrquridSuccess: false,
            isBankCode: false,
            bankCode: '0',
            portalType: "",
            isProductCode: false,
            productCode: '6000', //贷款产品
            queryBankCode: '',

            stream: '', //stream
            querystream: '',
            // isstream:false, // 是否填写stream
            productList: [],
            textList: []
        };
    },
    created: function created() {
        this.provinceBankJson = bank_default.a;
        this.productListFun();
        localStorage.setItem('productCode', this.productCode);
        this.textList = text_default.a[0]; // 默认值 6000
    },
    mounted: function mounted() {
        var _this = this;

        var version = "2026-01-20 14:00 update";
        console.log(version);

        var arr = this.provinceBankJson;
        var newarr = arr.filter(function (item) {
            return item.bankCode !== 'HBCQ' && item.bankCode !== 'HBGD';
        });

        this.provinceBankJson = newarr;

        this.provinceBankJson.map(function (item, index) {
            if (_this.$route.query.bankCode === item.bankCode) {
                _this.queryBankCode = _this.$route.query.bankCode;
                return;
            }
            return;
        });
        this.bankCode = this.queryBankCode || "0";
        this.querystream = this.$route.query.stream;
        this.stream = this.querystream || null;
    },

    filters: {
        bankCodef: function bankCodef(val, that) {
            if (val) {
                var name = '';
                that.provinceBankJson.map(function (item, index) {
                    if (val == item.bankCode) {
                        name = item.bankName;
                    }
                });
                return name;
            } else {
                return '--';
            }
        }
    },
    methods: {
        changeProduct: function changeProduct() {
            var _this2 = this;

            localStorage.setItem('productCode', this.productCode);
            text_default.a.map(function (item, index) {
                if (_this2.productCode === item.code) {
                    _this2.textList = item;
                    return;
                }
                return;
            });
            console.log(this.textList);
        },
        productListFun: function productListFun() {
            var _this3 = this;

            var url = "/portal/" + 'prdList';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (_ref) {
                var data = _ref.data;

                if (data) {
                    _this3.productList = data.responseData.list;
                }
            });
        },
        start: function start() {
            var _this4 = this;

            index({
                productCode: this.productCode,
                portalType: this.portalType,
                bankCode: this.bankCode
            }).then(function (result) {
                if (result.responseCode == "000000") {
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    _this4.$router.push({
                        path: url
                    });
                }
            });
        },

        //开始申请
        apply: function apply(item) {
            this.isAllRrquridSuccess = false;
            // this.streamChange();
            this.bankCodeChange();
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                hashmap.set('productCode', this.productCode);
                this.$refs.isAlertShow.showAlert();
                this.data = item;
            } else {
                window.scrollTo(0, 0);
            }
        },
        closeAlertp: function closeAlertp(item) {
            this.$refs.isAlertShow.closeAlert();
            if (item == 'login') {
                this.$router.push({
                    path: "/login"
                });
            } else if (item == 'action') {
                this.portalType = "register";
                this.start();
            }
        },
        cancelInfop: function cancelInfop() {
            this.$refs.isAlertShow.closeAlert();
        },
        bankCodeChange: function bankCodeChange() {
            if (!this.bankCode || this.bankCode == '0') {
                this.isBankCode = true;
            } else {
                this.isBankCode = false;
                hashmap.set('bankCode', this.bankCode);
                if (this.stream) {
                    hashmap.set('stream', this.stream);
                }
            }
            this.isAllSuccess();
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isBankCode) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56a2d18c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Index.vue
var Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-wrap"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBankCode),expression:"isBankCode"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBankCode"}},[_vm._v("请选择您所在地的汇丰村镇银行！")])])])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"isBankCode"}},[_vm._v("选择借款申请主体所在地的汇丰村镇银行")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"isBankCode"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bankCode),expression:"bankCode"}],attrs:{"id":"isBankCode","aria-describedby":"HelpText1","placeholder":"全部"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.bankCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.bankCodeChange]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("请选择")]),_vm._v(" "),_vm._l((_vm.provinceBankJson),function(item,index){return _c('option',{key:index,attrs:{"label":item.bankName},domProps:{"value":item.bankCode}},[_vm._v(_vm._s(item.bankName))])})],2),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBankCode),expression:"isBankCode"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择您所在地的汇丰村镇银行！")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"point"},[_vm._v("注意：请核对您的选择与借款申请主体所在地的汇丰村镇银行一致。注册/登录后，您的选择将无法修改。本平台中所提及的“汇丰村镇银行”代指您以上选择的汇丰村镇银行。")]),_vm._v(" "),_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"isProductCode"}}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"regConuntry"}},[_vm._v("申请的贷款产品：")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin",class:{'global-select-error':_vm.isProductCode}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.productCode),expression:"productCode"}],attrs:{"id":"regConuntry","placeholder":"全部","aria-invalid":"true","aria-describedby":"HelpText0"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.productCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeProduct]}},_vm._l((_vm.productList),function(item,index){return _c('option',{key:index,attrs:{"label":item.productName},domProps:{"value":item.productCode}},[_vm._v(_vm._s(item.productName))])}),0),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProductCode),expression:"isProductCode"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText0","aria-label":"错误提示，请选择企业主要业务所在国家/地区！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择企业主要业务所在国家/地区！")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),(_vm.productCode == '6000')?_c('div',{staticClass:"global-unit-5"}):_vm._e(),_vm._v(" "),(_vm.productCode == '6000')?_c('div',{staticClass:"global-feedback-desc"},[_vm._v("预申请过程中需提供您的身份证号、带有银联标志的境内银行卡号以及与银行卡绑定的本人手机号等信息以完成身份验证。请提前准备。")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"index-btn-tip"},[_vm._v("初次预申请，请点击“开始预申请”")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"index-btn-margin"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.apply('action')}}},[_vm._v("开始预申请")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"index-btn-tip"},[_vm._v("提取/继续上一次的预申请，请点击“登录”")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"index-btn-margin"},[_c('button',{staticClass:"global-btn btn-default f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.apply('login')}}},[_vm._v("登录")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"}),_vm._v(" "),_c('alert',{ref:"isAlertShow"},[_c('h2',{attrs:{"slot":"alert_title"},slot:"alert_title"},[_vm._v("确认信息")]),_vm._v(" "),_c('div',{attrs:{"slot":"close_icon"},slot:"close_icon"},[_c('button',{staticClass:"close-icon",attrs:{"type":"button","aria-label":"关闭按钮","title":"关闭"},on:{"click":_vm.cancelInfop}},[_c('img',{attrs:{"src":__webpack_require__("mq5u"),"alt":""}})])]),_vm._v(" "),_c('div',{attrs:{"slot":"alert_content"},slot:"alert_content"},[(_vm.productCode == '7000')?_c('div',[_vm._v("\n                您/贵司已选择在"+_vm._s(_vm._f("bankCodef")(_vm.bankCode,_vm.that))+"申请"+_vm._s(_vm.textList.protitle2)+"\n            ")]):_c('div',[_vm._v("\n                您已选择在"+_vm._s(_vm._f("bankCodef")(_vm.bankCode,_vm.that))+"申请"+_vm._s(_vm.textList.protitle2)+"\n            ")])]),_vm._v(" "),_c('div',{attrs:{"slot":"btn_sure"},slot:"btn_sure"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeAlertp(_vm.data)}}},[_vm._v("确认")])]),_vm._v(" "),_c('div',{attrs:{"slot":"btn_close"},on:{"click":_vm.cancelInfop},slot:"btn_close"},[_vm._v("重新选择")])])],1)}
var Index_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-title-wrap"},[_c('h1',{staticClass:"title"},[_vm._v("欢迎进入汇丰村镇银行贷款在线预申请平台")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("为“三农”及广大个人和企业客户提供量身定制的贷款产品，助力客户发展事业，事半功倍")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])}]
var Index_esExports = { render: Index_render, staticRenderFns: Index_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_Index = (Index_esExports);
// CONCATENATED MODULE: ./src/view/Index.vue
function Index_injectStyle (ssrContext) {
  __webpack_require__("2MJW")
}
var Index_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Index___vue_template_functional__ = false
/* styles */
var Index___vue_styles__ = Index_injectStyle
/* scopeId */
var Index___vue_scopeId__ = "data-v-56a2d18c"
/* moduleIdentifier (server only) */
var Index___vue_module_identifier__ = null
var Index_Component = Index_normalizeComponent(
  view_Index,
  selectortype_template_index_0_src_view_Index,
  Index___vue_template_functional__,
  Index___vue_styles__,
  Index___vue_scopeId__,
  Index___vue_module_identifier__
)

/* harmony default export */ var src_view_Index = (Index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/feedBack.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var feedBack = ({
    data: function data() {
        return {
            hintText: '',
            lend: '', //01定期贷款 02 循环贷款
            fbCode: "",
            title: '',
            hintContent: '',
            showButton: null,
            buttonShowId: {
                index: false,
                anginAC: false,
                login: false,
                angin: false,
                back: false,
                regiest: false,
                reApply: false,
                closeInfo: false
            }
        };
    },
    mounted: function mounted() {
        var fbCode = this.$route.query.code;
        this.fbCode = fbCode;
        var routerParams = utils.routerJump.returnUrl(fbCode);
        this.title = routerParams.title;
        this.hintText = routerParams.messages;
        this.hintContent = routerParams.message;
        this.showButton = routerParams.showbutton;
        this.setButton();
    },

    methods: {
        setButton: function setButton() {
            for (var i in this.showButton) {
                switch (this.showButton[i]) {
                    case "1":
                        this.buttonShowId.index = true;
                        break;
                    case "2":
                        this.buttonShowId.anginAC = true;
                        break;
                    case "3":
                        this.buttonShowId.login = true;
                        break;
                    case "4":
                        this.buttonShowId.angin = true;
                        break;
                    case "5":
                        this.buttonShowId.back = true;
                        break;
                    case "6":
                        this.buttonShowId.regiest = true;
                        break;
                    case "7":
                        this.buttonShowId.reApply = true;
                        break;
                    case "8":
                        this.buttonShowId.closeInfo = true;
                        break;
                }
            }
        },
        gotoPage: function gotoPage(val) {
            var url = '';
            switch (val) {
                case "1":
                    url = 'index';
                    break;
                case "2":
                    url = 'stepDescription';
                    break;
                case "3":
                    url = 'login';
                    break;
                case "4":
                    url = '-1';
                    break;
                case "5":
                    url = '-1';
                    break;
                case "6":
                    url = 'index';
                    break;
                case "7":
                    url = '/questionnaire';
                    break;
                case "8":
                    // 关闭浏览器窗口
                    if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                        window.location.href = "about:blank";
                    } else {
                        window.opener = null;
                        window.open("about:blank", "_self");
                        window.close();
                    }
                    break;
            }

            if (url == '') {
                return false;
            }
            if (url == '-1') {
                this.$router.go(-1);return false;
            }
            this.$router.push({
                path: url
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/feedBack.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var view_feedBack = ({
    data: function data() {
        return {
            hintText: '',
            lend: '', //01定期贷款 02 循环贷款
            fbCode: "",
            title: '',
            hintContent: '',
            showButton: null,
            buttonShowId: {
                index: false,
                anginAC: false,
                login: false,
                angin: false,
                back: false,
                regiest: false,
                reApply: false,
                closeInfo: false
            }
        };
    },
    mounted: function mounted() {
        var fbCode = this.$route.query.code;
        this.fbCode = fbCode;
        var routerParams = utils.routerJump.returnUrl(fbCode);
        this.title = routerParams.title;
        this.hintText = routerParams.messages;
        this.hintContent = routerParams.message;
        this.showButton = routerParams.showbutton;
        this.setButton();
    },

    methods: {
        setButton: function setButton() {
            for (var i in this.showButton) {
                switch (this.showButton[i]) {
                    case "1":
                        this.buttonShowId.index = true;
                        break;
                    case "2":
                        this.buttonShowId.anginAC = true;
                        break;
                    case "3":
                        this.buttonShowId.login = true;
                        break;
                    case "4":
                        this.buttonShowId.angin = true;
                        break;
                    case "5":
                        this.buttonShowId.back = true;
                        break;
                    case "6":
                        this.buttonShowId.regiest = true;
                        break;
                    case "7":
                        this.buttonShowId.reApply = true;
                        break;
                    case "8":
                        this.buttonShowId.closeInfo = true;
                        break;
                }
            }
        },
        gotoPage: function gotoPage(val) {
            var url = '';
            switch (val) {
                case "1":
                    url = 'index';
                    break;
                case "2":
                    url = 'stepDescription';
                    break;
                case "3":
                    url = 'login';
                    break;
                case "4":
                    url = '-1';
                    break;
                case "5":
                    url = '-1';
                    break;
                case "6":
                    url = 'index';
                    break;
                case "7":
                    url = '/questionnaire';
                    break;
                case "8":
                    // 关闭浏览器窗口
                    if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                        window.location.href = "about:blank";
                    } else {
                        window.opener = null;
                        window.open("about:blank", "_self");
                        window.close();
                    }
                    break;
            }

            if (url == '') {
                return false;
            }
            if (url == '-1') {
                this.$router.go(-1);return false;
            }
            this.$router.push({
                path: url
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6a03fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/feedBack.vue
var feedBack_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-wrap"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),(_vm.hintText)?_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.hintText))]):_vm._e(),_vm._v(" "),(_vm.hintText)?_c('div',{staticClass:"global-unit-4"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.hintContent))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.reApply),expression:"buttonShowId.reApply"}],staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('7')}}},[_vm._v("\n        重新申请\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.anginAC),expression:"buttonShowId.anginAC"}],staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('2')}}},[_vm._v("\n        重新认证\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.login),expression:"buttonShowId.login"}],staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('3')}}},[_vm._v("\n        立即登录\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.angin),expression:"buttonShowId.angin"}],staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('4')}}},[_vm._v("\n        重试\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.closeInfo),expression:"buttonShowId.closeInfo"}],staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('8')}}},[_vm._v("\n        关闭\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.regiest),expression:"buttonShowId.regiest"}],staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('6')}}},[_vm._v("\n        立即注册\n    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.buttonShowId.back),expression:"buttonShowId.back"}],staticClass:"global-btn btn-back",attrs:{"type":"button"},on:{"click":function($event){return _vm.gotoPage('5')}}},[_vm._v("\n        返回\n    ")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var feedBack_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"aria-hidden":"true","alt":"错误图标","src":__webpack_require__("FPiP")}})])}]
var feedBack_esExports = { render: feedBack_render, staticRenderFns: feedBack_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_feedBack = (feedBack_esExports);
// CONCATENATED MODULE: ./src/view/feedBack.vue
function feedBack_injectStyle (ssrContext) {
  __webpack_require__("09GF")
}
var feedBack_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var feedBack___vue_template_functional__ = false
/* styles */
var feedBack___vue_styles__ = feedBack_injectStyle
/* scopeId */
var feedBack___vue_scopeId__ = "data-v-2e6a03fc"
/* moduleIdentifier (server only) */
var feedBack___vue_module_identifier__ = null
var feedBack_Component = feedBack_normalizeComponent(
  view_feedBack,
  selectortype_template_index_0_src_view_feedBack,
  feedBack___vue_template_functional__,
  feedBack___vue_styles__,
  feedBack___vue_scopeId__,
  feedBack___vue_module_identifier__
)

/* harmony default export */ var src_view_feedBack = (feedBack_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vue-qr/src/main.js
var main = __webpack_require__("X2mQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/acceptLoan.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var acceptLoan = ({
    data: function data() {
        return defineProperty_default()({
            config: {
                value: ''
            },
            productCode: "",
            textList: []
        }, 'productCode', localStorage.getItem('productCode'));
    },
    mounted: function mounted() {
        var _this = this;

        // process.env.BASE_URL
        text_default.a.map(function (item, index) {
            if (_this.productCode === item.code) {
                _this.textList = item;
                return;
            }
            return;
        });
        this.config.value = window.location.origin + '/#/certified?loanOrderCode=' + this.$route.query.loanOrderCode;
        if (this.productCode == '6000') {
            var a = document.getElementById('qrUrl').getElementsByTagName("img");
            a[0].alt = this.config.value;
        }
    },

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        },
        copyQrUrl: function copyQrUrl() {
            var input = document.getElementById('textarea');
            input.value = this.config.value;
            input.select();
            document.execCommand("Copy");
            document.getElementById('showTips').style.display = 'block';
            setTimeout(function () {
                document.getElementById('showTips').style.display = 'none';
            }, 2000);
        }
    },
    components: {
        VueQr: main["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/acceptLoan.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var view_acceptLoan = ({
    data: function data() {
        return defineProperty_default()({
            config: {
                value: ''
            },
            productCode: "",
            textList: []
        }, 'productCode', localStorage.getItem('productCode'));
    },
    mounted: function mounted() {
        var _this = this;

        // process.env.BASE_URL
        text_default.a.map(function (item, index) {
            if (_this.productCode === item.code) {
                _this.textList = item;
                return;
            }
            return;
        });
        this.config.value = window.location.origin + '/#/certified?loanOrderCode=' + this.$route.query.loanOrderCode;
        if (this.productCode == '6000') {
            var a = document.getElementById('qrUrl').getElementsByTagName("img");
            a[0].alt = this.config.value;
        }
    },

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        },
        copyQrUrl: function copyQrUrl() {
            var input = document.getElementById('textarea');
            input.value = this.config.value;
            input.select();
            document.execCommand("Copy");
            document.getElementById('showTips').style.display = 'block';
            setTimeout(function () {
                document.getElementById('showTips').style.display = 'none';
            }, 2000);
        }
    },
    components: {
        VueQr: main["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48263909","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/acceptLoan.vue
var acceptLoan_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-wrap"},[_c('div',{staticClass:"global-title-wrap",attrs:{"role":"region"}},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.textList.acceptloan_h1))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),(_vm.productCode === '6000')?_c('div',[_vm._v(_vm._s(_vm.textList.acceptloan_next))]):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('div',[_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"redFont"},[_vm._v("长按保存下方二维码")]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"qrbox"},[_c('vue-qr',{staticClass:"qr-code-pic",attrs:{"tabindex":"0","id":"qrUrl","text":_vm.config.value,"size":230,"correctLevel":4,"margin":10}}),_vm._v(" "),_c('textarea',{staticClass:"qrText",attrs:{"tabindex":"-1","name":"","id":"textarea","readonly":""}})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"copySrc",on:{"click":_vm.copyQrUrl}},[_c('img',{staticClass:"pictureTips",attrs:{"aria-hidden":"false","src":__webpack_require__("rjgy"),"alt":"点击此处复制链接"}}),_vm._v("点击此处复制链接")])]):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-unit-6"}):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-requrid-tip"},[_vm._v("\n            注意：预申请结果将根据您提交的信息综合评估得出，仅供参考。您是否具备办理相关贷款业务的条件及贷款业务的具体安排须以您正式提出贷款申请后银行的最终审核结果为准。\n            "),_c('br'),_vm._v("通过扫描上述二维码或打开复制链接，将显示您此次贷款申请的信息，供其他贷款义务人或相关人士身份验证及征信信息查询授权之用途。请注意，二维码包含个人信息，请勿随意向无关人士提供上述二维码或链接。\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"index-tip"},[_vm._v("\n            "+_vm._s(_vm.textList.acceptloan_tip1)+"\n        ")]),_vm._v(" "),(_vm.productCode == '6000')?_c('div',[_vm._v("\n            "+_vm._s(_vm.textList.acceptloan_tip2)+"\n        ")]):_c('div',[_vm._v("\n            如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理或访问汇丰村镇银行官网"),_c('a',{staticClass:"a_href",attrs:{"href":"https://www.hsbc.com.cn/rural-bank/","target":"_blank"}},[_vm._v("https://www.hsbc.com.cn/rural-bank/")])]),_vm._v(" "),(_vm.productCode === '7000')?_c('div',[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var acceptLoan_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"aria-hidden":"true","alt":"成功图标","src":__webpack_require__("4N50")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-alert-tips",attrs:{"id":"showTips"}},[_c('p',[_vm._v("复制成功")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-requrid-tip"},[_vm._v("\n                注意：预申请结果将根据贵司提交的信息综合评估得出，仅供参考。"),_c('b',[_vm._v("贵司是否具备办理相关贷款业务的条件及贷款业务的具体安排须以贵司正式提出贷款申请后银行的最终审核结果为准。")])])}]
var acceptLoan_esExports = { render: acceptLoan_render, staticRenderFns: acceptLoan_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_acceptLoan = (acceptLoan_esExports);
// CONCATENATED MODULE: ./src/view/acceptLoan.vue
function acceptLoan_injectStyle (ssrContext) {
  __webpack_require__("FfCt")
}
var acceptLoan_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var acceptLoan___vue_template_functional__ = false
/* styles */
var acceptLoan___vue_styles__ = acceptLoan_injectStyle
/* scopeId */
var acceptLoan___vue_scopeId__ = "data-v-48263909"
/* moduleIdentifier (server only) */
var acceptLoan___vue_module_identifier__ = null
var acceptLoan_Component = acceptLoan_normalizeComponent(
  view_acceptLoan,
  selectortype_template_index_0_src_view_acceptLoan,
  acceptLoan___vue_template_functional__,
  acceptLoan___vue_styles__,
  acceptLoan___vue_scopeId__,
  acceptLoan___vue_module_identifier__
)

/* harmony default export */ var src_view_acceptLoan = (acceptLoan_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/informationConfirmed.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var informationConfirmed = ({
    data: function data() {
        return {
            linkPeopleList: [],
            fbTitle: '',
            fbMessage: '',
            editAgain: '',
            productCode: ""
        };
    },
    mounted: function mounted() {
        this.getloadRelation();
    },

    filters: {
        nullFilters: function nullFilters(value) {
            return value ? value : "--";
        },
        relationTypeFilter: function relationTypeFilter(val) {
            if (val == '1') {
                return val = '共同借款人';
            } else if (val == '2') {
                return val = '担保人';
            } else if (val == '3') {
                return val = '其他';
            } else {
                return '--';
            }
        },
        relationTypeFilter2: function relationTypeFilter2(val) {
            if (val == '4') {
                return val = '借款申请主体法定代表人';
            } else if (val == '5') {
                return val = '借款申请主体实际控制人';
            } else if (val == '6') {
                return val = '个人保证担保人';
            } else if (val == '7') {
                return val = '个人抵押担保人';
            } else if (val == '8') {
                return val = '个人保证担保人配偶';
            } else if (val == '9') {
                return val = '个人抵押担保人配偶';
            } else if (val == '10') {
                return val = '其他';
            } else {
                return '--';
            }
        },
        identityFilter: function identityFilter(val) {
            if (val == '1') {
                return val = '配偶';
            } else if (val == '2') {
                return val = '朋友';
            } else if (val == '7') {
                return val = '朋友配偶';
            } else if (val == '3') {
                return val = '亲戚';
            } else if (val == '8') {
                return val = '亲戚配偶';
            } else if (val == '4') {
                return val = '其他';
            } else if (val == '5') {
                return val = '合伙人';
            } else if (val == '6') {
                return val = '合伙人配偶';
            } else {
                return '--';
            }
        }
    },
    methods: {
        getloadRelation: function getloadRelation() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode', _this.productCode);
                }
            });
            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    _this.linkPeopleList = retsult.relationList;
                }
            });
        },

        // 确定
        updateStatus: function updateStatus() {
            var _this2 = this;

            submitOrderSuccess({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var loanOrderCode = result.responseData.loanOrderCode;
                    var fbMessage = result.responseData.fbMessage;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this2.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            loanOrderCode: loanOrderCode,
                            fbMessage: fbMessage
                        }
                    });
                }
            });
        },

        // 上一步
        testDemo: function testDemo() {
            if (this.$route.query.editAgain == 'edit') {
                this.$router.push({
                    path: "/editPerson"
                });
            } else {
                this.$router.push({
                    path: "/linkPeople"
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/informationConfirmed.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var view_informationConfirmed = ({
    data: function data() {
        return {
            linkPeopleList: [],
            fbTitle: '',
            fbMessage: '',
            editAgain: '',
            productCode: ""
        };
    },
    mounted: function mounted() {
        this.getloadRelation();
    },

    filters: {
        nullFilters: function nullFilters(value) {
            return value ? value : "--";
        },
        relationTypeFilter: function relationTypeFilter(val) {
            if (val == '1') {
                return val = '共同借款人';
            } else if (val == '2') {
                return val = '担保人';
            } else if (val == '3') {
                return val = '其他';
            } else {
                return '--';
            }
        },
        relationTypeFilter2: function relationTypeFilter2(val) {
            if (val == '4') {
                return val = '借款申请主体法定代表人';
            } else if (val == '5') {
                return val = '借款申请主体实际控制人';
            } else if (val == '6') {
                return val = '个人保证担保人';
            } else if (val == '7') {
                return val = '个人抵押担保人';
            } else if (val == '8') {
                return val = '个人保证担保人配偶';
            } else if (val == '9') {
                return val = '个人抵押担保人配偶';
            } else if (val == '10') {
                return val = '其他';
            } else {
                return '--';
            }
        },
        identityFilter: function identityFilter(val) {
            if (val == '1') {
                return val = '配偶';
            } else if (val == '2') {
                return val = '朋友';
            } else if (val == '7') {
                return val = '朋友配偶';
            } else if (val == '3') {
                return val = '亲戚';
            } else if (val == '8') {
                return val = '亲戚配偶';
            } else if (val == '4') {
                return val = '其他';
            } else if (val == '5') {
                return val = '合伙人';
            } else if (val == '6') {
                return val = '合伙人配偶';
            } else {
                return '--';
            }
        }
    },
    methods: {
        getloadRelation: function getloadRelation() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode', _this.productCode);
                }
            });
            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    _this.linkPeopleList = retsult.relationList;
                }
            });
        },

        // 确定
        updateStatus: function updateStatus() {
            var _this2 = this;

            submitOrderSuccess({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var loanOrderCode = result.responseData.loanOrderCode;
                    var fbMessage = result.responseData.fbMessage;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this2.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            loanOrderCode: loanOrderCode,
                            fbMessage: fbMessage
                        }
                    });
                }
            });
        },

        // 上一步
        testDemo: function testDemo() {
            if (this.$route.query.editAgain == 'edit') {
                this.$router.push({
                    path: "/editPerson"
                });
            } else {
                this.$router.push({
                    path: "/linkPeople"
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f7b8eff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/informationConfirmed.vue
var informationConfirmed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("其他贷款义务人或相关人士信息详情")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-bgbox"},[_vm._l((_vm.linkPeopleList),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',[_vm._v("其他贷款义务人或相关人士"+_vm._s(index+1)+"：")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("其他贷款义务人或相关人士身份")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),(_vm.productCode === '6000')?_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("relationTypeFilter")(item.relationType)))]):_vm._e(),_vm._v(" "),(_vm.productCode === '7000')?_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("relationTypeFilter2")(item.relationType)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("nullFilters")(item.userName)))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),(_vm.productCode === '6000')?_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("与借款申请人关系")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("identityFilter")(item.identity)))])]):_vm._e(),_vm._v(" "),(['6', '7', '8'].indexOf(item.identity) > -1)?_c('div',{staticClass:"global-unit-4"}):_vm._e(),_vm._v(" "),((['6', '7', '8'].indexOf(item.identity) > -1) || (_vm.productCode === '7000'  &&(item.relationType == '8'|| item.relationType == '9') && item.spouseName))?_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("此其他贷款义务人或相关人士配偶姓名")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("nullFilters")(item.spouseName)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),(_vm.productCode === '6000')?_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("手机号码（选填）")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("nullFilters")(item.mobile)))])]):_vm._e(),_vm._v(" "),(index != _vm.linkPeopleList.length-1)?_c('div',{staticClass:"global-unit-4"}):_vm._e(),_vm._v(" "),(index != _vm.linkPeopleList.length-1)?_c('div',{staticClass:"global-hr"}):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})],2),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":_vm.updateStatus}},[_vm._v("确认")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-default",attrs:{"type":"button"},on:{"click":_vm.testDemo}},[_vm._v("上一步")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var informationConfirmed_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-title-wrap"},[_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("确认其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请仔细检查并确认同意以下其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])}]
var informationConfirmed_esExports = { render: informationConfirmed_render, staticRenderFns: informationConfirmed_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_informationConfirmed = (informationConfirmed_esExports);
// CONCATENATED MODULE: ./src/view/informationConfirmed.vue
function informationConfirmed_injectStyle (ssrContext) {
  __webpack_require__("uul/")
}
var informationConfirmed_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var informationConfirmed___vue_template_functional__ = false
/* styles */
var informationConfirmed___vue_styles__ = informationConfirmed_injectStyle
/* scopeId */
var informationConfirmed___vue_scopeId__ = "data-v-0f7b8eff"
/* moduleIdentifier (server only) */
var informationConfirmed___vue_module_identifier__ = null
var informationConfirmed_Component = informationConfirmed_normalizeComponent(
  view_informationConfirmed,
  selectortype_template_index_0_src_view_informationConfirmed,
  informationConfirmed___vue_template_functional__,
  informationConfirmed___vue_styles__,
  informationConfirmed___vue_scopeId__,
  informationConfirmed___vue_module_identifier__
)

/* harmony default export */ var src_view_informationConfirmed = (informationConfirmed_Component.exports);

// CONCATENATED MODULE: ./src/assets/utils/pyconst.js
var pinyin = {
    "a": "\u554A\u963F\u9515",
    "ai": "\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u8BF6\u6371\u55F3\u55CC\u5AD2\u7477\u66A7\u7839\u953F\u972D",
    "an": "\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u8C19\u57EF\u63DE\u72B4\u5EB5\u6849\u94F5\u9E4C\u9878\u9EEF",
    "ang": "\u80AE\u6602\u76CE",
    "ao": "\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u5773\u62D7\u55F7\u5662\u5C99\u5ED2\u9068\u5AAA\u9A9C\u8071\u87AF\u93CA\u9CCC\u93D6",
    "ba": "\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u8307\u83DD\u8406\u636D\u5C9C\u705E\u6777\u94AF\u7C91\u9C85\u9B43",
    "bai": "\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u859C\u63B0\u97B4",
    "ban": "\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u962A\u5742\u8C73\u94A3\u7622\u764D\u8228",
    "bang": "\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u84A1\u8783",
    "bao": "\u82DE\u80DE\u5305\u8912\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u52F9\u8446\u5B80\u5B62\u7172\u9E28\u8913\u8DB5\u9F85",
    "bo": "\u5265\u8584\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u4EB3\u8543\u5575\u997D\u6A97\u64D8\u7934\u94B9\u9E41\u7C38\u8DDB",
    "bei": "\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5B5B\u9642\u90B6\u57E4\u84D3\u5457\u602B\u6096\u789A\u9E4E\u8919\u943E",
    "ben": "\u5954\u82EF\u672C\u7B28\u755A\u574C\u951B",
    "beng": "\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u552A\u5623\u750F",
    "bi": "\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u5315\u4EF3\u4FFE\u8298\u835C\u8378\u5421\u54D4\u72F4\u5EB3\u610E\u6ED7\u6FDE\u5F3C\u59A3\u5A62\u5B16\u74A7\u8D32\u7540\u94CB\u79D5\u88E8\u7B5A\u7B85\u7BE6\u822D\u895E\u8DF8\u9AC0",
    "bian": "\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u533E\u5F01\u82C4\u5FED\u6C74\u7F0F\u7178\u782D\u78A5\u7A39\u7A86\u8759\u7B3E\u9CCA",
    "biao": "\u6807\u5F6A\u8198\u8868\u5A4A\u9AA0\u98D1\u98D9\u98DA\u706C\u9556\u9573\u762D\u88F1\u9CD4",
    "bie": "\u9CD6\u618B\u522B\u762A\u8E69\u9CD8",
    "bin": "\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u50A7\u6D5C\u7F24\u73A2\u6BA1\u8191\u9554\u9ACC\u9B13",
    "bing": "\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\u75C5\u5E76\u7980\u90B4\u6452\u7EE0\u678B\u69DF\u71F9",
    "bu": "\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u62CA\u535F\u900B\u74FF\u6661\u949A\u91AD",
    "ca": "\u64E6\u5693\u7924",
    "cai": "\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521",
    "can": "\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u9A96\u74A8\u7CB2\u9EEA",
    "cang": "\u82CD\u8231\u4ED3\u6CA7\u85CF\u4F27",
    "cao": "\u64CD\u7CD9\u69FD\u66F9\u8349\u8279\u5608\u6F15\u87AC\u825A",
    "ce": "\u5395\u7B56\u4FA7\u518C\u6D4B\u5202\u5E3B\u607B",
    "ceng": "\u5C42\u8E6D\u564C",
    "cha": "\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u7339\u9987\u6C4A\u59F9\u6748\u6942\u69CE\u6AAB\u9497\u9538\u9572\u8869",
    "chai": "\u62C6\u67F4\u8C7A\u4FAA\u8308\u7625\u867F\u9F87",
    "chan": "\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u5181\u8C04\u8C36\u8487\u5EDB\u5FCF\u6F7A\u6FB6\u5B71\u7FBC\u5A75\u5B17\u9AA3\u89C7\u7985\u9561\u88E3\u87FE\u8E94",
    "chang": "\u660C\u7316\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u4F25\u9B2F\u82CC\u83D6\u5F9C\u6005\u60DD\u960A\u5A3C\u5AE6\u6636\u6C05\u9CB3",
    "chao": "\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u600A\u7EC9\u6641\u8016",
    "che": "\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u577C\u5C6E\u7817",
    "chen": "\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u79F0\u8C0C\u62BB\u55D4\u5BB8\u741B\u6987\u809C\u80C2\u789C\u9F80",
    "cheng": "\u6491\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u57D5\u5D4A\u5FB5\u6D48\u67A8\u67FD\u6A18\u665F\u584D\u77A0\u94D6\u88CE\u86CF\u9172",
    "chi": "\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u50BA\u5880\u82AA\u830C\u640B\u53F1\u54E7\u557B\u55E4\u5F73\u996C\u6CB2\u5AB8\u6555\u80DD\u7719\u7735\u9E31\u761B\u892B\u86A9\u87AD\u7B1E\u7BEA\u8C49\u8E05\u8E1F\u9B51",
    "chong": "\u5145\u51B2\u866B\u5D07\u5BA0\u833A\u5FE1\u61A7\u94F3\u825F",
    "chou": "\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u4FE6\u5733\u5E31\u60C6\u6EB4\u59AF\u7633\u96E0\u9C8B",
    "chu": "\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\u7840\u50A8\u77D7\u6410\u89E6\u5904\u4E8D\u520D\u61B7\u7ECC\u6775\u696E\u6A17\u870D\u8E70\u9EDC",
    "chuan": "\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u63BE\u821B\u60F4\u9044\u5DDB\u6C1A\u948F\u9569\u8221",
    "chuang": "\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u6006",
    "chui": "\u5439\u708A\u6376\u9524\u5782\u9672\u68F0\u69CC",
    "chun": "\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u4FC3\u83BC\u6C8C\u80AB\u6710\u9E51\u877D",
    "chuo": "\u6233\u7EF0\u851F\u8FB6\u8F8D\u955E\u8E14\u9F8A",
    "ci": "\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u8360\u5472\u5D6F\u9E5A\u8785\u7CCD\u8D91",
    "cong": "\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u506C\u82C1\u6DD9\u9AA2\u742E\u7481\u679E",
    "cu": "\u51D1\u7C97\u918B\u7C07\u731D\u6B82\u8E59",
    "cuan": "\u8E7F\u7BE1\u7A9C\u6C46\u64BA\u6615\u7228",
    "cui": "\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u8403\u60B4\u7480\u69B1\u96B9",
    "cun": "\u6751\u5B58\u5BF8\u78CB\u5FD6\u76B4",
    "cuo": "\u64AE\u6413\u63AA\u632B\u9519\u539D\u811E\u9509\u77EC\u75E4\u9E7E\u8E49\u8E9C",
    "da": "\u642D\u8FBE\u7B54\u7629\u6253\u5927\u8037\u54D2\u55D2\u601B\u59B2\u75B8\u8921\u7B2A\u977C\u9791",
    "dai": "\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\u6020\u57ED\u7519\u5454\u5CB1\u8FE8\u902F\u9A80\u7ED0\u73B3\u9EDB",
    "dan": "\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u4EBB\u510B\u5369\u840F\u5556\u6FB9\u6A90\u6B9A\u8D55\u7708\u7605\u8043\u7BAA",
    "dang": "\u5F53\u6321\u515A\u8361\u6863\u8C20\u51FC\u83EA\u5B95\u7800\u94DB\u88C6",
    "dao": "\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u53E8\u5541\u5FC9\u6D2E\u6C18\u7118\u5FD1\u7E9B",
    "de": "\u5FB7\u5F97\u7684\u951D",
    "deng": "\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5654\u5D9D\u6225\u78F4\u956B\u7C26",
    "di": "\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u6C10\u7C74\u8BCB\u8C1B\u90B8\u577B\u839C\u837B\u5600\u5A23\u67E2\u68E3\u89CC\u7825\u78B2\u7747\u955D\u7F9D\u9AB6",
    "dian": "\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u4E36\u963D\u576B\u57DD\u5DC5\u73B7\u765C\u766B\u7C1F\u8E2E",
    "diao": "\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8F7A\u94DE\u8729\u7C9C\u8C82",
    "die": "\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\u4F5A\u57A4\u581E\u63F2\u558B\u6E2B\u8F76\u7252\u74DE\u8936\u800B\u8E40\u9CBD\u9CCE",
    "ding": "\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4EC3\u5576\u738E\u815A\u7887\u753A\u94E4\u7594\u8035\u914A",
    "dong": "\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u578C\u549A\u5CBD\u5CD2\u5902\u6C21\u80E8\u80F4\u7850\u9E2B",
    "dou": "\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u8538\u94AD\u7AA6\u7AAC\u86AA\u7BFC\u9161",
    "du": "\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u828F\u561F\u6E0E\u691F\u6A50\u724D\u8839\u7B03\u9AD1\u9EE9",
    "duan": "\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5F56\u6934\u7145\u7C16",
    "dui": "\u5806\u5151\u961F\u5BF9\u603C\u619D\u7893",
    "dun": "\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u7096\u7818\u7905\u76F9\u9566\u8DB8",
    "duo": "\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u5484\u54DA\u7F0D\u67C1\u94CE\u88F0\u8E31",
    "e": "\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u5669\u8C14\u57A9\u57AD\u82CA\u83AA\u843C\u5443\u6115\u5C59\u5A40\u8F6D\u66F7\u816D\u786A\u9507\u9537\u9E57\u989A\u9CC4",
    "en": "\u6069\u84BD\u6441\u5514\u55EF",
    "er": "\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\u8D30\u8FE9\u73E5\u94D2\u9E38\u9C95",
    "fa": "\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u57A1\u781D",
    "fan": "\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u8629\u5E61\u72AD\u68B5\u6535\u71D4\u7548\u8E6F",
    "fang": "\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u531A\u90A1\u5F77\u94AB\u822B\u9C82",
    "fei": "\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82BE\u72D2\u60B1\u6DDD\u5983\u7ECB\u7EEF\u69A7\u8153\u6590\u6249\u7953\u7829\u9544\u75F1\u871A\u7BDA\u7FE1\u970F\u9CB1",
    "fen": "\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u507E\u7035\u68FC\u610D\u9CBC\u9F22",
    "feng": "\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4FF8\u9146\u8451\u6CA3\u781C",
    "fu": "\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5310\u51EB\u90DB\u8299\u82FB\u832F\u83A9\u83D4\u544B\u5E5E\u6ECF\u8274\u5B5A\u9A78\u7EC2\u6874\u8D59\u9EFB\u9EFC\u7F58\u7A03\u99A5\u864D\u86A8\u8709\u8760\u876E\u9EB8\u8DBA\u8DD7\u9CC6",
    "ga": "\u5676\u560E\u86E4\u5C2C\u5477\u5C15\u5C1C\u65EE\u9486",
    "gai": "\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u4E10\u9654\u5793\u6224\u8D45\u80F2",
    "gan": "\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5769\u82F7\u5C34\u64C0\u6CD4\u6DE6\u6F89\u7EC0\u6A44\u65F0\u77F8\u75B3\u9150",
    "gang": "\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6206\u7F61\u9883\u7B7B",
    "gong": "\u6760\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u857B\u5EFE\u54A3\u73D9\u80B1\u86A3\u86E9\u89E5",
    "gao": "\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u777E\u8BF0\u90DC\u84BF\u85C1\u7F1F\u69D4\u69C1\u6772\u9506",
    "ge": "\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u9601\u9694\u94EC\u4E2A\u5404\u9B32\u4EE1\u54FF\u5865\u55DD\u7EA5\u643F\u8188\u784C\u94EA\u9549\u88BC\u988C\u867C\u8238\u9ABC\u9AC2",
    "gei": "\u7ED9",
    "gen": "\u6839\u8DDF\u4E98\u831B\u54CF\u826E",
    "geng": "\u8015\u66F4\u5E9A\u7FB9\u57C2\u803F\u6897\u54FD\u8D53\u9CA0",
    "gou": "\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u4F5D\u8BDF\u5CA3\u9058\u5ABE\u7F11\u89CF\u5F40\u9E32\u7B31\u7BDD\u97B2",
    "gu": "\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u560F\u8BC2\u83F0\u54CC\u5D2E\u6C69\u688F\u8F71\u726F\u727F\u80CD\u81CC\u6BC2\u77BD\u7F5F\u94B4\u9522\u74E0\u9E2A\u9E44\u75FC\u86C4\u9164\u89DA\u9CB4\u9AB0\u9E58",
    "gua": "\u522E\u74DC\u5250\u5BE1\u6302\u8902\u5366\u8BD6\u5471\u681D\u9E39",
    "guai": "\u4E56\u62D0\u602A\u54D9",
    "guan": "\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u500C\u839E\u63BC\u6DAB\u76E5\u9E73\u9CCF",
    "guang": "\u5149\u5E7F\u901B\u72B7\u6844\u80F1\u7592",
    "gui": "\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u5326\u523F\u5E8B\u5B84\u59AB\u6867\u7085\u6677\u7688\u7C0B\u9C91\u9CDC",
    "gun": "\u8F8A\u6EDA\u68CD\u4E28\u886E\u7EF2\u78D9\u9CA7",
    "guo": "\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u9998\u8803\u57DA\u63B4\u5459\u56D7\u5E3C\u5D1E\u7313\u6901\u8662\u951E\u8052\u872E\u873E\u8748",
    "ha": "\u54C8",
    "hai": "\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u54B4\u55E8\u988F\u91A2",
    "han": "\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u9097\u83E1\u6496\u961A\u701A\u6657\u7113\u9894\u86B6\u9F3E",
    "hen": "\u592F\u75D5\u5F88\u72E0\u6068",
    "hang": "\u676D\u822A\u6C86\u7ED7\u73E9\u6841",
    "hao": "\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u8585\u55E5\u5686\u6FE0\u704F\u660A\u7693\u98A2\u869D",
    "he": "\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u8BC3\u52BE\u58D1\u85FF\u55D1\u55EC\u9616\u76CD\u86B5\u7FEE",
    "hei": "\u563F\u9ED1",
    "heng": "\u54FC\u4EA8\u6A2A\u8861\u6052\u8A07\u8605",
    "hong": "\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u9EC9\u8BA7\u836D\u85A8\u95F3\u6CD3",
    "hou": "\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u5820\u5F8C\u9005\u760A\u7BCC\u7CC7\u9C8E\u9ABA",
    "hu": "\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u51B1\u553F\u56EB\u5CB5\u7322\u6019\u60DA\u6D52\u6EF9\u7425\u69F2\u8F77\u89F3\u70C0\u7173\u623D\u6248\u795C\u9E55\u9E71\u7B0F\u9190\u659B",
    "hua": "\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u5290\u6D4D\u9A85\u6866\u94E7\u7A1E",
    "huai": "\u69D0\u5F8A\u6000\u6DEE\u574F\u8FD8\u8E1D",
    "huan": "\u6B22\u73AF\u6853\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u90C7\u5942\u57B8\u64D0\u571C\u6D39\u6D63\u6F36\u5BF0\u902D\u7F33\u953E\u9CA9\u9B1F",
    "huang": "\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u968D\u5FA8\u6E5F\u6F62\u9051\u749C\u8093\u7640\u87E5\u7BC1\u9CC7",
    "hui": "\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8BD9\u8334\u835F\u8559\u54D5\u5599\u96B3\u6D04\u5F57\u7F0B\u73F2\u6656\u605A\u867A\u87EA\u9EBE",
    "hun": "\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8BE8\u9984\u960D\u6EB7\u7F17",
    "huo": "\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u6509\u56AF\u5925\u94AC\u952A\u956C\u8020\u8816",
    "ji": "\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5C45\u4E0C\u4E69\u525E\u4F76\u4F74\u8114\u58BC\u82A8\u82B0\u8401\u84BA\u857A\u638E\u53FD\u54AD\u54DC\u5527\u5C8C\u5D74\u6D0E\u5F50\u5C50\u9AA5\u757F\u7391\u696B\u6B9B\u621F\u6222\u8D4D\u89CA\u7284\u9F51\u77F6\u7F81\u5D47\u7A37\u7620\u7635\u866E\u7B08\u7B04\u66A8\u8DFB\u8DFD\u9701\u9C9A\u9CAB\u9AFB\u9E82",
    "jia": "\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u4F3D\u90CF\u62EE\u5CAC\u6D43\u8FE6\u73C8\u621B\u80DB\u605D\u94D7\u9553\u75C2\u86F1\u7B33\u8888\u8DCF",
    "jian": "\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50ED\u8C0F\u8C2B\u83C5\u84B9\u641B\u56DD\u6E54\u8E47\u8B07\u7F23\u67A7\u67D9\u6957\u620B\u622C\u726E\u728D\u6BFD\u8171\u7751\u950F\u9E63\u88E5\u7B15\u7BB4\u7FE6\u8DBC\u8E3A\u9CA3\u97AF",
    "jiang": "\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8333\u6D1A\u7EDB\u7F30\u729F\u7913\u8029\u7CE8\u8C47",
    "jiao": "\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u4F7C\u50EC\u832D\u6322\u564D\u5CE4\u5FBC\u59E3\u7E9F\u656B\u768E\u9E6A\u86DF\u91AE\u8DE4\u9C9B",
    "jie": "\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5048\u8BA6\u8BD8\u5588\u55DF\u736C\u5A55\u5B51\u6840\u7352\u78A3\u9534\u7596\u88B7\u9889\u86A7\u7FAF\u9C92\u9AB1\u9AEB",
    "jin": "\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\u5C3D\u537A\u8369\u5807\u5664\u9991\u5ED1\u5997\u7F19\u747E\u69FF\u8D46\u89D0\u9485\u9513\u887F\u77DC",
    "jing": "\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u522D\u5106\u9631\u83C1\u734D\u61AC\u6CFE\u8FF3\u5F2A\u5A67\u80BC\u80EB\u8148\u65CC",
    "jiong": "\u70AF\u7A98\u5182\u8FE5\u6243",
    "jiu": "\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u50E6\u557E\u9604\u67E9\u6855\u9E6B\u8D73\u9B0F",
    "ju": "\u97A0\u62D8\u72D9\u75BD\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u5028\u8BB5\u82E3\u82F4\u8392\u63AC\u907D\u5C66\u741A\u67B8\u6910\u6998\u6989\u6A58\u728B\u98D3\u949C\u9514\u7AAD\u88FE\u8D84\u91B5\u8E3D\u9F83\u96CE\u97AB",
    "juan": "\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u9104\u72F7\u6D93\u684A\u8832\u9529\u954C\u96BD",
    "jue": "\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u53A5\u5282\u8C32\u77CD\u8568\u5658\u5D1B\u7357\u5B53\u73CF\u6877\u6A5B\u721D\u9562\u8E76\u89D6",
    "jun": "\u5747\u83CC\u94A7\u519B\u541B\u5CFB\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u6343\u72FB\u76B2\u7B60\u9E87",
    "ka": "\u5580\u5496\u5361\u4F67\u5494\u80E9",
    "ke": "\u54AF\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u5CA2\u606A\u6E98\u9A92\u7F02\u73C2\u8F72\u6C2A\u778C\u94B6\u75B4\u7AA0\u874C\u9AC1",
    "kai": "\u5F00\u63E9\u6977\u51EF\u6168\u5240\u57B2\u8488\u5FFE\u607A\u94E0\u950E",
    "kan": "\u520A\u582A\u52D8\u574E\u780D\u770B\u4F83\u51F5\u83B0\u83B6\u6221\u9F9B\u77B0",
    "kang": "\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u5751\u4F09\u95F6\u94AA",
    "kao": "\u8003\u62F7\u70E4\u9760\u5C3B\u6832\u7292\u94D0",
    "ken": "\u80AF\u5543\u57A6\u6073\u57A0\u88C9\u9880",
    "keng": "\u542D\u5FD0\u94FF",
    "kong": "\u7A7A\u6050\u5B54\u63A7\u5025\u5D06\u7B9C",
    "kou": "\u62A0\u53E3\u6263\u5BC7\u82A4\u853B\u53E9\u770D\u7B58",
    "ku": "\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5233\u5800\u55BE\u7ED4\u9AB7",
    "kua": "\u5938\u57AE\u630E\u8DE8\u80EF\u4F89",
    "kuai": "\u5757\u7B77\u4FA9\u5FEB\u84AF\u90D0\u8489\u72EF\u810D",
    "kuan": "\u5BBD\u6B3E\u9ACB",
    "kuang": "\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u8BD3\u8BF3\u909D\u5739\u593C\u54D0\u7EA9\u8D36",
    "kui": "\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\u9988\u6127\u6E83\u9997\u532E\u5914\u9697\u63C6\u55B9\u559F\u609D\u6126\u9615\u9035\u668C\u777D\u8069\u8770\u7BD1\u81FE\u8DEC",
    "kun": "\u5764\u6606\u6346\u56F0\u6083\u9603\u7428\u951F\u918C\u9CB2\u9AE1",
    "kuo": "\u62EC\u6269\u5ED3\u9614\u86DE",
    "la": "\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u524C\u647A\u908B\u65EF\u782C\u760C",
    "lai": "\u83B1\u6765\u8D56\u5D03\u5F95\u6D9E\u6FD1\u8D49\u7750\u94FC\u765E\u7C41",
    "lan": "\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u5549\u5C9A\u61D4\u6F24\u6984\u6593\u7F71\u9567\u8934",
    "lang": "\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u83A8\u8497\u5577\u9606\u9512\u7A02\u8782",
    "lao": "\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u5520\u5D02\u6833\u94D1\u94F9\u75E8\u91AA",
    "le": "\u52D2\u4E50\u808B\u4EC2\u53FB\u561E\u6CD0\u9CD3",
    "lei": "\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u7C7B\u6CEA\u7FB8\u8BD4\u837D\u54A7\u6F2F\u5AD8\u7F27\u6A91\u8012\u9179",
    "ling": "\u68F1\u51B7\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u9143\u5844\u82D3\u5464\u56F9\u6CE0\u7EEB\u67C3\u68C2\u74F4\u8046\u86C9\u7FCE\u9CAE",
    "leng": "\u695E\u6123",
    "li": "\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FEA\u4FDA\u90E6\u575C\u82C8\u8385\u84E0\u85DC\u6369\u5456\u5533\u55B1\u7301\u6EA7\u6FA7\u9026\u5A0C\u5AE0\u9A8A\u7F21\u73DE\u67A5\u680E\u8F79\u623E\u783A\u8A48\u7F79\u9502\u9E42\u75A0\u75AC\u86CE\u870A\u8821\u7B20\u7BE5\u7C9D\u91B4\u8DDE\u96F3\u9CA1\u9CE2\u9EE7",
    "lian": "\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u631B\u8539\u5941\u6F4B\u6FC2\u5A08\u740F\u695D\u6B93\u81C1\u81A6\u88E2\u880A\u9CA2",
    "liang": "\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u589A\u690B\u8E09\u9753\u9B49",
    "liao": "\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u84FC\u5C25\u5639\u7360\u5BEE\u7F2D\u948C\u9E69\u8022",
    "lie": "\u5217\u88C2\u70C8\u52A3\u730E\u51BD\u57D2\u6D0C\u8D94\u8E90\u9B23",
    "lin": "\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u853A\u5D99\u5EEA\u9074\u6AA9\u8F9A\u77B5\u7CBC\u8E8F\u9E9F",
    "liu": "\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u62A1\u507B\u848C\u6CD6\u6D4F\u905B\u9A9D\u7EFA\u65D2\u7198\u950D\u954F\u9E68\u938F",
    "long": "\u9F99\u804B\u5499\u7B3C\u7ABF\u9686\u5784\u62E2\u9647\u5F04\u5785\u830F\u6CF7\u73D1\u680A\u80E7\u783B\u7643",
    "lou": "\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u55BD\u5D5D\u9542\u7618\u8027\u877C\u9AC5",
    "lu": "\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u5786\u6445\u64B8\u565C\u6CF8\u6E0C\u6F09\u7490\u680C\u6A79\u8F73\u8F82\u8F98\u6C07\u80EA\u9565\u9E2C\u9E6D\u7C0F\u823B\u9C88",
    "lv": "\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u634B\u95FE\u6988\u8182\u7A06\u891B",
    "luan": "\u5CE6\u5B6A\u6EE6\u5375\u4E71\u683E\u9E3E\u92AE",
    "lue": "\u63A0\u7565\u950A",
    "lun": "\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u56F5",
    "luo": "\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u502E\u8366\u645E\u7321\u6CFA\u6924\u8136\u9559\u7630\u96D2",
    "ma": "\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u551B\u72B8\u5B37\u6769\u9EBD",
    "mai": "\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u52A2\u836C\u54AA\u973E",
    "man": "\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\u8C29\u5881\u5E54\u7F26\u71B3\u9558\u989F\u87A8\u9CD7\u9794",
    "mang": "\u8292\u832B\u76F2\u5FD9\u83BD\u9099\u6F2D\u6726\u786D\u87D2",
    "meng": "\u6C13\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u52D0\u750D\u77A2\u61F5\u791E\u867B\u8722\u8813\u824B\u8268\u9EFE",
    "miao": "\u732B\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u55B5\u9088\u7F08\u7F2A\u676A\u6DFC\u7707\u9E4B\u8731",
    "mao": "\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4F94\u88A4\u52D6\u8306\u5CC1\u7441\u6634\u7266\u8004\u65C4\u61CB\u7780\u86D1\u8765\u87CA\u9AE6",
    "me": "\u4E48",
    "mei": "\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u5776\u8393\u5D4B\u7338\u6D7C\u6E44\u6963\u9545\u9E5B\u8882\u9B45",
    "men": "\u95E8\u95F7\u4EEC\u626A\u739F\u7116\u61D1\u9494",
    "mi": "\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u8288\u5196\u8C27\u863C\u5627\u7315\u736F\u6C68\u5B93\u5F2D\u8112\u6549\u7CF8\u7E3B\u9E8B",
    "mian": "\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u6C94\u6E4E\u817C\u7704",
    "mie": "\u8511\u706D\u54A9\u881B\u7BFE",
    "min": "\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u82E0\u5CB7\u95F5\u6CEF\u73C9",
    "ming": "\u660E\u879F\u9E23\u94ED\u540D\u547D\u51A5\u8317\u6E9F\u669D\u7791\u9169",
    "miu": "\u8C2C",
    "mo": "\u6478\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C1F\u8309\u84E6\u998D\u5AEB\u9546\u79E3\u763C\u8031\u87C6\u8C8A\u8C98",
    "mou": "\u8C0B\u725F\u67D0\u53B6\u54DE\u5A7A\u7738\u936A",
    "mu": "\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u4EEB\u82DC\u5452\u6C90\u6BEA\u94BC",
    "na": "\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u5185\u637A\u80AD\u954E\u8872\u7BAC",
    "nai": "\u6C16\u4E43\u5976\u8010\u5948\u9F10\u827F\u8418\u67F0",
    "nan": "\u5357\u7537\u96BE\u56CA\u5583\u56E1\u6960\u8169\u877B\u8D67",
    "nao": "\u6320\u8111\u607C\u95F9\u5B6C\u57B4\u7331\u7459\u7847\u94D9\u86F2",
    "ne": "\u6DD6\u5462\u8BB7",
    "nei": "\u9981",
    "nen": "\u5AE9\u80FD\u6798\u6041",
    "ni": "\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u4F32\u576D\u730A\u6029\u6EE0\u6635\u65CE\u7962\u615D\u7768\u94CC\u9CB5",
    "nian": "\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5EFF\u8F87\u9ECF\u9C87\u9CB6",
    "niang": "\u5A18\u917F",
    "niao": "\u9E1F\u5C3F\u8311\u5B32\u8132\u8885",
    "nie": "\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u4E5C\u9667\u8616\u55EB\u8080\u989E\u81EC\u8E51",
    "nin": "\u60A8\u67E0",
    "ning": "\u72DE\u51DD\u5B81\u62E7\u6CDE\u4F5E\u84E5\u549B\u752F\u804D",
    "niu": "\u725B\u626D\u94AE\u7EBD\u72C3\u5FF8\u599E\u86B4",
    "nong": "\u8113\u6D53\u519C\u4FAC",
    "nu": "\u5974\u52AA\u6012\u5476\u5E11\u5F29\u80EC\u5B65\u9A7D",
    "nv": "\u5973\u6067\u9495\u8844",
    "nuan": "\u6696",
    "nuenue": "\u8650",
    "nue": "\u759F\u8C11",
    "nuo": "\u632A\u61E6\u7CEF\u8BFA\u50A9\u6426\u558F\u9518",
    "ou": "\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u6004\u74EF\u8026",
    "pa": "\u556A\u8DB4\u722C\u5E15\u6015\u7436\u8469\u7B62",
    "pai": "\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u4FF3\u848E",
    "pan": "\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u723F\u6CEE\u88A2\u897B\u87E0\u8E52",
    "pang": "\u4E53\u5E9E\u65C1\u802A\u80D6\u6EC2\u9004",
    "pao": "\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u530F\u72CD\u5E96\u812C\u75B1",
    "pei": "\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u638A\u8F94\u5E14\u6DE0\u65C6\u952B\u9185\u9708",
    "pen": "\u55B7\u76C6\u6E53",
    "peng": "\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u580B\u562D\u6026\u87DB",
    "pi": "\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u4E15\u9674\u90B3\u90EB\u572E\u9F19\u64D7\u567C\u5E80\u5AB2\u7EB0\u6787\u7513\u7765\u7F74\u94CD\u75E6\u7656\u758B\u868D\u8C94",
    "pian": "\u7BC7\u504F\u7247\u9A97\u8C1D\u9A88\u728F\u80FC\u890A\u7FE9\u8E41",
    "piao": "\u98D8\u6F02\u74E2\u7968\u527D\u560C\u5AD6\u7F25\u6B8D\u779F\u87B5",
    "pie": "\u6487\u77A5\u4E3F\u82E4\u6C15",
    "pin": "\u62FC\u9891\u8D2B\u54C1\u8058\u62DA\u59D8\u5AD4\u6980\u725D\u98A6",
    "ping": "\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u4FDC\u5A09\u67B0\u9C86",
    "po": "\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u53F5\u9131\u6EA5\u73C0\u948B\u94B7\u76A4\u7B38",
    "pou": "\u5256\u88D2\u8E23",
    "pu": "\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u530D\u5657\u6FEE\u749E\u6C06\u9564\u9568\u8E7C",
    "qi": "\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u4E9F\u4E93\u573B\u8291\u840B\u847A\u5601\u5C7A\u5C90\u6C54\u6DC7\u9A90\u7EEE\u742A\u7426\u675E\u6864\u69ED\u6B39\u797A\u61A9\u789B\u86F4\u871E\u7DA6\u7DAE\u8DBF\u8E4A\u9CCD\u9E92",
    "qia": "\u6390\u6070\u6D3D\u845C",
    "qian": "\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u4F65\u9621\u828A\u82A1\u8368\u63AE\u5C8D\u60AD\u614A\u9A9E\u6434\u8930\u7F31\u6920\u80B7\u6106\u94A4\u8654\u7B9D",
    "qiang": "\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u5AF1\u6A2F\u6217\u709D\u9516\u9535\u956A\u8941\u8723\u7F9F\u8DEB\u8DC4",
    "qiao": "\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5281\u8BEE\u8C2F\u835E\u6100\u6194\u7F32\u6A35\u6BF3\u7857\u8DF7\u9792",
    "qie": "\u5207\u8304\u4E14\u602F\u7A83\u90C4\u553C\u60EC\u59BE\u6308\u9532\u7BA7",
    "qin": "\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u82A9\u84C1\u8572\u63FF\u5423\u55EA\u5659\u6EB1\u6A8E\u8793\u887E",
    "qing": "\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u5029\u82D8\u570A\u6AA0\u78EC\u873B\u7F44\u7B90\u8B26\u9CAD\u9EE5",
    "qiong": "\u743C\u7A77\u909B\u8315\u7A79\u7B47\u928E",
    "qiu": "\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u4FC5\u6C3D\u5DEF\u827D\u72B0\u6E6B\u9011\u9052\u6978\u8D47\u9E20\u866C\u86AF\u8764\u88D8\u7CD7\u9CC5\u9F3D",
    "qu": "\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\u53D6\u5A36\u9F8B\u8DA3\u53BB\u8BCE\u52AC\u8556\u8627\u5C96\u8862\u9612\u74A9\u89D1\u6C0D\u795B\u78F2\u766F\u86D0\u883C\u9EB4\u77BF\u9EE2",
    "quan": "\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u8BE0\u8343\u737E\u609B\u7EFB\u8F81\u754E\u94E8\u8737\u7B4C\u9B08",
    "que": "\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u9619\u60AB",
    "qun": "\u88D9\u7FA4\u9021",
    "ran": "\u7136\u71C3\u5189\u67D3\u82D2\u9AEF",
    "rang": "\u74E4\u58E4\u6518\u56B7\u8BA9\u79B3\u7A70",
    "rao": "\u9976\u6270\u7ED5\u835B\u5A06\u6861",
    "ruo": "\u60F9\u82E5\u5F31",
    "re": "\u70ED\u504C",
    "ren": "\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u4EDE\u834F\u845A\u996A\u8F6B\u7A14\u887D",
    "reng": "\u6254\u4ECD",
    "ri": "\u65E5",
    "rong": "\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u5D58\u72E8\u7F1B\u6995\u877E",
    "rou": "\u63C9\u67D4\u8089\u7CC5\u8E42\u97A3",
    "ru": "\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u84D0\u85B7\u5685\u6D33\u6EBD\u6FE1\u94F7\u8966\u98A5",
    "ruan": "\u8F6F\u962E\u670A",
    "rui": "\u854A\u745E\u9510\u82AE\u8564\u777F\u868B",
    "run": "\u95F0\u6DA6",
    "sa": "\u6492\u6D12\u8428\u5345\u4EE8\u6332\u98D2",
    "sai": "\u816E\u9CC3\u585E\u8D5B\u567B",
    "san": "\u4E09\u53C1\u4F1E\u6563\u5F61\u9993\u6C35\u6BF5\u7CC1\u9730",
    "sang": "\u6851\u55D3\u4E27\u6421\u78C9\u98A1",
    "sao": "\u6414\u9A9A\u626B\u5AC2\u57FD\u81CA\u7619\u9CCB",
    "se": "\u745F\u8272\u6DA9\u556C\u94E9\u94EF\u7A51",
    "sen": "\u68EE",
    "seng": "\u50E7",
    "sha": "\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u810E\u6B43\u75E7\u88DF\u970E\u9CA8",
    "shai": "\u7B5B\u6652\u917E",
    "shan": "\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5261\u8BAA\u912F\u57CF\u829F\u6F78\u59D7\u9A9F\u81BB\u9490\u759D\u87EE\u8222\u8DDA\u9CDD",
    "shang": "\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u57A7\u7EF1\u6B87\u71B5\u89DE",
    "shao": "\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u52AD\u82D5\u6F72\u86F8\u7B24\u7B72\u8244",
    "she": "\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u538D\u4F58\u731E\u7572\u9E9D",
    "shen": "\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u8BDC\u8C02\u5432\u54C2\u6E16\u6939\u77E7\u8703",
    "sheng": "\u58F0\u751F\u7525\u7272\u5347\u7EF3\u7701\u76DB\u5269\u80DC\u5723\u4E1E\u6E11\u5AB5\u771A\u7B19",
    "shi": "\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u8C25\u57D8\u83B3\u84CD\u5F11\u5511\u9963\u8F7C\u8006\u8D33\u70BB\u793B\u94C8\u94CA\u87AB\u8210\u7B6E\u8C55\u9CA5\u9CBA",
    "shou": "\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u624C\u72E9\u7EF6\u824F",
    "shu": "\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\u6055\u500F\u587E\u83FD\u5FC4\u6CAD\u6D91\u6F8D\u59DD\u7EBE\u6BF9\u8167\u6BB3\u956F\u79EB\u9E6C",
    "shua": "\u5237\u800D\u5530\u6DAE",
    "shuai": "\u6454\u8870\u7529\u5E05\u87C0",
    "shuan": "\u6813\u62F4\u95E9",
    "shuang": "\u971C\u53CC\u723D\u5B40",
    "shui": "\u8C01\u6C34\u7761\u7A0E",
    "shun": "\u542E\u77AC\u987A\u821C\u6042",
    "shuo": "\u8BF4\u7855\u6714\u70C1\u84B4\u6420\u55CD\u6FEF\u5981\u69CA\u94C4",
    "si": "\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u53AE\u4FDF\u5155\u83E5\u549D\u6C5C\u6CD7\u6F8C\u59D2\u9A77\u7F0C\u7940\u7960\u9536\u9E36\u801C\u86F3\u7B25",
    "song": "\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u51C7\u83D8\u5D27\u5D69\u5FEA\u609A\u6DDE\u7AE6",
    "sou": "\u641C\u8258\u64DE\u55FD\u53DF\u55D6\u55FE\u998A\u6EB2\u98D5\u778D\u953C\u878B",
    "su": "\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u5919\u8C21\u850C\u55C9\u612B\u7C0C\u89EB\u7A23",
    "suan": "\u9178\u849C\u7B97",
    "sui": "\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u84D1\u51AB\u8C07\u6FC9\u9083\u71E7\u772D\u7762",
    "sun": "\u5B59\u635F\u7B0B\u836A\u72F2\u98E7\u69AB\u8DE3\u96BC",
    "suo": "\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u5522\u55E6\u5A11\u686B\u7743\u7FA7",
    "ta": "\u584C\u4ED6\u5B83\u5979\u5854\u736D\u631E\u8E4B\u8E0F\u95FC\u6EBB\u9062\u69BB\u6C93",
    "tai": "\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u90B0\u85B9\u80BD\u70B1\u949B\u8DC6\u9C90",
    "tan": "\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u90EF\u8548\u6619\u94BD\u952C\u8983",
    "tang": "\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u50A5\u9967\u6E8F\u746D\u94F4\u9557\u8025\u8797\u87B3\u7FB0\u91A3",
    "thang": "\u5018\u8EBA\u6DCC",
    "theng": "\u8D9F\u70EB",
    "tao": "\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u6311\u9F17\u5555\u97EC\u9955",
    "te": "\u7279",
    "teng": "\u85E4\u817E\u75BC\u8A8A\u6ED5",
    "ti": "\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u8351\u608C\u9016\u7EE8\u7F07\u9E48\u88FC\u918D",
    "tian": "\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u63AD\u5FDD\u9617\u6B84\u754B\u94BF\u86BA",
    "tiao": "\u6761\u8FE2\u773A\u8DF3\u4F7B\u7967\u94EB\u7A95\u9F86\u9CA6",
    "tie": "\u8D34\u94C1\u5E16\u841C\u992E",
    "ting": "\u5385\u542C\u70C3\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u839B\u8476\u5A77\u6883\u8713\u9706",
    "tong": "\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u4F5F\u50EE\u4EDD\u833C\u55F5\u6078\u6F7C\u783C",
    "tou": "\u5077\u6295\u5934\u900F\u4EA0",
    "tu": "\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u580D\u837C\u83DF\u948D\u9174",
    "tuan": "\u6E4D\u56E2\u7583",
    "tui": "\u63A8\u9893\u817F\u8715\u892A\u9000\u5FD2\u717A",
    "tun": "\u541E\u5C6F\u81C0\u9968\u66BE\u8C5A\u7A80",
    "tuo": "\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u4E47\u4F57\u5768\u5EB9\u6CB1\u67DD\u7823\u7BA8\u8204\u8DCE\u9F0D",
    "wa": "\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u4F64\u5A32\u817D",
    "wai": "\u6B6A\u5916",
    "wan": "\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u525C\u8284\u82CB\u83C0\u7EA8\u7EFE\u742C\u8118\u7579\u873F\u7BA2",
    "wang": "\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u7F54\u5C22\u60D8\u8F8B\u9B4D",
    "wei": "\u5A01\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u502D\u504E\u8BFF\u9688\u8473\u8587\u5E0F\u5E37\u5D34\u5D6C\u7325\u732C\u95F1\u6CA9\u6D27\u6DA0\u9036\u5A13\u73AE\u97EA\u8ECE\u709C\u7168\u71A8\u75FF\u8249\u9C94",
    "wen": "\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u520E\u6120\u960C\u6C76\u74BA\u97EB\u6B81\u96EF",
    "weng": "\u55E1\u7FC1\u74EE\u84CA\u8579",
    "wo": "\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u83B4\u5E44\u6E25\u674C\u809F\u9F8C",
    "wu": "\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u5140\u4EF5\u9622\u90AC\u572C\u82B4\u5E91\u6003\u5FE4\u6D6F\u5BE4\u8FD5\u59A9\u9A9B\u727E\u7110\u9E49\u9E5C\u8708\u92C8\u9F2F",
    "xi": "\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u50D6\u516E\u96B0\u90D7\u831C\u8478\u84F0\u595A\u550F\u5F99\u9969\u960B\u6D60\u6DC5\u5C63\u5B09\u73BA\u6A28\u66E6\u89CB\u6B37\u71B9\u798A\u79A7\u94B8\u7699\u7A78\u8725\u87CB\u823E\u7FB2\u7C9E\u7FD5\u91AF\u9F37",
    "xia": "\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u846D\u55C4\u72CE\u9050\u7455\u7856\u7615\u7F45\u9EE0",
    "xian": "\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u51BC\u85D3\u5C98\u7303\u66B9\u5A34\u6C19\u7946\u9E47\u75EB\u86AC\u7B45\u7C7C\u9170\u8DF9",
    "xiang": "\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8297\u8459\u9977\u5EA0\u9AA7\u7F03\u87D3\u9C9E\u98E8",
    "xiao": "\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u54D3\u54BB\u5D24\u6F47\u900D\u9A81\u7EE1\u67AD\u67B5\u7B71\u7BAB\u9B48",
    "xie": "\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u5055\u4EB5\u52F0\u71EE\u85A4\u64B7\u5EE8\u7023\u9082\u7EC1\u7F2C\u69AD\u698D\u6B59\u8E9E",
    "xin": "\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u56DF\u99A8\u8398\u6B46\u94FD\u946B",
    "xing": "\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u9649\u8347\u8365\u64E4\u60BB\u784E",
    "xiong": "\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u828E",
    "xiu": "\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u83A0\u5CAB\u9990\u5EA5\u9E3A\u8C85\u9AF9",
    "xu": "\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8BB4\u8BE9\u5729\u84FF\u6035\u6D2B\u6E86\u987C\u6829\u7166\u7809\u76F1\u80E5\u7CC8\u9191",
    "xuan": "\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\u9009\u7663\u7729\u7EDA\u5107\u8C16\u8431\u63CE\u9994\u6CEB\u6D35\u6E32\u6F29\u7487\u6966\u6684\u70AB\u714A\u78B9\u94C9\u955F\u75C3",
    "xue": "\u9774\u859B\u5B66\u7A74\u96EA\u8840\u5671\u6CF6\u9CD5",
    "xun": "\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u5DFD\u57D9\u8340\u85B0\u5CCB\u5F87\u6D54\u66DB\u7AA8\u91BA\u9C9F",
    "ya": "\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u4F22\u63E0\u5416\u5C88\u8FD3\u5A05\u740A\u6860\u6C29\u7811\u775A\u75D6",
    "yan": "\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u53A3\u9765\u8D5D\u4FE8\u5043\u5156\u8BA0\u8C33\u90FE\u9122\u82AB\u83F8\u5D26\u6079\u95EB\u960F\u6D07\u6E6E\u6EDF\u598D\u5AE3\u7430\u664F\u80ED\u814C\u7131\u7F68\u7B75\u917D\u9B47\u990D\u9F39",
    "yang": "\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u5F89\u600F\u6CF1\u7080\u70CA\u6059\u86D8\u9785",
    "yao": "\u9080\u8170\u5996\u7476\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u592D\u723B\u5406\u5D3E\u5FAD\u7039\u5E7A\u73E7\u6773\u66DC\u80B4\u9E5E\u7A88\u7E47\u9CD0",
    "ye": "\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u8C12\u90BA\u63F6\u9980\u6654\u70E8\u94D8",
    "yi": "\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u5208\u5293\u4F7E\u8BD2\u572A\u572F\u57F8\u61FF\u82E1\u858F\u5F08\u5955\u6339\u5F0B\u5453\u54A6\u54BF\u566B\u5CC4\u5DB7\u7317\u9974\u603F\u6021\u6092\u6F2A\u8FE4\u9A7F\u7F22\u6BAA\u8D3B\u65D6\u71A0\u9487\u9552\u9571\u75CD\u7617\u7654\u7FCA\u8864\u8734\u8223\u7FBF\u7FF3\u914F\u9EDF",
    "yin": "\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\u5370\u80E4\u911E\u5819\u831A\u5591\u72FA\u5924\u6C24\u94DF\u763E\u8693\u972A\u9F88",
    "ying": "\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u5B34\u90E2\u8314\u83BA\u8426\u6484\u5624\u81BA\u6EE2\u6F46\u701B\u745B\u748E\u6979\u9E66\u763F\u988D\u7F42",
    "yo": "\u54DF\u5537",
    "yong": "\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u4FD1\u58C5\u5889\u6175\u9095\u955B\u752C\u9CD9\u9954",
    "you": "\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u5363\u6538\u4F91\u83B8\u5466\u56FF\u5BA5\u67DA\u7337\u7256\u94D5\u75A3\u8763\u9C7F\u9EDD\u9F2C",
    "yu": "\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u79BA\u6BD3\u4F1B\u4FE3\u8C00\u8C15\u8438\u84E3\u63C4\u5581\u5704\u5709\u5D5B\u72F3\u996B\u5EBE\u9608\u59AA\u59A4\u7EA1\u745C\u6631\u89CE\u8174\u6B24\u65BC\u715C\u71E0\u807F\u94B0\u9E46\u7610\u7600\u7AB3\u8753\u7AFD\u8201\u96E9\u9F89",
    "yuan": "\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u586C\u6C85\u5A9B\u7457\u6A7C\u7230\u7722\u9E22\u8788\u9F0B",
    "yue": "\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u9FA0\u6A3E\u5216\u94BA",
    "yun": "\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u90D3\u82B8\u72C1\u607D\u7EAD\u6B92\u6600\u6C32",
    "za": "\u531D\u7838\u6742\u62F6\u5482",
    "zai": "\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u5D3D\u753E",
    "zan": "\u6512\u6682\u8D5E\u74D2\u661D\u7C2A\u7CCC\u8DB1\u933E",
    "zang": "\u8D43\u810F\u846C\u5958\u6215\u81E7",
    "zao": "\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u5523\u7F2B",
    "ze": "\u8D23\u62E9\u5219\u6CFD\u4EC4\u8D5C\u5567\u8FEE\u6603\u7B2E\u7BA6\u8234",
    "zei": "\u8D3C",
    "zen": "\u600E\u8C2E",
    "zeng": "\u589E\u618E\u66FE\u8D60\u7F2F\u7511\u7F7E\u9503",
    "zha": "\u624E\u55B3\u6E23\u672D\u8F67\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u63F8\u5412\u54A4\u54F3\u600D\u781F\u75C4\u86B1\u9F44",
    "zhai": "\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u7826",
    "zhan": "\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u8C35\u640C\u65C3",
    "zhang": "\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u4EC9\u9123\u5E5B\u5D82\u7350\u5ADC\u748B\u87D1",
    "zhao": "\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u722A\u8BCF\u68F9\u948A\u7B0A",
    "zhe": "\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u8C2A\u966C\u67D8\u8F84\u78D4\u9E67\u891A\u8707\u8D6D",
    "zhen": "\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u7F1C\u6862\u699B\u8F78\u8D48\u80D7\u6715\u796F\u755B\u9E29",
    "zheng": "\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\u5E27\u75C7\u90D1\u8BC1\u8BE4\u5CE5\u94B2\u94EE\u7B5D",
    "zhi": "\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u536E\u965F\u90C5\u57F4\u82B7\u646D\u5E19\u5FEE\u5F58\u54AB\u9A98\u6809\u67B3\u6800\u684E\u8F75\u8F7E\u6534\u8D3D\u81A3\u7949\u7957\u9EF9\u96C9\u9E37\u75E3\u86ED\u7D77\u916F\u8DD6\u8E2C\u8E2F\u8C78\u89EF",
    "zhong": "\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u51A2\u953A\u87BD\u8202\u822F\u8E35",
    "zhou": "\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u5544\u7740\u501C\u8BF9\u836E\u9B3B\u7EA3\u80C4\u78A1\u7C40\u8233\u914E\u9CB7",
    "zhu": "\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\u4F4F\u6CE8\u795D\u9A7B\u4F2B\u4F8F\u90BE\u82CE\u8331\u6D19\u6E1A\u6F74\u9A7A\u677C\u69E0\u6A65\u70B7\u94E2\u75B0\u7603\u86B0\u7AFA\u7BB8\u7FE5\u8E85\u9E88",
    "zhua": "\u6293",
    "zhuai": "\u62FD",
    "zhuan": "\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u629F\u556D\u989B",
    "zhuang": "\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u4E2C",
    "zhui": "\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8411\u9A93\u7F12",
    "zhun": "\u8C06\u51C6",
    "zhuo": "\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u707C\u6D4A\u502C\u8BFC\u5EF4\u855E\u64E2\u555C\u6D5E\u6DBF\u6753\u712F\u799A\u65AB",
    "zi": "\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u8C18\u5D6B\u59CA\u5B73\u7F01\u6893\u8F8E\u8D40\u6063\u7726\u9531\u79ED\u8014\u7B2B\u7CA2\u89DC\u8A3E\u9CBB\u9AED",
    "zong": "\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u8159\u7CBD",
    "zou": "\u90B9\u8D70\u594F\u63CD\u9139\u9CB0",
    "zu": "\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u4FCE\u83F9\u5550\u5F82\u9A75\u8E74",
    "zuan": "\u94BB\u7E82\u6525\u7F35",
    "zui": "\u5634\u9189\u6700\u7F6A",
    "zun": "\u5C0A\u9075\u6499\u6A3D\u9CDF",
    "zuo": "\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\u961D\u963C\u80D9\u795A\u9162",
    "cou": "\u85AE\u6971\u8F8F\u8160",
    "nang": "\u652E\u54DD\u56D4\u9995\u66E9",
    "o": "\u5594",
    "dia": "\u55F2",
    "chuai": "\u562C\u81AA\u8E39",
    "cen": "\u5C91\u6D94",
    "diu": "\u94E5",
    "nou": "\u8028",
    "fou": "\u7F36",
    "bia": "\u9ADF"
};
// CONCATENATED MODULE: ./src/assets/utils/vue-py.js

/* harmony default export */ var vue_py = ({
    chineseToPinYin: function chineseToPinYin(l1) {
        var l2 = l1.length;
        var I1 = '';
        var reg = new RegExp('[a-zA-Z0-9]');
        for (var i = 0; i < l2; i++) {
            var val = l1.substr(i, 1);
            var name = this.arraySearch(val, pinyin);
            if (reg.test(val)) {
                I1 += val;
            } else if (name !== false) {
                I1 += name;
            }
        }
        I1 = I1.replace(/ /g, '-');
        while (I1.indexOf('--') > 0) {
            I1 = I1.replace('--', '-');
        }
        return I1;
    },
    arraySearch: function arraySearch(l1, l2) {
        for (var name in pinyin) {
            if (pinyin[name].indexOf(l1) !== -1) {
                return this.ucfirst(name);
            }
        }
        return false;
    },
    ucfirst: function ucfirst(l1) {
        if (l1.length > 0) {
            var first = l1.substr(0, 1).toUpperCase();
            var spare = l1.substr(1, l1.length);
            return first + spare;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/certified.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var certified = ({
    data: function data() {
        return {
            that: this,
            lastNameText: '姓名不能为空！',
            isUserName: false,
            isfullNameEng: false,
            sendInfo: {
                loanOrderCode: this.$route.query.loanOrderCode,
                fullNameEng: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '' // 名
            },
            provinceBankJson: [],
            bankCode: '',
            cardUserName: '',
            productCode: '',
            isAllRrquridSuccess: false,
            lastNEng: "",
            firstNEng: ""
        };
    },
    created: function created() {
        this.provinceBankJson = bank_default.a;
    },
    mounted: function mounted() {
        this.init();
    },

    filters: {
        nullFilter: function nullFilter(val) {
            return val ? val : '--';
        },
        bankCodeFilter: function bankCodeFilter(val, that) {
            if (val) {
                var name = '';
                that.provinceBankJson.map(function (item, index) {
                    if (val == item.bankCode) {
                        name = item.bankName;
                    }
                });
                return name;
            } else {
                return '--';
            }
        },
        productCodeFilter: function productCodeFilter(val) {
            if (val == '6000') {
                return '个人经营性贷款';
            }
        }
    },
    methods: {
        init: function init() {
            var _this = this;

            commonPageDetailLoad({
                loanOrderCode: this.$route.query.loanOrderCode
            }).then(function (result) {
                if (result.responseCode == '000000') {
                    var resData = result.responseData;
                    _this.bankCode = resData.loanInfo.bankCode;
                    _this.cardUserName = resData.loanUserInfo.cardUserName;
                    _this.productCode = resData.loanInfo.productCode;
                    hashmap.set('productCode', _this.productCode);
                    hashmap.set('bankCode', _this.bankCode);
                }
            });
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isfullNameEng = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isfullNameEng = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isfullNameEng = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isfullNameEng = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)) {
                this.lastNameText = '请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.lastName) {
                    this.isAllSuccess();
                    this.verlastNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
                if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                    this.sendInfo.lastNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.lastName) && reg.test(this.sendInfo.firstName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verlastNamePY();
                this.lastNEng = PinYin;
            }
        },
        verName: function verName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.firstName) {
                    this.isAllSuccess();
                    this.verNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
                if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                    this.sendInfo.firstNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.firstName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verNamePY();
                this.firstNEng = PinYin;
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isUserName && !this.isfullNameEng) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },

        //开始申请
        apply: function apply() {
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.next();
            } else {
                window.scrollTo(0, 0);
            }
        },
        next: function next() {
            var _this2 = this;

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }
            this.sendInfo.fullNameEng = ret;
            hashmap.set('loanOrderCode', this.$route.query.loanOrderCode);
            hashmap.set('sendInfo', this.sendInfo);

            loadRelationByUserName(this.sendInfo).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this2.$router.push({
                        path: url
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/certified.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var view_certified = ({
    data: function data() {
        return {
            that: this,
            lastNameText: '姓名不能为空！',
            isUserName: false,
            isfullNameEng: false,
            sendInfo: {
                loanOrderCode: this.$route.query.loanOrderCode,
                fullNameEng: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '' // 名
            },
            provinceBankJson: [],
            bankCode: '',
            cardUserName: '',
            productCode: '',
            isAllRrquridSuccess: false,
            lastNEng: "",
            firstNEng: ""
        };
    },
    created: function created() {
        this.provinceBankJson = bank_default.a;
    },
    mounted: function mounted() {
        this.init();
    },

    filters: {
        nullFilter: function nullFilter(val) {
            return val ? val : '--';
        },
        bankCodeFilter: function bankCodeFilter(val, that) {
            if (val) {
                var name = '';
                that.provinceBankJson.map(function (item, index) {
                    if (val == item.bankCode) {
                        name = item.bankName;
                    }
                });
                return name;
            } else {
                return '--';
            }
        },
        productCodeFilter: function productCodeFilter(val) {
            if (val == '6000') {
                return '个人经营性贷款';
            }
        }
    },
    methods: {
        init: function init() {
            var _this = this;

            commonPageDetailLoad({
                loanOrderCode: this.$route.query.loanOrderCode
            }).then(function (result) {
                if (result.responseCode == '000000') {
                    var resData = result.responseData;
                    _this.bankCode = resData.loanInfo.bankCode;
                    _this.cardUserName = resData.loanUserInfo.cardUserName;
                    _this.productCode = resData.loanInfo.productCode;
                    hashmap.set('productCode', _this.productCode);
                    hashmap.set('bankCode', _this.bankCode);
                }
            });
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isfullNameEng = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isfullNameEng = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isfullNameEng = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isfullNameEng = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)) {
                this.lastNameText = '请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.lastName) {
                    this.isAllSuccess();
                    this.verlastNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
                if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                    this.sendInfo.lastNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.lastName) && reg.test(this.sendInfo.firstName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verlastNamePY();
                this.lastNEng = PinYin;
            }
        },
        verName: function verName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.firstName) {
                    this.isAllSuccess();
                    this.verNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
                if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                    this.sendInfo.firstNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.firstName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verNamePY();
                this.firstNEng = PinYin;
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isUserName && !this.isfullNameEng) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },

        //开始申请
        apply: function apply() {
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.next();
            } else {
                window.scrollTo(0, 0);
            }
        },
        next: function next() {
            var _this2 = this;

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }
            this.sendInfo.fullNameEng = ret;
            hashmap.set('loanOrderCode', this.$route.query.loanOrderCode);
            hashmap.set('sendInfo', this.sendInfo);

            loadRelationByUserName(this.sendInfo).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this2.$router.push({
                        path: url
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5beeb3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/certified.vue
var certified_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-wrap"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserName","aria-label":'错误提示，' + _vm.lastNameText}},[_vm._v(_vm._s(_vm.lastNameText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isfullNameEng),expression:"isfullNameEng"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isfullNameEng","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_vm._v("姓名（英文/拼音）不能为空！")])])])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('dl',{staticClass:"global-bgbox"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("借款申请人所在地的汇丰村镇银行")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium"},[_vm._v("\n                    "+_vm._s(_vm._f("bankCodeFilter")(_vm.bankCode,_vm.that))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{},[_vm._v("借款申请人"+_vm._s(_vm._f("nullFilter")(_vm.cardUserName))+"正在我行申请"+_vm._s(_vm._f("productCodeFilter")(_vm.productCode))+"，现诚挚邀请您作为共同借款人/担保人/其他贷款义务人或相关人士进行身份验证及征信信息查询授权。")]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("身份信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(3),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserName"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('label',{attrs:{"for":"lName"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastName),expression:"sendInfo.lastName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"id":"lName","aria-labelledby":"chineseNameF","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","aria-invalid":"true","aria-describedby":"HelpText0","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastName)},on:{"change":_vm.verlastName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('label',{attrs:{"for":"fName"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstName),expression:"sendInfo.firstName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"id":"fName","aria-labelledby":"chineseNameL","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","aria-invalid":"true","aria-describedby":"HelpText0","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstName)},on:{"change":_vm.verName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText0","aria-label":'错误提示，'+ _vm.lastNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.lastNameText))])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(4),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isfullNameEng"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('label',{attrs:{"for":"lNameEng"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastNameEng),expression:"sendInfo.lastNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isfullNameEng},attrs:{"id":"lNameEng","aria-labelledby":"englishNameF","onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastNameEng)},on:{"blur":[_vm.verlastNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastNameEng", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('label',{attrs:{"for":"fNameEng"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstNameEng),expression:"sendInfo.firstNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isfullNameEng},attrs:{"id":"fNameEng","aria-labelledby":"englishNameL","onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstNameEng)},on:{"blur":[_vm.verNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstNameEng", $event.target.value.trim())}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isfullNameEng),expression:"isfullNameEng"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("姓名（英文/拼音）不能为空！")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"index-btn-margin"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":_vm.apply}},[_vm._v("同意并进行认证授权")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])])}
var certified_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-title-wrap"},[_c('h1',{staticClass:"title"},[_vm._v("其他贷款义务人或相关人士认证授权")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-btn-tip"},[_c('b',[_vm._v("若您同意，请点击下方按钮，进入下一步。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-btn-tip"},[_c('b',[_vm._v("若不同意，请直接关闭页面即可。")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"chineseNameF"}},[_vm._v("姓（中文）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"chineseNameL"}},[_vm._v("名（中文）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"englishNameF"}},[_vm._v("姓（拼音）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"englishNameL"}},[_vm._v("名（拼音）")])])}]
var certified_esExports = { render: certified_render, staticRenderFns: certified_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_certified = (certified_esExports);
// CONCATENATED MODULE: ./src/view/certified.vue
function certified_injectStyle (ssrContext) {
  __webpack_require__("CVgN")
}
var certified_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var certified___vue_template_functional__ = false
/* styles */
var certified___vue_styles__ = certified_injectStyle
/* scopeId */
var certified___vue_scopeId__ = "data-v-1f5beeb3"
/* moduleIdentifier (server only) */
var certified___vue_module_identifier__ = null
var certified_Component = certified_normalizeComponent(
  view_certified,
  selectortype_template_index_0_src_view_certified,
  certified___vue_template_functional__,
  certified___vue_styles__,
  certified___vue_scopeId__,
  certified___vue_module_identifier__
)

/* harmony default export */ var src_view_certified = (certified_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/code/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var code = ({
    props: ['photoCodeBool', 'isDisabled'],
    directives: {
        focus: {
            componentUpdated: function componentUpdated(el, obj) {
                obj.value && el.focus();
            }
        }
    },
    created: function created() {
        this.code = new Array(this.amount).fill('');
    },
    data: function data() {
        return {
            code: [],
            currentIndex: 0,
            currentcode: null,
            amount: 6
        };
    },

    computed: {
        isPhotoCode: function isPhotoCode() {
            return this.photoCodeBool;
        }
    },
    methods: {
        bothCode: function bothCode(e, index) {
            this.code[index - 1] = e.target.value;
            if (this.currentcode && this.currentcode.length === 6) {
                this.$parent.verPhotoCode(); //父组件位数实施检验
            }
        },
        aa: function aa() {
            this.code = [];
            this.currentIndex = 0;
        },
        handleInput: function handleInput(e, index) {
            this.currentIndex = index;
            e.target.value = this.validateNumber(e.target.value);
            e.target.value !== '' && ++this.currentIndex;
            var code = this.code.join('');
            this.currentcode = code;
            this.$parent.getPhotoCode(code);
        },
        onDelete: function onDelete(e, index) {
            this.code[index] = e.target.value;
            if (e.target.value === '') {
                this.currentIndex = index - 1;
            }
        },
        validateNumber: function validateNumber(val) {
            return val.replace(/\D/g, '');
        },
        handlePaste: function handlePaste(e) {
            e.preventDefault();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/code/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_code = ({
    props: ['photoCodeBool', 'isDisabled'],
    directives: {
        focus: {
            componentUpdated: function componentUpdated(el, obj) {
                obj.value && el.focus();
            }
        }
    },
    created: function created() {
        this.code = new Array(this.amount).fill('');
    },
    data: function data() {
        return {
            code: [],
            currentIndex: 0,
            currentcode: null,
            amount: 6
        };
    },

    computed: {
        isPhotoCode: function isPhotoCode() {
            return this.photoCodeBool;
        }
    },
    methods: {
        bothCode: function bothCode(e, index) {
            this.code[index - 1] = e.target.value;
            if (this.currentcode && this.currentcode.length === 6) {
                this.$parent.verPhotoCode(); //父组件位数实施检验
            }
        },
        aa: function aa() {
            this.code = [];
            this.currentIndex = 0;
        },
        handleInput: function handleInput(e, index) {
            this.currentIndex = index;
            e.target.value = this.validateNumber(e.target.value);
            e.target.value !== '' && ++this.currentIndex;
            var code = this.code.join('');
            this.currentcode = code;
            this.$parent.getPhotoCode(code);
        },
        onDelete: function onDelete(e, index) {
            this.code[index] = e.target.value;
            if (e.target.value === '') {
                this.currentIndex = index - 1;
            }
        },
        validateNumber: function validateNumber(val) {
            return val.replace(/\D/g, '');
        },
        handlePaste: function handlePaste(e) {
            e.preventDefault();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218e1b20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/code/index.vue
var code_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-input-wrap"},[_c('fieldset',{staticClass:"global-fieldset"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"ys-verification"},_vm._l((_vm.amount),function(item,index){return _c('div',{key:index,staticClass:"input-wrapper"},[_c('input',{directives:[{name:"focus",rawName:"v-focus",value:((item - 1) === _vm.currentIndex),expression:"(item - 1) === currentIndex"},{name:"model",rawName:"v-model",value:(_vm.code[item-1]),expression:"code[item-1]"}],staticClass:"global-input code-input",class:{'global-input-error':_vm.isPhotoCode},attrs:{"aria-label":'Verification code character'+ (index+1),"id":"codeId","type":"tel","disabled":_vm.isDisabled,"onkeyup":"this.value=this.value.replace(/\\D/g,'')","maxlength":"1","onblur":"this.value=this.value.replace(/\\D/g,'')"},domProps:{"value":(_vm.code[item-1])},on:{"paste":_vm.handlePaste,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.code, item-1, $event.target.value)},function($event){_vm.handleInput($event,(item-1))}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }_vm.onDelete($event,(item-1))},"blur":function($event){return _vm.bothCode($event,item)}}})])}),0)])])}
var code_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legend',{staticClass:"global-label"},[_c('label',{attrs:{"for":"codeId"}},[_vm._v("验证码")])])}]
var code_esExports = { render: code_render, staticRenderFns: code_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_code = (code_esExports);
// CONCATENATED MODULE: ./src/components/code/index.vue
function code_injectStyle (ssrContext) {
  __webpack_require__("VgBI")
}
var code_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var code___vue_template_functional__ = false
/* styles */
var code___vue_styles__ = code_injectStyle
/* scopeId */
var code___vue_scopeId__ = "data-v-218e1b20"
/* moduleIdentifier (server only) */
var code___vue_module_identifier__ = null
var code_Component = code_normalizeComponent(
  components_code,
  selectortype_template_index_0_src_components_code,
  code___vue_template_functional__,
  code___vue_styles__,
  code___vue_scopeId__,
  code___vue_module_identifier__
)

/* harmony default export */ var src_components_code = (code_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//验证码组件





/* harmony default export */ var login = ({
    components: {
        photoCode: src_components_code
    },
    data: function data() {
        return {
            isDisabled: true,
            isAllRrquridSuccess: false,
            toastMsg: '',
            hint: "发送验证码",
            photoCode: '',
            mobilPhone: "",
            getCursor: true, //验证码不可点击样式
            bindPhotoTxt: 'waring',
            isBindPhotoTxtShow: false,
            isBindPhotoError: false,
            photoCodeBool: false,
            verifyCode: '',
            // 验证码
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            loginParams: {
                countryCode: "CN",
                mobile: "18917309999", //this.mobilePhone
                countryNo: "86",
                projectId: "HSBC", //项目ID
                verifyCode: '',
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            bankCode: hashmap.get('bankCode'),
            //倒计时
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: ""
            },
            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: true
        };
    },
    mounted: function mounted() {
        this.countdown.counts = this.hint;
        if (!this.bankCode) {
            this.$router.push('/index');
        }
        this.getImage();
    },

    methods: {
        // 获取图形验证码
        getImage: function getImage() {
            var _this = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this.imgSrc = result.data.responseData.verCode;
                _this.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },
        btnBack: function btnBack() {
            this.$router.push('/index');
        },
        getPhotoCode: function getPhotoCode(val) {
            this.loginParams.verifyCode = val; // 判断是否全部为空
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.loginParams.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
                return true;
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (this.isBindPhotoError === false && this.isBindPhotoTxtShow === false) {
                this.isAllRrquridSuccess = false;
                return true;
            } else {
                this.isAllRrquridSuccess = true;
                window.scrollTo(0, 0);
                return false;
            }
        },
        getdata: function getdata() {
            var _this2 = this;

            this.loginParams.mobile = this.mobilPhone;
            dataBase_login(this.loginParams).then(function (result) {
                if (result.responseCode === "000000") {
                    hashmap.set('application_id', result.responseData.loanOrderCode);
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    _this2.$router.push({
                        path: url,
                        query: {
                            code: result.responseData.fbCode,
                            loanOrderCode: result.responseData.loanOrderCode,
                            fromType: result.responseData.fromType,
                            rejectDueDate: result.responseData.rejectDueDate || '', //审批拒绝日期提示
                            reApplyBtn: result.responseData.reApplyBtn || '' //审批拒绝按钮显示不显示
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this2.isBindPhotoError = true;
                    _this2.isAllSuccess();
                    _this2.toastMsg = result.responseMessage;
                }
            });
        },
        login: function login() {
            this.portalType = "login";
            this.verMobilePhone(1);
            this.verPhotoCode();
            var isver = this.isAllSuccess();
            if (isver) {
                this.getdata();
            }
        },
        register: function register() {
            this.portalType = "register";
            this.getdata();
        },
        getVerifyCode: function getVerifyCode() {
            var _this3 = this;

            //是否在倒计时
            if (this.countdown.counts === this.hint) {
                this.valiCodeParams.mobile = this.mobilPhone;
                this.valiCodeParams.verCode = this.verCode;
                this.valiCodeParams.uuId = this.uuId;
                getLoginPhoneValidCode(this.valiCodeParams).then(function (result) {
                    if (result.responseCode === "000000") {
                        _this3.isDisabled = false;

                        //开始倒计时
                        _this3.countdownTime();
                        // this.showToast("验证码获取成功！") 尼古拉斯说这个提示不要
                        // clearInterval(this.countdown.timer);
                    }
                });
            }
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this4 = this;

            if (!this.countdown.timer) {
                //开始计时  按钮不可点击
                this.getCursorCode = true;
                this.getCursor = true;
                //初始化 计时器时间
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this4.countdown.count > 0 && _this4.countdown.count <= _this4.countdown.TIME_COUNT) {
                        _this4.countdown.counts = "重发验证码（" + _this4.countdown.count + "s）";
                        _this4.countdown.count--;
                    } else {
                        //计时结束 按钮可以点击
                        _this4.getCursorCode = false;
                        _this4.getCursor = false;

                        clearInterval(_this4.countdown.timer);
                        _this4.countdown.timer = null;
                        _this4.countdown.counts = _this4.hint;
                    }
                }, 1000);
            }
        },

        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.mobilPhone = e.target.value;
            }
            this.getCursor = true;
            this.isBindPhotoTxtShow = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.mobilPhone == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isAllSuccess();
                return;
            } else if (this.mobilPhone && this.mobilPhone.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.mobilPhone)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isAllSuccess();
                return;
            } else if (this.countdown.counts !== this.hint) {
                this.isBindPhotoTxtShow = false;
                this.bindPhotoTxt = 'waring';
                this.getCursor = true;
                return;
            } else {
                this.isBindPhotoTxtShow = false;
                this.bindPhotoTxt = 'waring';
                this.getCursor = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//验证码组件





/* harmony default export */ var view_login = ({
    components: {
        photoCode: src_components_code
    },
    data: function data() {
        return {
            isDisabled: true,
            isAllRrquridSuccess: false,
            toastMsg: '',
            hint: "发送验证码",
            photoCode: '',
            mobilPhone: "",
            getCursor: true, //验证码不可点击样式
            bindPhotoTxt: 'waring',
            isBindPhotoTxtShow: false,
            isBindPhotoError: false,
            photoCodeBool: false,
            verifyCode: '',
            // 验证码
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            loginParams: {
                countryCode: "CN",
                mobile: "18917309999", //this.mobilePhone
                countryNo: "86",
                projectId: "HSBC", //项目ID
                verifyCode: '',
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            bankCode: hashmap.get('bankCode'),
            //倒计时
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: ""
            },
            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: true
        };
    },
    mounted: function mounted() {
        this.countdown.counts = this.hint;
        if (!this.bankCode) {
            this.$router.push('/index');
        }
        this.getImage();
    },

    methods: {
        // 获取图形验证码
        getImage: function getImage() {
            var _this = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this.imgSrc = result.data.responseData.verCode;
                _this.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },
        btnBack: function btnBack() {
            this.$router.push('/index');
        },
        getPhotoCode: function getPhotoCode(val) {
            this.loginParams.verifyCode = val; // 判断是否全部为空
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.loginParams.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
                return true;
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (this.isBindPhotoError === false && this.isBindPhotoTxtShow === false) {
                this.isAllRrquridSuccess = false;
                return true;
            } else {
                this.isAllRrquridSuccess = true;
                window.scrollTo(0, 0);
                return false;
            }
        },
        getdata: function getdata() {
            var _this2 = this;

            this.loginParams.mobile = this.mobilPhone;
            dataBase_login(this.loginParams).then(function (result) {
                if (result.responseCode === "000000") {
                    hashmap.set('application_id', result.responseData.loanOrderCode);
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    _this2.$router.push({
                        path: url,
                        query: {
                            code: result.responseData.fbCode,
                            loanOrderCode: result.responseData.loanOrderCode,
                            fromType: result.responseData.fromType,
                            rejectDueDate: result.responseData.rejectDueDate || '', //审批拒绝日期提示
                            reApplyBtn: result.responseData.reApplyBtn || '' //审批拒绝按钮显示不显示
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this2.isBindPhotoError = true;
                    _this2.isAllSuccess();
                    _this2.toastMsg = result.responseMessage;
                }
            });
        },
        login: function login() {
            this.portalType = "login";
            this.verMobilePhone(1);
            this.verPhotoCode();
            var isver = this.isAllSuccess();
            if (isver) {
                this.getdata();
            }
        },
        register: function register() {
            this.portalType = "register";
            this.getdata();
        },
        getVerifyCode: function getVerifyCode() {
            var _this3 = this;

            //是否在倒计时
            if (this.countdown.counts === this.hint) {
                this.valiCodeParams.mobile = this.mobilPhone;
                this.valiCodeParams.verCode = this.verCode;
                this.valiCodeParams.uuId = this.uuId;
                getLoginPhoneValidCode(this.valiCodeParams).then(function (result) {
                    if (result.responseCode === "000000") {
                        _this3.isDisabled = false;

                        //开始倒计时
                        _this3.countdownTime();
                        // this.showToast("验证码获取成功！") 尼古拉斯说这个提示不要
                        // clearInterval(this.countdown.timer);
                    }
                });
            }
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this4 = this;

            if (!this.countdown.timer) {
                //开始计时  按钮不可点击
                this.getCursorCode = true;
                this.getCursor = true;
                //初始化 计时器时间
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this4.countdown.count > 0 && _this4.countdown.count <= _this4.countdown.TIME_COUNT) {
                        _this4.countdown.counts = "重发验证码（" + _this4.countdown.count + "s）";
                        _this4.countdown.count--;
                    } else {
                        //计时结束 按钮可以点击
                        _this4.getCursorCode = false;
                        _this4.getCursor = false;

                        clearInterval(_this4.countdown.timer);
                        _this4.countdown.timer = null;
                        _this4.countdown.counts = _this4.hint;
                    }
                }, 1000);
            }
        },

        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.mobilPhone = e.target.value;
            }
            this.getCursor = true;
            this.isBindPhotoTxtShow = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.mobilPhone == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isAllSuccess();
                return;
            } else if (this.mobilPhone && this.mobilPhone.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.mobilPhone)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isAllSuccess();
                return;
            } else if (this.countdown.counts !== this.hint) {
                this.isBindPhotoTxtShow = false;
                this.bindPhotoTxt = 'waring';
                this.getCursor = true;
                return;
            } else {
                this.isBindPhotoTxtShow = false;
                this.bindPhotoTxt = 'waring';
                this.getCursor = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e942882","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoTxtShow),expression:"isBindPhotoTxtShow"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhotoTxtShow","aria-label":'错误提示，'+_vm.bindPhotoTxt}},[_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhotoError","aria-label":'错误提示，'+_vm.toastMsg}},[_vm._v(_vm._s(_vm.toastMsg))])])])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"photo"}},[_vm._v("手机号码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"isBindPhotoTxtShow"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.mobilPhone),expression:"mobilPhone",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"type":"tel","onkeyup":"this.value=this.value.replace(/\\D/g,'')","onblur":"this.value=this.value.replace(/\\D/g,'')","id":"photo","aria-invalid":"true","aria-describedby":"HelpText","maxlength":"11","placeholder":"请填写电话号码"},domProps:{"value":(_vm.mobilPhone)},on:{"keyup":_vm.verMobilePhone,"input":function($event){if($event.target.composing){ return; }_vm.mobilPhone=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoTxtShow),expression:"isBindPhotoTxtShow"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText","aria-label":'错误提示，'+_vm.bindPhotoTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.bindPhotoTxt))]),_vm._v(" "),_c('div',{staticClass:"global-requrid-tip"},[_vm._v("只⽀持注册在中国内地的手机号。")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.getVerCode},attrs:{"type":"button","disabled":_vm.getVerCode,"aria-live":"polite","aria-atomic":"true"},on:{"click":_vm.getImage}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"验证码，激活刷新"}})])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"photo"}},[_vm._v("图形验证码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"labelVerText"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.verCode),expression:"verCode",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"disabled":_vm.getVerCode,"maxlength":"4","id":"verCode","aria-invalid":"true","aria-describedby":"HelpText","placeholder":"请填写图形验证码"},domProps:{"value":(_vm.verCode)},on:{"blur":[_vm.verCodeChange,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.verCode=$event.target.value.trim()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，'+_vm.verCodeErrorText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(this.verCodeErrorText))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.getCursor},attrs:{"type":"button","disabled":_vm.getCursorCode || _vm.getCursor,"aria-live":"polite","aria-atomic":"true"},on:{"click":_vm.getVerifyCode}},[_vm._v(_vm._s(_vm.countdown.counts))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('photo-code',{attrs:{"isDisabled":_vm.isDisabled,"photoCodeBool":_vm.photoCodeBool}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，'+_vm.toastMsg}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.toastMsg))]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary mg-r",on:{"click":_vm.login}},[_vm._v("登录")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-default",attrs:{"type":"button"},on:{"click":_vm.btnBack}},[_vm._v("返回注册")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})],1)}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-title-wrap"},[_c('h1',{staticClass:"title"},[_vm._v("申请人登录")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请输入您注册使用的手机号码继续您的预申请。")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isVerCodeError"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhotoError"}})])}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_login = (login_esExports);
// CONCATENATED MODULE: ./src/view/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("WPfM")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-0e942882"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  view_login,
  selectortype_template_index_0_src_view_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_view_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/components/stepDescription6000.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import provinceBankJson from '@/assets/api/bank.json'





/* harmony default export */ var stepDescription6000 = ({
    components: {
        photoCode: src_components_code,
        Alert: src_components_alert
    },
    data: function data() {
        return {
            // provinceBankJson: [],

            isGender: false,
            isChannelAgent: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt: 'waring', //负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            lastNameText: '姓名不能为空！',
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg: 'waring',
            sendInfo: {
                bankCode: hashmap.get('bankCode'),

                verifyCode: '', //验证码

                gender: '', //性别
                channelAgent: '', //客户经理推荐号
                // caUser:'', // 客户推荐手机号
                corpName: '', //借款人经营主体
                productCode: hashmap.get('productCode'), //贷款产品
                loanAmt: '', //贷款额度

                userNamePY: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '', // 名

                idCardNum: '', //身份证号码
                bankNum: '', // 银行卡
                mobile: '', //手机号
                stream: hashmap.get('stream') ? hashmap.get('stream') : ''

            },
            //倒计时
            isSendPhone: false,
            isSendCode: true, //发送验证码按钮不可点击样式
            hint: '发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo: {
                checked01: false,
                checked02: false,
                checked07: false,
                checked08: false,
                checked09: false,
                checked10: false

                // checked03: false,
            },
            isCheckBox: false,
            isChecked: false,
            isCheckedp: false, // 个人选中
            isLoanAmt: false,
            lastNEng: "",
            firstNEng: "",

            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode: false,
            // 小微贷款修改---
            textList: [],
            productCode: localStorage.getItem('productCode'),
            corpNameTxt: "waring",
            iscorpName: false,
            loanAmtTxt: ""
        };
    },
    mounted: function mounted() {
        // this.inif()
        this.getImage();
    },
    created: function created() {
        var _this = this;

        // this.provinceBankJson = provinceBankJson
        text_default.a.map(function (item, index) {
            if (_this.productCode === item.code) {
                _this.textList = item;
                return;
            }
            return;
        });
        console.log(this.textList);
    },

    methods: {
        inif: function inif() {
            var _this2 = this;

            pageDetailLoad({ 'fbCode': '0016' }).then(function (result) {
                if (result.responseCode === "000000") {
                    var responseData = result.responseData;
                    hashmap.set('application_id', responseData.loanOrderCode);
                    _this2.sendInfo.bankNum = responseData.cardNum || '';
                    _this2.sendInfo.mobile = responseData.mobile || '';

                    _this2.sendInfo.lastName = responseData.lastName || '';
                    _this2.sendInfo.firstName = responseData.firstName || '';
                    _this2.sendInfo.lastNameEng = responseData.lastNameEng || '';
                    _this2.sendInfo.firstNameEng = responseData.firstNameEng || '';
                }
            });
        },

        // 获取图形验证码
        getImage: function getImage() {
            var _this3 = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this3.imgSrc = result.data.responseData.verCode;
                _this3.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },

        // 贷款额度
        loanAmtVal: function loanAmtVal(e) {
            if (e.target) {
                this.sendInfo.loanAmt = e.target.value;
            }

            this.isLoanAmt = true;

            if (Number(this.sendInfo.loanAmt) > 1000) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能大于1000万元';
                return;
            } else if (Number(this.sendInfo.loanAmt) <= 0) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能小于等于0';
                return;
            } else if (this.sendInfo.loanAmt === '') {
                console.log('贷款额度不能为空！');
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能为空！';
                this.isAllSuccess();
                return;
            }

            this.isLoanAmt = false;
            this.loanAmtTxt = 'waring';
            this.isAllSuccess();
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/index"
            });
            return false;
        },

        //验证码
        getPhotoCode: function getPhotoCode(val) {
            this.sendInfo.verifyCode = val;
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                if (!this.sendInfo.lastName) {
                    this.isAllSuccess();
                    this.verlastNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
                if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                    this.sendInfo.lastNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verlastNamePY();
                this.lastNEng = PinYin;
            }
        },
        verName: function verName() {

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.firstName) {
                    this.isAllSuccess();
                    this.verNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
                if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                    this.sendInfo.firstNameEng = PinYin;
                }

                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verNamePY();
                this.firstNEng = PinYin;
            }
        },

        // 身份证校验
        verificationIdCoder: function verificationIdCoder() {
            var sex = null;
            this.isCardId = true;
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            if (this.sendInfo.idCardNum.length === 0) {
                this.cardIdTxt = "身份证号不能为空！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.idCardNum.length && this.sendInfo.idCardNum.length < 18) {
                this.cardIdTxt = "身份证号长度不够！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!this.sendInfo.idCardNum || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(this.sendInfo.idCardNum)) {
                this.cardIdTxt = "身份证号格式有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!city[this.sendInfo.idCardNum.substr(0, 2)]) {
                this.cardIdTxt = "地址编码有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else {
                //18位身份证需要验证最后一位校验位
                if (this.sendInfo.idCardNum.length === 18) {
                    var Code = this.sendInfo.idCardNum.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    //校验位
                    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++) {
                        ai = Code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];

                    if (parity[sum % 11] != Code[17]) {
                        this.cardIdTxt = "身份证号不正确！";
                        this.sendInfo.gender = '';
                        this.isAllSuccess();
                        return;
                    }

                    sex = this.sendInfo.idCardNum.substring(16, 17);
                } else {
                    sex = this.sendInfo.idCardNum.substring(13, 14);
                }
            }
            if (sex % 2 === 0) {
                this.sendInfo.gender = '02';
            } else {
                this.sendInfo.gender = '01';
            }
            this.isCardId = false;
            this.cardIdTxt = "waring";
            this.isAllSuccess();
        },
        vercorpName: function vercorpName(e) {
            if (e.target) {
                this.sendInfo.corpName = e.target.value;
            }
            this.iscorpName = true;
            if (this.sendInfo.corpName === '') {
                this.corpNameTxt = '借款人经营主体不能为空！';
                this.isAllSuccess();
                return;
            }
            this.iscorpName = false;
            this.corpNameTxt = 'waring';
            this.isAllSuccess();
        },

        //银行卡校验
        verBankCard: function verBankCard(e) {
            if (e.target) {
                this.sendInfo.bankNum = e.target.value;
            }
            this.isBankCard = true;
            if (this.sendInfo.bankNum === '') {
                this.bankCardTxt = '银行卡号不能为空！';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.bankNum && this.sendInfo.bankNum.length < 13) {
                this.bankCardTxt = '银行卡位数有误！';
                this.isAllSuccess();
                return;
            }
            this.isBankCard = false;
            this.bankCardTxt = 'waring';
            this.isAllSuccess();
        },

        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.sendInfo.mobile = e.target.value;
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.sendInfo.mobile == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.mobile && this.sendInfo.mobile.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.sendInfo.mobile)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess();
        },

        //获取验证码
        getVerifyCode: function getVerifyCode() {
            var _this4 = this;

            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode = this.verCode;
            this.valiCodeParams.uuId = this.uuId;
            getValiCode(this.valiCodeParams).then(function (result) {
                if (result.responseCode === "000000") {

                    _this4.isDisabled = false;

                    //开始倒计时
                    _this4.countdownTime();

                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                } else if (result.responseCode == "000405") {
                    _this4.isVerCodeError = true;
                    _this4.isDisabled = true;
                    _this4.isAllSuccess();
                    _this4.verCodeErrorText = result.responseMessage;
                }
            });
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this5 = this;

            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.imageValidCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this5.countdown.count > 0 && _this5.countdown.count <= _this5.countdown.TIME_COUNT) {
                        _this5.countdown.counts = '重发验证码（' + _this5.countdown.count + "s）";
                        _this5.countdown.count--;
                    } else {
                        clearInterval(_this5.countdown.timer);
                        _this5.imageValidCode = false;
                        _this5.getCursorCode = false;
                        _this5.countdown.timer = null;
                        _this5.countdown.counts = _this5.hint;
                        _this5.isSendPhone = false;
                        _this5.isSendCode = false;
                    }
                }, 1000);
            }
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.sendInfo.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
            }
        },


        //四要素认证
        callFourEleCheck: function callFourEleCheck() {
            var _this6 = this;

            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC';
            this.sendInfo.appName = "00PACIFIC";

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret;
            // 授权协议
            // this.sendInfo.cup1002 = this.verNoticeInfo.checked01,
            // this.sendInfo.type1004 = this.verNoticeInfo.checked02,
            if (this.productCode === '6000') {
                this.sendInfo.type1007 = this.verNoticeInfo.checked07;
                this.sendInfo.type1008 = this.verNoticeInfo.checked08;
                this.sendInfo.type1009 = this.verNoticeInfo.checked09;
            } else if (this.productCode === '7000') {
                this.sendInfo.type1012 = this.verNoticeInfo.checked07;
                this.sendInfo.type1013 = this.verNoticeInfo.checked08;
                this.sendInfo.type1014 = this.verNoticeInfo.checked09;
                this.sendInfo.type1015 = this.verNoticeInfo.checked10;
            }

            hashmap.set('sendInfo', this.sendInfo);
            console.log('sendInfo------------', this.sendInfo);
            fourEleCheck(this.sendInfo).then(function (result) {
                _this6.isBindPhotoError = false;
                _this6.isAllRrquridSuccess = false;
                if (result.responseCode === "000000") {
                    hashmap.set('application_id', result.responseData.loanOrderCode);
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var loginName = result.responseData.loginName || '';
                    var retryBtn = result.responseData.retryBtn || '';
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage, //认证失败还有所少次变化 后端返回
                            retryBtn: retryBtn, // '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName: loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this6.isBindPhotoError = true;
                    _this6.toastMsg = result.responseMessage;
                    _this6.isAllRrquridSuccess = true;

                    window.scrollTo(0, 0);
                }
            });
        },

        // 下一步
        pass: function pass() {
            console.log(this.sendInfo);
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            this.verificationIdCoder();
            this.verBankCard(1);
            this.verMobilePhone(1);
            this.verPhotoCode();
            this.loanAmtVal(1);

            // this.verNotice()
            this.verNoticeBox();
            this.genderChange();

            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.callFourEleCheck();
            } else {
                window.scrollTo(0, 0);
            }
        },
        genderChange: function genderChange() {
            if (!this.sendInfo.gender) {
                this.isGender = true;
                this.isAllSuccess();
            } else {
                this.isGender = false;
                this.isAllSuccess();
            }
        },
        isAllSuccess: function isAllSuccess() {

            if (!this.isCheckBox && !this.isChecked && !this.isCardId && !this.isUserName && !this.isUserNamePY && !this.isBankCard && !this.isBindPhoto && !this.isBindPhotoError && !this.isGender && !this.isVerCodeError && !this.isLoanAmt) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },
        spaceEvent: function spaceEvent(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },
        keyEvent: function keyEvent(e) {
            if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                var a = void 0;
                if (e.currentTarget.previousElementSibling.value == '01') {
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0];
                } else {
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0];
                }
                a.focus();
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            } else {
                return;
            }
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },

        //认证须知校验
        verNotice: function verNotice() {
            debugger;
            if (this.verNoticeInfo.checked02 === false) {
                this.isChecked = true;
                this.isAllSuccess();
            } else {
                this.isChecked = false;
                this.isAllSuccess();
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.verNoticeInfo.checked07 === false || this.verNoticeInfo.checked08 === false || this.verNoticeInfo.checked09 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/components/stepDescription6000.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import provinceBankJson from '@/assets/api/bank.json'





/* harmony default export */ var components_stepDescription6000 = ({
    components: {
        photoCode: src_components_code,
        Alert: src_components_alert
    },
    data: function data() {
        return {
            // provinceBankJson: [],

            isGender: false,
            isChannelAgent: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt: 'waring', //负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            lastNameText: '姓名不能为空！',
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg: 'waring',
            sendInfo: {
                bankCode: hashmap.get('bankCode'),

                verifyCode: '', //验证码

                gender: '', //性别
                channelAgent: '', //客户经理推荐号
                // caUser:'', // 客户推荐手机号
                corpName: '', //借款人经营主体
                productCode: hashmap.get('productCode'), //贷款产品
                loanAmt: '', //贷款额度

                userNamePY: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '', // 名

                idCardNum: '', //身份证号码
                bankNum: '', // 银行卡
                mobile: '', //手机号
                stream: hashmap.get('stream') ? hashmap.get('stream') : ''

            },
            //倒计时
            isSendPhone: false,
            isSendCode: true, //发送验证码按钮不可点击样式
            hint: '发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo: {
                checked01: false,
                checked02: false,
                checked07: false,
                checked08: false,
                checked09: false,
                checked10: false

                // checked03: false,
            },
            isCheckBox: false,
            isChecked: false,
            isCheckedp: false, // 个人选中
            isLoanAmt: false,
            lastNEng: "",
            firstNEng: "",

            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode: false,
            // 小微贷款修改---
            textList: [],
            productCode: localStorage.getItem('productCode'),
            corpNameTxt: "waring",
            iscorpName: false,
            loanAmtTxt: ""
        };
    },
    mounted: function mounted() {
        // this.inif()
        this.getImage();
    },
    created: function created() {
        var _this = this;

        // this.provinceBankJson = provinceBankJson
        text_default.a.map(function (item, index) {
            if (_this.productCode === item.code) {
                _this.textList = item;
                return;
            }
            return;
        });
        console.log(this.textList);
    },

    methods: {
        inif: function inif() {
            var _this2 = this;

            pageDetailLoad({ 'fbCode': '0016' }).then(function (result) {
                if (result.responseCode === "000000") {
                    var responseData = result.responseData;
                    hashmap.set('application_id', responseData.loanOrderCode);
                    _this2.sendInfo.bankNum = responseData.cardNum || '';
                    _this2.sendInfo.mobile = responseData.mobile || '';

                    _this2.sendInfo.lastName = responseData.lastName || '';
                    _this2.sendInfo.firstName = responseData.firstName || '';
                    _this2.sendInfo.lastNameEng = responseData.lastNameEng || '';
                    _this2.sendInfo.firstNameEng = responseData.firstNameEng || '';
                }
            });
        },

        // 获取图形验证码
        getImage: function getImage() {
            var _this3 = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this3.imgSrc = result.data.responseData.verCode;
                _this3.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },

        // 贷款额度
        loanAmtVal: function loanAmtVal(e) {
            if (e.target) {
                this.sendInfo.loanAmt = e.target.value;
            }

            this.isLoanAmt = true;

            if (Number(this.sendInfo.loanAmt) > 1000) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能大于1000万元';
                return;
            } else if (Number(this.sendInfo.loanAmt) <= 0) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能小于等于0';
                return;
            } else if (this.sendInfo.loanAmt === '') {
                console.log('贷款额度不能为空！');
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能为空！';
                this.isAllSuccess();
                return;
            }

            this.isLoanAmt = false;
            this.loanAmtTxt = 'waring';
            this.isAllSuccess();
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/index"
            });
            return false;
        },

        //验证码
        getPhotoCode: function getPhotoCode(val) {
            this.sendInfo.verifyCode = val;
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                if (!this.sendInfo.lastName) {
                    this.isAllSuccess();
                    this.verlastNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
                if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                    this.sendInfo.lastNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verlastNamePY();
                this.lastNEng = PinYin;
            }
        },
        verName: function verName() {

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.firstName) {
                    this.isAllSuccess();
                    this.verNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
                if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                    this.sendInfo.firstNameEng = PinYin;
                }

                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verNamePY();
                this.firstNEng = PinYin;
            }
        },

        // 身份证校验
        verificationIdCoder: function verificationIdCoder() {
            var sex = null;
            this.isCardId = true;
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            if (this.sendInfo.idCardNum.length === 0) {
                this.cardIdTxt = "身份证号不能为空！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.idCardNum.length && this.sendInfo.idCardNum.length < 18) {
                this.cardIdTxt = "身份证号长度不够！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!this.sendInfo.idCardNum || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(this.sendInfo.idCardNum)) {
                this.cardIdTxt = "身份证号格式有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!city[this.sendInfo.idCardNum.substr(0, 2)]) {
                this.cardIdTxt = "地址编码有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else {
                //18位身份证需要验证最后一位校验位
                if (this.sendInfo.idCardNum.length === 18) {
                    var Code = this.sendInfo.idCardNum.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    //校验位
                    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++) {
                        ai = Code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];

                    if (parity[sum % 11] != Code[17]) {
                        this.cardIdTxt = "身份证号不正确！";
                        this.sendInfo.gender = '';
                        this.isAllSuccess();
                        return;
                    }

                    sex = this.sendInfo.idCardNum.substring(16, 17);
                } else {
                    sex = this.sendInfo.idCardNum.substring(13, 14);
                }
            }
            if (sex % 2 === 0) {
                this.sendInfo.gender = '02';
            } else {
                this.sendInfo.gender = '01';
            }
            this.isCardId = false;
            this.cardIdTxt = "waring";
            this.isAllSuccess();
        },
        vercorpName: function vercorpName(e) {
            if (e.target) {
                this.sendInfo.corpName = e.target.value;
            }
            this.iscorpName = true;
            if (this.sendInfo.corpName === '') {
                this.corpNameTxt = '借款人经营主体不能为空！';
                this.isAllSuccess();
                return;
            }
            this.iscorpName = false;
            this.corpNameTxt = 'waring';
            this.isAllSuccess();
        },

        //银行卡校验
        verBankCard: function verBankCard(e) {
            if (e.target) {
                this.sendInfo.bankNum = e.target.value;
            }
            this.isBankCard = true;
            if (this.sendInfo.bankNum === '') {
                this.bankCardTxt = '银行卡号不能为空！';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.bankNum && this.sendInfo.bankNum.length < 13) {
                this.bankCardTxt = '银行卡位数有误！';
                this.isAllSuccess();
                return;
            }
            this.isBankCard = false;
            this.bankCardTxt = 'waring';
            this.isAllSuccess();
        },

        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.sendInfo.mobile = e.target.value;
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.sendInfo.mobile == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.mobile && this.sendInfo.mobile.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.sendInfo.mobile)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess();
        },

        //获取验证码
        getVerifyCode: function getVerifyCode() {
            var _this4 = this;

            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode = this.verCode;
            this.valiCodeParams.uuId = this.uuId;
            getValiCode(this.valiCodeParams).then(function (result) {
                if (result.responseCode === "000000") {

                    _this4.isDisabled = false;

                    //开始倒计时
                    _this4.countdownTime();

                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                } else if (result.responseCode == "000405") {
                    _this4.isVerCodeError = true;
                    _this4.isDisabled = true;
                    _this4.isAllSuccess();
                    _this4.verCodeErrorText = result.responseMessage;
                }
            });
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this5 = this;

            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.imageValidCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this5.countdown.count > 0 && _this5.countdown.count <= _this5.countdown.TIME_COUNT) {
                        _this5.countdown.counts = '重发验证码（' + _this5.countdown.count + "s）";
                        _this5.countdown.count--;
                    } else {
                        clearInterval(_this5.countdown.timer);
                        _this5.imageValidCode = false;
                        _this5.getCursorCode = false;
                        _this5.countdown.timer = null;
                        _this5.countdown.counts = _this5.hint;
                        _this5.isSendPhone = false;
                        _this5.isSendCode = false;
                    }
                }, 1000);
            }
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.sendInfo.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
            }
        },


        //四要素认证
        callFourEleCheck: function callFourEleCheck() {
            var _this6 = this;

            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC';
            this.sendInfo.appName = "00PACIFIC";

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret;
            // 授权协议
            // this.sendInfo.cup1002 = this.verNoticeInfo.checked01,
            // this.sendInfo.type1004 = this.verNoticeInfo.checked02,
            if (this.productCode === '6000') {
                this.sendInfo.type1007 = this.verNoticeInfo.checked07;
                this.sendInfo.type1008 = this.verNoticeInfo.checked08;
                this.sendInfo.type1009 = this.verNoticeInfo.checked09;
            } else if (this.productCode === '7000') {
                this.sendInfo.type1012 = this.verNoticeInfo.checked07;
                this.sendInfo.type1013 = this.verNoticeInfo.checked08;
                this.sendInfo.type1014 = this.verNoticeInfo.checked09;
                this.sendInfo.type1015 = this.verNoticeInfo.checked10;
            }

            hashmap.set('sendInfo', this.sendInfo);
            console.log('sendInfo------------', this.sendInfo);
            fourEleCheck(this.sendInfo).then(function (result) {
                _this6.isBindPhotoError = false;
                _this6.isAllRrquridSuccess = false;
                if (result.responseCode === "000000") {
                    hashmap.set('application_id', result.responseData.loanOrderCode);
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var loginName = result.responseData.loginName || '';
                    var retryBtn = result.responseData.retryBtn || '';
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage, //认证失败还有所少次变化 后端返回
                            retryBtn: retryBtn, // '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName: loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this6.isBindPhotoError = true;
                    _this6.toastMsg = result.responseMessage;
                    _this6.isAllRrquridSuccess = true;

                    window.scrollTo(0, 0);
                }
            });
        },

        // 下一步
        pass: function pass() {
            console.log(this.sendInfo);
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            this.verificationIdCoder();
            this.verBankCard(1);
            this.verMobilePhone(1);
            this.verPhotoCode();
            this.loanAmtVal(1);

            // this.verNotice()
            this.verNoticeBox();
            this.genderChange();

            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.callFourEleCheck();
            } else {
                window.scrollTo(0, 0);
            }
        },
        genderChange: function genderChange() {
            if (!this.sendInfo.gender) {
                this.isGender = true;
                this.isAllSuccess();
            } else {
                this.isGender = false;
                this.isAllSuccess();
            }
        },
        isAllSuccess: function isAllSuccess() {

            if (!this.isCheckBox && !this.isChecked && !this.isCardId && !this.isUserName && !this.isUserNamePY && !this.isBankCard && !this.isBindPhoto && !this.isBindPhotoError && !this.isGender && !this.isVerCodeError && !this.isLoanAmt) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },
        spaceEvent: function spaceEvent(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },
        keyEvent: function keyEvent(e) {
            if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                var a = void 0;
                if (e.currentTarget.previousElementSibling.value == '01') {
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0];
                } else {
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0];
                }
                a.focus();
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            } else {
                return;
            }
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },

        //认证须知校验
        verNotice: function verNotice() {
            debugger;
            if (this.verNoticeInfo.checked02 === false) {
                this.isChecked = true;
                this.isAllSuccess();
            } else {
                this.isChecked = false;
                this.isAllSuccess();
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.verNoticeInfo.checked07 === false || this.verNoticeInfo.checked08 === false || this.verNoticeInfo.checked09 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d35f61d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/stepDescription6000.vue
var stepDescription6000_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verified"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.textList.setup_title))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.textList.setup_desc))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserName","aria-label":'错误提示，'+ _vm.lastNameText}},[_vm._v(_vm._s(_vm.lastNameText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserNamePY),expression:"isUserNamePY"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserNamePY","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_vm._v("姓名（英文/拼音）不能为空！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCardId),expression:"isCardId"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCardId","aria-label":'错误提示，' + _vm.cardIdTxt}},[_vm._v(_vm._s(_vm.cardIdTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBankCard),expression:"isBankCard"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBankCard","aria-label":'错误提示，' + _vm.bankCardTxt}},[_vm._v(_vm._s(_vm.bankCardTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhoto),expression:"isBindPhoto"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhoto","aria-label":'错误提示，' + _vm.bindPhotoTxt}},[_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhotoError","aria-label":'错误提示，'+ _vm.toastMsg}},[_vm._v(_vm._s(_vm.toastMsg))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGender),expression:"isGender"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isGender","aria-label":"错误提示，请选择性别！"}},[_vm._v("请选择性别！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isVerCodeError","aria-label":'错误提示，'+_vm.verCodeErrorText}},[_vm._v(_vm._s(_vm.verCodeErrorText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.iscorpName),expression:"iscorpName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#iscorpName","aria-label":'错误提示，' + _vm.corpNameTxt}},[_vm._v(_vm._s(_vm.corpNameTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoanAmt),expression:"isLoanAmt"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isLoanAmt","aria-label":'错误提示，' + _vm.loanAmtTxt}},[_vm._v(_vm._s(_vm.loanAmtTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCheckBox","aria-label":"错误提示，请阅读授权及声明的内容并勾选！"}},[_vm._v("请阅读授权及声明的内容并勾选！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChecked),expression:"isChecked"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isChecked","aria-label":"错误提示，请阅读完毕后勾选作出授权！"}},[_vm._v("请阅读完毕后勾选作出授权！")])])])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-con-black"},[_c('h2',{staticClass:"global-subtitle"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),(_vm.productCode == '7000')?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"corpName"}},[_vm._v("借款申请主体：")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"iscorpName"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.corpName),expression:"sendInfo.corpName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.iscorpName},attrs:{"type":"text","aria-invalid":"true","aria-describedby":"cropText","id":"corpName","placeholder":"请输入经营主体营业执照名称"},domProps:{"value":(_vm.sendInfo.corpName)},on:{"blur":[_vm.vercorpName,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "corpName", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.iscorpName),expression:"iscorpName"}],staticClass:"global-requrid-feedback",attrs:{"id":"cropText","aria-label":'错误提示，' + _vm.corpNameTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.corpNameTxt))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"loanAmt"}},[_vm._v("您需要申请的贷款额度（万元）：")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isLoanAmt"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.loanAmt),expression:"sendInfo.loanAmt",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isLoanAmt},attrs:{"type":"number","min":"0","max":"1000","step":"1","aria-describedby":"isLoanAmt","onkeyup":"this.value=this.value.replace(/\\s/g,'')","id":"loanAmt","placeholder":"请输入贷款额度","aria-invalid":"true"},domProps:{"value":(_vm.sendInfo.loanAmt)},on:{"blur":[function($event){return _vm.loanAmtVal(_vm.sendInfo.loanAmt)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "loanAmt", $event.target.value.trim())}}}),_vm._v(" "),(_vm.isLoanAmt)?_c('div',{staticClass:"global-requrid-feedback",attrs:{"id":"isLoanAmt"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.loanAmtTxt))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"channelAgent"}},[_vm._v("客户经理推荐号（选填）：")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.channelAgent),expression:"sendInfo.channelAgent",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"id":"channelAgent","type":"text","onkeyup":"this.value=this.value.replace(/\\s/g,'')","placeholder":"请输入客户经理推荐号","aria-invalid":"true"},domProps:{"value":(_vm.sendInfo.channelAgent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "channelAgent", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),(_vm.productCode == '6000')?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"corpName2"}},[_vm._v("借款人经营主体（选填）：")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.corpName),expression:"sendInfo.corpName",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"id":"corpName2","type":"text","placeholder":"请输入经营主体营业执照名称","aria-invalid":"true"},domProps:{"value":(_vm.sendInfo.corpName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "corpName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v(_vm._s(_vm.textList.setup_title2))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserName"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('label',{attrs:{"for":"lName"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastName),expression:"sendInfo.lastName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"id":"lName","aria-labelledby":"chineseNameR","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastName)},on:{"change":_vm.verlastName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('label',{attrs:{"for":"fName"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstName),expression:"sendInfo.firstName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"id":"fName","aria-labelledby":"chineseNameL","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstName)},on:{"change":_vm.verName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1","aria-label":'错误提示，'+ _vm.lastNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.lastNameText))])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserNamePY"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastNameEng),expression:"sendInfo.lastNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserNamePY},attrs:{"id":"lNameEng","aria-labelledby":"englishNameR","onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText2","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastNameEng)},on:{"blur":[_vm.verlastNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastNameEng", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstNameEng),expression:"sendInfo.firstNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserNamePY},attrs:{"id":"fNameEng","aria-labelledby":"englishNameL","onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText2","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstNameEng)},on:{"blur":[_vm.verNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstNameEng", $event.target.value.trim())}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserNamePY),expression:"isUserNamePY"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText2","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("姓名（英文/拼音）不能为空！")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"cardId"}},[_vm._v("身份证号码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"isCardId"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.idCardNum),expression:"sendInfo.idCardNum",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isCardId},attrs:{"onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText3","type":"text","id":"cardId","maxlength":"18","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.idCardNum)},on:{"blur":[_vm.verificationIdCoder,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "idCardNum", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCardId),expression:"isCardId"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText3","aria-label":'错误提示，' + _vm.cardIdTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.cardIdTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap",attrs:{"role":"radiogroup","aria-labelledby":"HelpText8"}},[_c('label',{staticClass:"global-lable"},[_vm._v("性别")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor"}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"gender"},[_c('div',{staticClass:"radio-margin-no-top over-flow-hidden"},[_c('label',{staticClass:"global-radioLab",attrs:{"for":"gender1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendInfo.gender),expression:"sendInfo.gender"}],staticClass:"global-radioInp",attrs:{"id":"gender1","aria-describedby":"HelpText8","type":"radio","tabindex":"-1","name":"gender","value":"01"},domProps:{"checked":_vm._q(_vm.sendInfo.gender,"01")},on:{"change":[function($event){return _vm.$set(_vm.sendInfo, "gender", "01")},_vm.genderChange]}}),_vm._v(" "),_c('span',{staticClass:"global-radioSpa",attrs:{"role":"radio","aria-checked":"true","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEvent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEvent.apply(null, arguments)},_vm.keyEvent]}}),_vm._v("\n                        男\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"over-flow-hidden"},[_c('label',{staticClass:"global-radioLab",attrs:{"for":"gender2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendInfo.gender),expression:"sendInfo.gender"}],staticClass:"global-radioInp",attrs:{"id":"gender2","aria-describedby":"HelpText8","type":"radio","tabindex":"-1","name":"gender","value":"02"},domProps:{"checked":_vm._q(_vm.sendInfo.gender,"02")},on:{"change":[function($event){return _vm.$set(_vm.sendInfo, "gender", "02")},_vm.genderChange]}}),_vm._v(" "),_c('span',{staticClass:"global-radioSpa",attrs:{"role":"radio","aria-checked":"true","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEvent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEvent.apply(null, arguments)},_vm.keyEvent]}}),_vm._v("\n                        女\n                    ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGender),expression:"isGender"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText8","aria-label":"错误提示，请选择性别！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择性别！")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("银行卡信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"bankCard"}},[_vm._v("银行卡号")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBankCard"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"verified-bank-tip"},[_vm._v("\n                请输入您持有的带有中国银联标志的中国内地银行卡卡号及该卡的预留手机号码，您点击发送验证码即视为您同意并授权汇丰村镇银行向中国银联股份有限公司提供您的姓名、身份证号、银联卡卡号及手机号码用于身份验证。\n            ")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.bankNum),expression:"sendInfo.bankNum",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isBankCard},attrs:{"type":"tel","aria-invalid":"true","aria-describedby":"HelpText4","id":"bankCard","maxlength":"19","onkeyup":"this.value=this.value.replace(/\\D/g,'')","onblur":"this.value=this.value.replace(/\\D/g,'')","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.bankNum)},on:{"blur":[_vm.verBankCard,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "bankNum", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBankCard),expression:"isBankCard"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText4","aria-label":'错误提示，' + _vm.bankCardTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.bankCardTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"bindPhoto"}},[_vm._v("预留手机号")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhoto"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.mobile),expression:"sendInfo.mobile",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isBindPhoto},attrs:{"disabled":_vm.isSendPhone,"aria-invalid":"true","aria-describedby":"HelpText5","type":"tel","maxlength":"11","onkeyup":"this.value=this.value.replace(/\\D/g,'')","onblur":"this.value=this.value.replace(/\\D/g,'')","id":"bindPhoto","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.mobile)},on:{"keyup":_vm.verMobilePhone,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "mobile", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhoto),expression:"isBindPhoto"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText5"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.getVerCode},attrs:{"type":"button","disabled":_vm.getVerCode,"aria-live":"polite","aria-atomic":"true"},on:{"click":_vm.getImage}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"验证码，激活刷新"}})])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"photo"}},[_vm._v("图形验证码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"labelVerText"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.verCode),expression:"verCode",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"disabled":_vm.imageValidCode,"maxlength":"4","id":"verCode","aria-invalid":"true","aria-describedby":"HelpText","placeholder":"请填写图形验证码"},domProps:{"value":(_vm.verCode)},on:{"blur":[_vm.verCodeChange,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.verCode=$event.target.value.trim()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，'+_vm.verCodeErrorText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(this.verCodeErrorText))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.isSendCode||_vm.getCursorCode},attrs:{"type":"button","disabled":_vm.getCursorCode || _vm.isSendCode},on:{"click":_vm.getVerifyCode}},[_vm._v(_vm._s(_vm.countdown.counts))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('photo-code',{attrs:{"isDisabled":_vm.isDisabled,"photoCodeBool":_vm.photoCodeBool}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，' + _vm.toastMsg}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.toastMsg))]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("申请人授权及声明")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请仔细阅读下列内容，勾选作出相应的授权/确认后，点击下一步继续预申请流程。")]),_vm._v(" "),_c('a',{attrs:{"name":"isCheckBox"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText10"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked07),expression:"verNoticeInfo.checked07"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText10","type":"checkbox","tabindex":"-1","value":"true","name":"checked07"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked07)?_vm._i(_vm.verNoticeInfo.checked07,"true")>-1:(_vm.verNoticeInfo.checked07)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked07,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked07", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked07", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked07", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    "+_vm._s(_vm.textList.setup_check0)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText11"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked08),expression:"verNoticeInfo.checked08"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText11","type":"checkbox","tabindex":"-1","value":"true","name":"checked08"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked08)?_vm._i(_vm.verNoticeInfo.checked08,"true")>-1:(_vm.verNoticeInfo.checked08)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked08,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked08", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked08", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked08", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    "+_vm._s(_vm.textList.setup_check1)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked09),expression:"verNoticeInfo.checked09"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText12","type":"checkbox","tabindex":"-1","value":"true","name":"checked09"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked09)?_vm._i(_vm.verNoticeInfo.checked09,"true")>-1:(_vm.verNoticeInfo.checked09)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked09,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked09", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked09", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked09", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                     "+_vm._s(_vm.textList.setup_check2)+"\n                ")])])]),_vm._v(" "),(_vm.productCode === '7000')?_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText13"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked10),expression:"verNoticeInfo.checked10"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText13","type":"checkbox","tabindex":"-1","value":"true","name":"checked10"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked10)?_vm._i(_vm.verNoticeInfo.checked10,"true")>-1:(_vm.verNoticeInfo.checked10)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked10,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked10", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked10", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked10", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                     "+_vm._s(_vm.textList.setup_check3)+"\n                ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText6","aria-label":"错误提示，请阅读授权及声明的内容并勾选！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("\n            请仔细阅读授权及声明的内容，并逐项勾选作出确认，方可继续预申请流程。\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button","data-key":"logon_btn_next","role":"button"},on:{"click":_vm.pass}},[_vm._v("下一步")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-back",attrs:{"type":"button"},on:{"click":_vm.btnBack}},[_vm._v("上一步")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var stepDescription6000_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"chineseNameR"}},[_vm._v("姓（中文）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"chineseNameL"}},[_vm._v("名（中文）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"englishNameR"}},[_vm._v("姓（拼音）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"englishNameL"}},[_vm._v("名（拼音）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isVerCodeError"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhotoError"}})])}]
var stepDescription6000_esExports = { render: stepDescription6000_render, staticRenderFns: stepDescription6000_staticRenderFns }
/* harmony default export */ var view_components_stepDescription6000 = (stepDescription6000_esExports);
// CONCATENATED MODULE: ./src/view/components/stepDescription6000.vue
function stepDescription6000_injectStyle (ssrContext) {
  __webpack_require__("N5GO")
}
var stepDescription6000_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var stepDescription6000___vue_template_functional__ = false
/* styles */
var stepDescription6000___vue_styles__ = stepDescription6000_injectStyle
/* scopeId */
var stepDescription6000___vue_scopeId__ = "data-v-6d35f61d"
/* moduleIdentifier (server only) */
var stepDescription6000___vue_module_identifier__ = null
var stepDescription6000_Component = stepDescription6000_normalizeComponent(
  components_stepDescription6000,
  view_components_stepDescription6000,
  stepDescription6000___vue_template_functional__,
  stepDescription6000___vue_styles__,
  stepDescription6000___vue_scopeId__,
  stepDescription6000___vue_module_identifier__
)

/* harmony default export */ var src_view_components_stepDescription6000 = (stepDescription6000_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/components/stepDescription7000.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import provinceBankJson from '@/assets/api/bank.json'





/* harmony default export */ var stepDescription7000 = ({
    components: {
        photoCode: src_components_code,
        Alert: src_components_alert
    },
    data: function data() {
        return {
            isChannelAgent: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt: 'waring', //负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            lastNameText: '姓名不能为空！',
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg: 'waring',
            sendInfo: {
                bankCode: hashmap.get('bankCode'),

                verifyCode: '', //验证码

                gender: '', //性别
                channelAgent: '', //客户经理推荐号
                // caUser:'', // 客户推荐手机号
                corpName: '', //借款人经营主体
                productCode: hashmap.get('productCode'), //贷款产品
                loanAmt: '', //贷款额度

                userNamePY: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '', // 名

                idCardNum: '', //身份证号码
                bankNum: '', // 银行卡
                mobile: '', //手机号
                stream: hashmap.get('stream') ? hashmap.get('stream') : ''

            },
            //倒计时
            isSendPhone: false,
            isSendCode: true, //发送验证码按钮不可点击样式
            hint: '发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo: {
                checked01: false,
                checked02: false,
                checked07: false,
                checked08: false,
                checked09: false,
                checked10: false

                // checked03: false,
            },
            isCheckBox: false,
            isChecked: false,
            isCheckedp: false, // 个人选中
            isLoanAmt: false,
            lastNEng: "",
            firstNEng: "",

            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode: false,
            // 小微贷款修改---
            textList: [],
            productCode: localStorage.getItem('productCode'),
            corpNameTxt: "waring",
            iscorpName: false,
            loanAmtTxt: ""
        };
    },
    mounted: function mounted() {
        // this.inif()
        this.getImage();
    },
    created: function created() {
        var _this = this;

        // this.provinceBankJson = provinceBankJson
        text_default.a.map(function (item, index) {
            if (_this.productCode === item.code) {
                _this.textList = item;
                return;
            }
            return;
        });
        console.log(this.textList);
    },

    methods: {
        inif: function inif() {
            var _this2 = this;

            pageDetailLoad({ 'fbCode': '0016' }).then(function (result) {
                if (result.responseCode === "000000") {
                    var responseData = result.responseData;
                    hashmap.set('application_id', responseData.loanOrderCode);
                    _this2.sendInfo.bankNum = responseData.cardNum || '';
                    _this2.sendInfo.mobile = responseData.mobile || '';

                    _this2.sendInfo.lastName = responseData.lastName || '';
                    _this2.sendInfo.firstName = responseData.firstName || '';
                    _this2.sendInfo.lastNameEng = responseData.lastNameEng || '';
                    _this2.sendInfo.firstNameEng = responseData.firstNameEng || '';
                }
            });
        },

        // 获取图形验证码
        getImage: function getImage() {
            var _this3 = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this3.imgSrc = result.data.responseData.verCode;
                _this3.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },

        // 贷款额度
        loanAmtVal: function loanAmtVal(e) {
            if (e.target) {
                this.sendInfo.loanAmt = e.target.value;
            }

            this.isLoanAmt = true;

            if (Number(this.sendInfo.loanAmt) > 2000) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能大于2000万元';
                return;
            } else if (Number(this.sendInfo.loanAmt) < 0) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能小于0';
                return;
            } else if (this.sendInfo.loanAmt === '') {
                console.log('请填写需要申请的贷款额度');
                this.isLoanAmt = true;
                this.loanAmtTxt = '请填写需要申请的贷款额度';
                this.isAllSuccess();
                return;
            }

            this.isLoanAmt = false;
            this.loanAmtTxt = 'waring';
            this.isAllSuccess();
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/index"
            });
            return false;
        },

        //验证码
        getPhotoCode: function getPhotoCode(val) {
            this.sendInfo.verifyCode = val;
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                if (!this.sendInfo.lastName) {
                    this.isAllSuccess();
                    this.verlastNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
                if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                    this.sendInfo.lastNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verlastNamePY();
                this.lastNEng = PinYin;
            }
        },
        verName: function verName() {

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.firstName) {
                    this.isAllSuccess();
                    this.verNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
                if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                    this.sendInfo.firstNameEng = PinYin;
                }

                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verNamePY();
                this.firstNEng = PinYin;
            }
        },
        vercorpName: function vercorpName(e) {
            if (e.target) {
                this.sendInfo.corpName = e.target.value;
            }
            this.iscorpName = true;
            if (this.sendInfo.corpName === '') {
                this.corpNameTxt = '请填写借款申请主体名称';
                this.isAllSuccess();
                return;
            }
            this.iscorpName = false;
            this.corpNameTxt = 'waring';
            this.isAllSuccess();
        },


        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.sendInfo.mobile = e.target.value;
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.sendInfo.mobile == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.mobile && this.sendInfo.mobile.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.sendInfo.mobile)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess();
        },

        //获取验证码
        getVerifyCode: function getVerifyCode() {
            var _this4 = this;

            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode = this.verCode;
            this.valiCodeParams.uuId = this.uuId;
            getValiCode(this.valiCodeParams).then(function (result) {
                if (result.responseCode === "000000") {

                    _this4.isDisabled = false;

                    //开始倒计时
                    _this4.countdownTime();

                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                } else if (result.responseCode == "000405") {
                    _this4.isVerCodeError = true;
                    _this4.isDisabled = true;
                    _this4.isAllSuccess();
                    _this4.verCodeErrorText = result.responseMessage;
                }
            });
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this5 = this;

            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.imageValidCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this5.countdown.count > 0 && _this5.countdown.count <= _this5.countdown.TIME_COUNT) {
                        _this5.countdown.counts = '重发验证码（' + _this5.countdown.count + "s）";
                        _this5.countdown.count--;
                    } else {
                        clearInterval(_this5.countdown.timer);
                        _this5.imageValidCode = false;
                        _this5.getCursorCode = false;
                        _this5.countdown.timer = null;
                        _this5.countdown.counts = _this5.hint;
                        _this5.isSendPhone = false;
                        _this5.isSendCode = false;
                    }
                }, 1000);
            }
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.sendInfo.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
            }
        },


        //四要素认证
        callFourEleCheck: function callFourEleCheck() {
            var _this6 = this;

            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC';
            this.sendInfo.appName = "00PACIFIC";

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret;

            // this.sendInfo.type1012 = this.verNoticeInfo.checked07
            this.sendInfo.type1013 = this.verNoticeInfo.checked08;
            this.sendInfo.type1014 = this.verNoticeInfo.checked09;
            this.sendInfo.type1015 = this.verNoticeInfo.checked10;

            hashmap.set('sendInfo', this.sendInfo);
            console.log('sendInfo------------', this.sendInfo);
            fourEleCheck(this.sendInfo).then(function (result) {
                _this6.isBindPhotoError = false;
                _this6.isAllRrquridSuccess = false;
                if (result.responseCode === "000000") {
                    hashmap.set('application_id', result.responseData.loanOrderCode);
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var loginName = result.responseData.loginName || '';
                    var retryBtn = result.responseData.retryBtn || '';
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage, //认证失败还有所少次变化 后端返回
                            retryBtn: retryBtn, // '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName: loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this6.isBindPhotoError = true;
                    _this6.toastMsg = result.responseMessage;
                    _this6.isAllRrquridSuccess = true;

                    window.scrollTo(0, 0);
                }
            });
        },

        // 下一步
        pass: function pass() {
            console.log(this.sendInfo);
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            this.verMobilePhone(1);
            this.verPhotoCode();
            this.vercorpName(1);
            this.verNoticeBox();
            this.loanAmtVal(1);

            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.callFourEleCheck();
            } else {
                window.scrollTo(0, 0);
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isCheckBox && !this.isChecked && !this.isUserName && !this.isUserNamePY && !this.isBindPhoto && !this.isBindPhotoError && !this.isVerCodeError && !this.isLoanAmt && !this.iscorpName) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },
        spaceEvent: function spaceEvent(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },
        keyEvent: function keyEvent(e) {
            if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                var a = void 0;
                if (e.currentTarget.previousElementSibling.value == '01') {
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0];
                } else {
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0];
                }
                a.focus();
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            } else {
                return;
            }
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },

        //认证须知校验
        verNotice: function verNotice() {
            if (this.verNoticeInfo.checked02 === false) {
                this.isChecked = true;
                this.isAllSuccess();
            } else {
                this.isChecked = false;
                this.isAllSuccess();
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.verNoticeInfo.checked08 === false || this.verNoticeInfo.checked09 === false || this.verNoticeInfo.checked10 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/components/stepDescription7000.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import provinceBankJson from '@/assets/api/bank.json'





/* harmony default export */ var components_stepDescription7000 = ({
    components: {
        photoCode: src_components_code,
        Alert: src_components_alert
    },
    data: function data() {
        return {
            isChannelAgent: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt: 'waring', //负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            lastNameText: '姓名不能为空！',
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg: 'waring',
            sendInfo: {
                bankCode: hashmap.get('bankCode'),

                verifyCode: '', //验证码

                gender: '', //性别
                channelAgent: '', //客户经理推荐号
                // caUser:'', // 客户推荐手机号
                corpName: '', //借款人经营主体
                productCode: hashmap.get('productCode'), //贷款产品
                loanAmt: '', //贷款额度

                userNamePY: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '', // 名

                idCardNum: '', //身份证号码
                bankNum: '', // 银行卡
                mobile: '', //手机号
                stream: hashmap.get('stream') ? hashmap.get('stream') : ''

            },
            //倒计时
            isSendPhone: false,
            isSendCode: true, //发送验证码按钮不可点击样式
            hint: '发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo: {
                checked01: false,
                checked02: false,
                checked07: false,
                checked08: false,
                checked09: false,
                checked10: false

                // checked03: false,
            },
            isCheckBox: false,
            isChecked: false,
            isCheckedp: false, // 个人选中
            isLoanAmt: false,
            lastNEng: "",
            firstNEng: "",

            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode: false,
            // 小微贷款修改---
            textList: [],
            productCode: localStorage.getItem('productCode'),
            corpNameTxt: "waring",
            iscorpName: false,
            loanAmtTxt: ""
        };
    },
    mounted: function mounted() {
        // this.inif()
        this.getImage();
    },
    created: function created() {
        var _this = this;

        // this.provinceBankJson = provinceBankJson
        text_default.a.map(function (item, index) {
            if (_this.productCode === item.code) {
                _this.textList = item;
                return;
            }
            return;
        });
        console.log(this.textList);
    },

    methods: {
        inif: function inif() {
            var _this2 = this;

            pageDetailLoad({ 'fbCode': '0016' }).then(function (result) {
                if (result.responseCode === "000000") {
                    var responseData = result.responseData;
                    hashmap.set('application_id', responseData.loanOrderCode);
                    _this2.sendInfo.bankNum = responseData.cardNum || '';
                    _this2.sendInfo.mobile = responseData.mobile || '';

                    _this2.sendInfo.lastName = responseData.lastName || '';
                    _this2.sendInfo.firstName = responseData.firstName || '';
                    _this2.sendInfo.lastNameEng = responseData.lastNameEng || '';
                    _this2.sendInfo.firstNameEng = responseData.firstNameEng || '';
                }
            });
        },

        // 获取图形验证码
        getImage: function getImage() {
            var _this3 = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this3.imgSrc = result.data.responseData.verCode;
                _this3.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },

        // 贷款额度
        loanAmtVal: function loanAmtVal(e) {
            if (e.target) {
                this.sendInfo.loanAmt = e.target.value;
            }

            this.isLoanAmt = true;

            if (Number(this.sendInfo.loanAmt) > 2000) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能大于2000万元';
                return;
            } else if (Number(this.sendInfo.loanAmt) < 0) {
                this.sendInfo.loanAmt = '';
                this.isLoanAmt = true;
                this.loanAmtTxt = '贷款额度不能小于0';
                return;
            } else if (this.sendInfo.loanAmt === '') {
                console.log('请填写需要申请的贷款额度');
                this.isLoanAmt = true;
                this.loanAmtTxt = '请填写需要申请的贷款额度';
                this.isAllSuccess();
                return;
            }

            this.isLoanAmt = false;
            this.loanAmtTxt = 'waring';
            this.isAllSuccess();
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/index"
            });
            return false;
        },

        //验证码
        getPhotoCode: function getPhotoCode(val) {
            this.sendInfo.verifyCode = val;
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.lastName && !reg.test(this.sendInfo.lastName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                if (!this.sendInfo.lastName) {
                    this.isAllSuccess();
                    this.verlastNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
                if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                    this.sendInfo.lastNameEng = PinYin;
                }
                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verlastNamePY();
                this.lastNEng = PinYin;
            }
        },
        verName: function verName() {

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.sendInfo.firstName && !reg.test(this.sendInfo.firstName)) {
                this.lastNameText = '姓名请输入中文！';
                this.isUserName = true;
            } else {
                this.isUserName = true;
                if (!this.sendInfo.firstName) {
                    this.isAllSuccess();
                    this.verNamePY();
                    return;
                }
                var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
                if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                    this.sendInfo.firstNameEng = PinYin;
                }

                if (reg.test(this.sendInfo.firstName) && reg.test(this.sendInfo.lastName)) {
                    this.isUserName = false;
                }
                this.isAllSuccess();
                this.verNamePY();
                this.firstNEng = PinYin;
            }
        },
        vercorpName: function vercorpName(e) {
            if (e.target) {
                this.sendInfo.corpName = e.target.value;
            }
            this.iscorpName = true;
            if (this.sendInfo.corpName === '') {
                this.corpNameTxt = '请填写借款申请主体名称';
                this.isAllSuccess();
                return;
            }
            this.iscorpName = false;
            this.corpNameTxt = 'waring';
            this.isAllSuccess();
        },


        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.sendInfo.mobile = e.target.value;
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.sendInfo.mobile == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.mobile && this.sendInfo.mobile.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.sendInfo.mobile)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess();
        },

        //获取验证码
        getVerifyCode: function getVerifyCode() {
            var _this4 = this;

            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode = this.verCode;
            this.valiCodeParams.uuId = this.uuId;
            getValiCode(this.valiCodeParams).then(function (result) {
                if (result.responseCode === "000000") {

                    _this4.isDisabled = false;

                    //开始倒计时
                    _this4.countdownTime();

                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                } else if (result.responseCode == "000405") {
                    _this4.isVerCodeError = true;
                    _this4.isDisabled = true;
                    _this4.isAllSuccess();
                    _this4.verCodeErrorText = result.responseMessage;
                }
            });
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this5 = this;

            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.imageValidCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this5.countdown.count > 0 && _this5.countdown.count <= _this5.countdown.TIME_COUNT) {
                        _this5.countdown.counts = '重发验证码（' + _this5.countdown.count + "s）";
                        _this5.countdown.count--;
                    } else {
                        clearInterval(_this5.countdown.timer);
                        _this5.imageValidCode = false;
                        _this5.getCursorCode = false;
                        _this5.countdown.timer = null;
                        _this5.countdown.counts = _this5.hint;
                        _this5.isSendPhone = false;
                        _this5.isSendCode = false;
                    }
                }, 1000);
            }
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.sendInfo.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
            }
        },


        //四要素认证
        callFourEleCheck: function callFourEleCheck() {
            var _this6 = this;

            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC';
            this.sendInfo.appName = "00PACIFIC";

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret;

            // this.sendInfo.type1012 = this.verNoticeInfo.checked07
            this.sendInfo.type1013 = this.verNoticeInfo.checked08;
            this.sendInfo.type1014 = this.verNoticeInfo.checked09;
            this.sendInfo.type1015 = this.verNoticeInfo.checked10;

            hashmap.set('sendInfo', this.sendInfo);
            console.log('sendInfo------------', this.sendInfo);
            fourEleCheck(this.sendInfo).then(function (result) {
                _this6.isBindPhotoError = false;
                _this6.isAllRrquridSuccess = false;
                if (result.responseCode === "000000") {
                    hashmap.set('application_id', result.responseData.loanOrderCode);
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var loginName = result.responseData.loginName || '';
                    var retryBtn = result.responseData.retryBtn || '';
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage, //认证失败还有所少次变化 后端返回
                            retryBtn: retryBtn, // '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName: loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this6.isBindPhotoError = true;
                    _this6.toastMsg = result.responseMessage;
                    _this6.isAllRrquridSuccess = true;

                    window.scrollTo(0, 0);
                }
            });
        },

        // 下一步
        pass: function pass() {
            console.log(this.sendInfo);
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            this.verMobilePhone(1);
            this.verPhotoCode();
            this.vercorpName(1);
            this.verNoticeBox();
            this.loanAmtVal(1);

            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.callFourEleCheck();
            } else {
                window.scrollTo(0, 0);
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isCheckBox && !this.isChecked && !this.isUserName && !this.isUserNamePY && !this.isBindPhoto && !this.isBindPhotoError && !this.isVerCodeError && !this.isLoanAmt && !this.iscorpName) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },
        spaceEvent: function spaceEvent(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },
        keyEvent: function keyEvent(e) {
            if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                var a = void 0;
                if (e.currentTarget.previousElementSibling.value == '01') {
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0];
                } else {
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0];
                }
                a.focus();
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            } else {
                return;
            }
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },

        //认证须知校验
        verNotice: function verNotice() {
            if (this.verNoticeInfo.checked02 === false) {
                this.isChecked = true;
                this.isAllSuccess();
            } else {
                this.isChecked = false;
                this.isAllSuccess();
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.verNoticeInfo.checked08 === false || this.verNoticeInfo.checked09 === false || this.verNoticeInfo.checked10 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-634107ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/stepDescription7000.vue
var stepDescription7000_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verified"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.textList.setup_title))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserName","aria-label":'错误提示，'+ _vm.lastNameText}},[_vm._v(_vm._s(_vm.lastNameText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserNamePY),expression:"isUserNamePY"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserNamePY","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_vm._v("姓名（英文/拼音）不能为空！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhoto),expression:"isBindPhoto"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhoto","aria-label":'错误提示，' + _vm.bindPhotoTxt}},[_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhotoError","aria-label":'错误提示，'+ _vm.toastMsg}},[_vm._v(_vm._s(_vm.toastMsg))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isVerCodeError","aria-label":'错误提示，'+_vm.verCodeErrorText}},[_vm._v(_vm._s(_vm.verCodeErrorText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.iscorpName),expression:"iscorpName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#iscorpName","aria-label":'错误提示，' + _vm.corpNameTxt}},[_vm._v(_vm._s(_vm.corpNameTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoanAmt),expression:"isLoanAmt"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isLoanAmt","aria-label":'错误提示，' + _vm.loanAmtTxt}},[_vm._v(_vm._s(_vm.loanAmtTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCheckBox","aria-label":"错误提示，请阅读借款申请主体经办人确认的内容并勾选！"}},[_vm._v("请阅读借款申请主体经办人确认的内容并勾选！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChecked),expression:"isChecked"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isChecked","aria-label":"错误提示，请阅读完毕后勾选作出授权！"}},[_vm._v("请阅读完毕后勾选作出授权！")])])])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-con-black"},[_c('h2',{staticClass:"global-subtitle"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"corpName"}},[_vm._v("借款申请主体：")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"iscorpName"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.corpName),expression:"sendInfo.corpName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.iscorpName},attrs:{"type":"text","aria-invalid":"true","aria-describedby":"cropText","id":"corpName","placeholder":"请输入借款申请主体营业执照上的名称"},domProps:{"value":(_vm.sendInfo.corpName)},on:{"blur":[_vm.vercorpName,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "corpName", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.iscorpName),expression:"iscorpName"}],staticClass:"global-requrid-feedback",attrs:{"id":"cropText","aria-label":'错误提示，' + _vm.corpNameTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.corpNameTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"loanAmt"}},[_vm._v("需要申请的贷款额度（万元）：")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isLoanAmt"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.loanAmt),expression:"sendInfo.loanAmt",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isLoanAmt},attrs:{"type":"number","min":"0","max":"2000","step":"1","aria-describedby":"isLoanAmt","onkeyup":"this.value=this.value.replace(/\\s/g,'')","id":"loanAmt","placeholder":"请输入贷款额度","aria-invalid":"true"},domProps:{"value":(_vm.sendInfo.loanAmt)},on:{"blur":[function($event){return _vm.loanAmtVal(_vm.sendInfo.loanAmt)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "loanAmt", $event.target.value.trim())}}}),_vm._v(" "),(_vm.isLoanAmt)?_c('div',{staticClass:"global-requrid-feedback",attrs:{"id":"isLoanAmt"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.loanAmtTxt))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"channelAgent"}},[_vm._v("客户经理推荐号（选填）：")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.channelAgent),expression:"sendInfo.channelAgent",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"id":"channelAgent","type":"text","onkeyup":"this.value=this.value.replace(/\\s/g,'')","placeholder":"请输入客户经理推荐号","aria-invalid":"true"},domProps:{"value":(_vm.sendInfo.channelAgent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "channelAgent", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v(_vm._s(_vm.textList.setup_title2))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserName"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('label',{attrs:{"for":"lName"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastName),expression:"sendInfo.lastName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"id":"lName","aria-labelledby":"chineseNameR","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastName)},on:{"change":_vm.verlastName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('label',{attrs:{"for":"fName"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstName),expression:"sendInfo.firstName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"id":"fName","aria-labelledby":"chineseNameL","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstName)},on:{"change":_vm.verName,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1","aria-label":'错误提示，'+ _vm.lastNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.lastNameText))])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserNamePY"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastNameEng),expression:"sendInfo.lastNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserNamePY},attrs:{"id":"lNameEng","aria-labelledby":"englishNameR","onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText2","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastNameEng)},on:{"blur":[_vm.verlastNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastNameEng", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstNameEng),expression:"sendInfo.firstNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserNamePY},attrs:{"id":"fNameEng","aria-labelledby":"englishNameL","onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText2","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstNameEng)},on:{"blur":[_vm.verNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstNameEng", $event.target.value.trim())}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserNamePY),expression:"isUserNamePY"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText2","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("姓名（英文/拼音）不能为空！")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"bindPhoto"}},[_vm._v("预留手机号")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhoto"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.mobile),expression:"sendInfo.mobile",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isBindPhoto},attrs:{"disabled":_vm.isSendPhone,"aria-invalid":"true","aria-describedby":"HelpText5","type":"tel","maxlength":"11","onkeyup":"this.value=this.value.replace(/\\D/g,'')","onblur":"this.value=this.value.replace(/\\D/g,'')","id":"bindPhoto","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.mobile)},on:{"keyup":_vm.verMobilePhone,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "mobile", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhoto),expression:"isBindPhoto"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText5"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.getVerCode},attrs:{"type":"button","disabled":_vm.getVerCode,"aria-live":"polite","aria-atomic":"true"},on:{"click":_vm.getImage}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"验证码，激活刷新"}})])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"photo"}},[_vm._v("图形验证码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"labelVerText"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.verCode),expression:"verCode",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"disabled":_vm.imageValidCode,"maxlength":"4","id":"verCode","aria-invalid":"true","aria-describedby":"HelpText","placeholder":"请填写图形验证码"},domProps:{"value":(_vm.verCode)},on:{"blur":[_vm.verCodeChange,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.verCode=$event.target.value.trim()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，'+_vm.verCodeErrorText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(this.verCodeErrorText))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.isSendCode||_vm.getCursorCode},attrs:{"type":"button","disabled":_vm.getCursorCode || _vm.isSendCode},on:{"click":_vm.getVerifyCode}},[_vm._v(_vm._s(_vm.countdown.counts))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('photo-code',{attrs:{"isDisabled":_vm.isDisabled,"photoCodeBool":_vm.photoCodeBool}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，' + _vm.toastMsg}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.toastMsg))]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("借款申请主体经办人确认")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请仔细阅读下列内容，勾选作出相应的授权/确认后，点击下一步继续预申请流程。")]),_vm._v(" "),_c('a',{attrs:{"name":"isCheckBox"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText11"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked08),expression:"verNoticeInfo.checked08"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText11","type":"checkbox","tabindex":"-1","value":"true","name":"checked08"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked08)?_vm._i(_vm.verNoticeInfo.checked08,"true")>-1:(_vm.verNoticeInfo.checked08)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked08,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked08", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked08", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked08", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText12"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked09),expression:"verNoticeInfo.checked09"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText12","type":"checkbox","tabindex":"-1","value":"true","name":"checked09"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked09)?_vm._i(_vm.verNoticeInfo.checked09,"true")>-1:(_vm.verNoticeInfo.checked09)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked09,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked09", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked09", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked09", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                     "+_vm._s(_vm.textList.setup_check2)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText13"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked10),expression:"verNoticeInfo.checked10"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText13","type":"checkbox","tabindex":"-1","value":"true","name":"checked10"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked10)?_vm._i(_vm.verNoticeInfo.checked10,"true")>-1:(_vm.verNoticeInfo.checked10)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked10,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked10", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked10", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked10", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                     "+_vm._s(_vm.textList.setup_check3)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText6","aria-label":"错误提示，请阅读授权及声明的内容并勾选！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("\n            请仔细阅读确认的内容，并逐项勾选作出确认，方可继续预申请流程。\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button","data-key":"logon_btn_next","role":"button"},on:{"click":_vm.pass}},[_vm._v("下一步")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-back",attrs:{"type":"button"},on:{"click":_vm.btnBack}},[_vm._v("上一步")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var stepDescription7000_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"chineseNameR"}},[_vm._v("姓（中文）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"chineseNameL"}},[_vm._v("名（中文）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"englishNameR"}},[_vm._v("姓（拼音）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"englishNameL"}},[_vm._v("名（拼音）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isVerCodeError"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhotoError"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    本人确认已取得上述借款申请主体（“我司”）授权代表提交贷款预申请，知晓并同意汇丰村镇银行将根据并依赖本人所填写的贷款预申请信息和提供的其他贷款义务人及相关人士信息就相关贷款业务进行评估、预审等。我司及本人充分了解并自愿填写、提供的贷款预申请信息及其他贷款义务人和相关人士信息的信息，并保证填写、提供的信息真实、准确且在任何方面不存在误导。我司及本人清楚了解并同意：若汇丰村镇银行认定或有理由怀疑我司或本人提供的信息在任何方面不真实、不准确、不完整或已过时或存在误导，汇丰村镇银行有权全部或部分暂停或终止向我司提供贷款服务，而无须对此承担任何责任。本人确认已阅读、理解《汇丰村镇银行个人信息和隐私保护政策》（可通过汇丰村镇银行网站"),_c('a',{staticClass:"a_href",attrs:{"href":"https://www.hsbc.com.cn/rural-bank","target":"_blank"}},[_vm._v("www.hsbc.com.cn/rural-bank")]),_vm._v("查阅）的条款和条件，并同意汇丰村镇银行按该等条款和条件处理（包括收集、存储、使用、加工、传输、提供、公开、删除等）本人的个人信息。\n                ")])}]
var stepDescription7000_esExports = { render: stepDescription7000_render, staticRenderFns: stepDescription7000_staticRenderFns }
/* harmony default export */ var view_components_stepDescription7000 = (stepDescription7000_esExports);
// CONCATENATED MODULE: ./src/view/components/stepDescription7000.vue
function stepDescription7000_injectStyle (ssrContext) {
  __webpack_require__("dfSi")
}
var stepDescription7000_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var stepDescription7000___vue_template_functional__ = false
/* styles */
var stepDescription7000___vue_styles__ = stepDescription7000_injectStyle
/* scopeId */
var stepDescription7000___vue_scopeId__ = "data-v-634107ea"
/* moduleIdentifier (server only) */
var stepDescription7000___vue_module_identifier__ = null
var stepDescription7000_Component = stepDescription7000_normalizeComponent(
  components_stepDescription7000,
  view_components_stepDescription7000,
  stepDescription7000___vue_template_functional__,
  stepDescription7000___vue_styles__,
  stepDescription7000___vue_scopeId__,
  stepDescription7000___vue_module_identifier__
)

/* harmony default export */ var src_view_components_stepDescription7000 = (stepDescription7000_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/stepDescription.vue
//
//
//
//
//
//
//





/* harmony default export */ var stepDescription = ({
    components: {
        StepDescription6000: src_view_components_stepDescription6000,
        StepDescription7000: src_view_components_stepDescription7000
    },
    data: function data() {
        return {
            productCode: ''
        };
    },
    created: function created() {
        this.getProductCodeFun();
    },

    methods: {
        getProductCodeFun: function getProductCodeFun() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode', _this.productCode);
                }
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/stepDescription.vue
//
//
//
//
//
//
//





/* harmony default export */ var view_stepDescription = ({
    components: {
        StepDescription6000: src_view_components_stepDescription6000,
        StepDescription7000: src_view_components_stepDescription7000
    },
    data: function data() {
        return {
            productCode: ''
        };
    },
    created: function created() {
        this.getProductCodeFun();
    },

    methods: {
        getProductCodeFun: function getProductCodeFun() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode', _this.productCode);
                }
            });
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5ecc97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/stepDescription.vue
var stepDescription_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productCode =='6000')?_c('StepDescription6000'):_vm._e(),_vm._v(" "),(_vm.productCode =='7000')?_c('StepDescription7000'):_vm._e()],1)}
var stepDescription_staticRenderFns = []
var stepDescription_esExports = { render: stepDescription_render, staticRenderFns: stepDescription_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_stepDescription = (stepDescription_esExports);
// CONCATENATED MODULE: ./src/view/stepDescription.vue
function stepDescription_injectStyle (ssrContext) {
  __webpack_require__("fOqk")
}
var stepDescription_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var stepDescription___vue_template_functional__ = false
/* styles */
var stepDescription___vue_styles__ = stepDescription_injectStyle
/* scopeId */
var stepDescription___vue_scopeId__ = "data-v-7d5ecc97"
/* moduleIdentifier (server only) */
var stepDescription___vue_module_identifier__ = null
var stepDescription_Component = stepDescription_normalizeComponent(
  view_stepDescription,
  selectortype_template_index_0_src_view_stepDescription,
  stepDescription___vue_template_functional__,
  stepDescription___vue_styles__,
  stepDescription___vue_scopeId__,
  stepDescription___vue_module_identifier__
)

/* harmony default export */ var src_view_stepDescription = (stepDescription_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/linkPeople.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var linkPeople = ({
    components: {
        Alert: src_components_alert
    },
    // 项目管理
    data: function data() {
        return {
            addNum: false,
            lastNameText: '姓名不能为空！',
            indexs: '',
            items: [],
            isRelationType: false,
            isName: false,
            isCardId: '',
            identitype: '',
            otherSpouseNameText: '请填写！',
            otherSpouseNameList: [],
            isSpouseName: false,
            relationList: [{
                value: "00",
                label: "请选择",
                relationType: '0',
                userName: '',
                mobile: '',
                idNo: '',
                identity: '0',
                spouseName: '',
                isActiveFlag: false,
                isSpouseName: false,
                isName: false,
                isRelationType: false,
                isidentity: false,
                tagger: 1,
                isMobile: false,
                mobileTxt: '',
                isOtherSpouseName: false,
                otherSpouseName: ""
            }],
            dataList: null,
            num: 0,
            isChangeName: false,
            changeNameTxt: '',
            isAllRrquridSuccess: false,
            isCheckBox: false,
            checked01: false,
            textList: [],
            productCode: localStorage.getItem('productCode')
        };
    },

    filters: {
        spouceFilter: function spouceFilter(value) {
            if (value == '7') {
                return value = '朋友';
            } else if (value == '8') {
                return value = '亲戚';
            } else if (value == '6') {
                return value = '合伙人';
            } else {
                return '';
            }
        }
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        isActiveFData: function isActiveFData(item, index) {
            var arr = [];
            this.otherSpouseNameList.map(function (i) {
                arr.push(i.userName);
            });
            if (item.activeFlag == "1" && item.spouseNames != "" && arr.indexOf(item.spouseName) == -1) {
                this.relationList[index].isActiveFlag = true;
            } else {
                this.relationList[index].isActiveFlag = false;
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.productCode === '6000' && this.checked01 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },
        mobileBlur: function mobileBlur(item) {
            if (item.mobile.length < 11) {
                item.mobile = '';
                item.isMobile = true;
                item.mobileTxt = '手机号码位数不够！';
            } else {
                item.isMobile = false;
            }
        },
        init: function init() {
            var _this = this;

            text_default.a.map(function (item, index) {
                if (_this.productCode === item.code) {
                    _this.textList = item;
                    _this.getlist();
                    return;
                }
                return;
            });
        },
        getlist: function getlist() {
            var _this2 = this;

            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    if (retsult.relationList.length > 0) {
                        _this2.relationList = retsult.relationList;
                        _this2.otherSpouseNameList = [];
                        var arr = [];
                        var arr1 = [];
                        _this2.relationList.forEach(function (item, index) {
                            // 获取配偶姓名和下标
                            arr1.push({ 'data': item.spouseName, 'index': index });
                            // 存储配偶姓名，避免实施修改
                            item.spouseNames = item.spouseName;
                            // 配偶姓名的下拉选项
                            if (_this2.productCode == '6000') {
                                if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            } else if (_this2.productCode == '7000') {
                                if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            }
                        });
                        // 是否重复
                        _this2.otherSpouseNameList.map(function (item, index) {
                            arr.push(item.userName);
                        });
                        arr1.map(function (k, y) {
                            if (arr.indexOf(k.data) > -1) {
                                _this2.relationList[y].isActiveFlag = false;
                            } else {
                                _this2.relationList[y].isActiveFlag = true;
                            }
                        });
                    }
                }
            });
        },
        isAllSuccess: function isAllSuccess() {
            var item = this.relationList;
            var isAllS = 0;
            for (var i = 0; i < item.length; i++) {
                if (this.productCode === '6000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isidentity || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                } else if (this.productCode === '7000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                }
            }

            if (isAllS > 0 || this.isCheckBox) {
                return this.isAllRrquridSuccess = true;
            } else {
                return this.isAllRrquridSuccess = false;
            }
        },
        identityChange: function identityChange(item, index) {
            if (item.identity && item.identity == '0') {
                this.relationList[index].isidentity = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isidentity = false;
                this.isAllSuccess();
            }
        },
        relationTypeChange: function relationTypeChange(item, index) {
            if (item.relationType && item.relationType == '0') {
                this.relationList[index].isRelationType = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isRelationType = false;
                this.isAllSuccess();
            }
        },
        userNameChange: function userNameChange(item, index) {
            var _this3 = this;

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.userName && !reg.test(item.userName)) {
                this.lastNameText = '姓名请输入中文！';
                this.relationList[index].isName = true;
            } else {
                if (!item.userName) {
                    this.relationList[index].isName = true;
                    this.isAllSuccess();
                } else {
                    if (this.productCode === '7000') {
                        // productcode 7000
                        this.otherSpouseNameList = [];
                        //选择了 8 9 之外的需要在relationList添加人名
                        this.relationList.forEach(function (item, index) {
                            if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                _this3.otherSpouseNameList.push(item);
                            }
                        });
                        if (['8', '9'].indexOf(item.relationType) == -1) {
                            // 如果选择的不是8 9，那就隐藏请填写的input
                            this.relationList[index].isOtherSpouseName = false;
                            this.isAllSuccess();
                        }

                        console.log('7000.otherSpouseNameList', this.otherSpouseNameList);
                    }
                    this.relationList[index].isName = false;
                    this.isAllSuccess();
                }
            }
        },
        identityChangeList: function identityChangeList(item, index) {
            var _this4 = this;

            //productcode 6000
            if (this.productCode == '6000') {
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this4.otherSpouseNameList.push(item);
                    }
                });
                if (['6', '7', '8'].indexOf(item.identity) == -1) {
                    // 如果选择的不是合伙人配偶、朋友配偶、亲戚配偶，那就隐藏请填写的input
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
                console.log('6000.otherSpouseNameList', this.otherSpouseNameList);
            }
        },
        otherSpouseNameChange: function otherSpouseNameChange(item, index) {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.otherSpouseName && !reg.test(item.otherSpouseName)) {
                this.otherSpouseNameText = '请填写中文！';
                this.relationList[index].isOtherSpouseName = true;
            } else {
                if (!item.otherSpouseName) {
                    this.relationList[index].isOtherSpouseName = true;
                    this.isAllSuccess();
                } else {
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
            }
        },

        //选择此其他贷款义务人或相关人士配偶姓名
        spouseNameChange: function spouseNameChange(item, index) {
            if (!item.spouseName) {
                this.relationList[index].isSpouseName = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isSpouseName = false;
                this.isAllSuccess();
            }
        },
        addItem: function addItem() {
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            } else {
                if (this.relationList.length < 10) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            }
        },
        affirm: function affirm(item, index) {
            this.$refs.alert.showAlert();
            this.items = item;
            this.indexs = index;
        },
        cancelInfo: function cancelInfo() {
            this.$refs.alert.closeAlert();
        },
        deleteItem: function deleteItem(item, indexs) {
            var _this5 = this;

            if (item.tagger) {
                this.relationList.splice(indexs, 1);
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this5.otherSpouseNameList.push(item);
                    }
                });
                this.cancelInfo();
            } else {
                deleteRelation(item).then(function (result) {
                    if (result.responseCode === "000000") {
                        var retsult = result.responseData;
                        _this5.relationList = retsult.relationList;
                        _this5.cancelInfo();
                        _this5.init();
                    }
                });
            }
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.addNum = false;
                }
            } else {
                if (this.relationList.length < 10) {
                    this.addNum = false;
                }
            }
        },
        next: function next() {
            this.verNoticeBox();
            this.isAllRrquridSuccess = false;
            for (var i = 0; i < this.relationList.length; i++) {
                this.relationTypeChange(this.relationList[i], i);
                this.userNameChange(this.relationList[i], i);
                this.identityChange(this.relationList[i], i);
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 || this.productCode === '7000' && (this.relationList[i].relationType == '8' || this.relationList[i].relationType == '9')) {
                    this.spouseNameChange(this.relationList[i], i);
                }
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 && this.relationList[i].spouseName == "其他") {
                    this.otherSpouseNameChange(this.relationList[i], i);
                }
            }
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.pass();
            }
        },
        pass: function pass() {
            var _this6 = this;

            var param = [];
            this.relationList.map(function (item, index) {
                param.push({
                    id: item.id,
                    mobile: item.mobile,
                    userName: item.userName,
                    relationType: item.relationType,
                    identity: item.identity,
                    spouseName: item.spouseName != "其他" ? item.spouseName : item.otherSpouseName
                });
            });
            recordRelationHandler({ relationList: param, type1006: this.checked01 }).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage
                        }
                    });
                }
            });
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/stepDescription"
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/linkPeople.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var view_linkPeople = ({
    components: {
        Alert: src_components_alert
    },
    // 项目管理
    data: function data() {
        return {
            addNum: false,
            lastNameText: '姓名不能为空！',
            indexs: '',
            items: [],
            isRelationType: false,
            isName: false,
            isCardId: '',
            identitype: '',
            otherSpouseNameText: '请填写！',
            otherSpouseNameList: [],
            isSpouseName: false,
            relationList: [{
                value: "00",
                label: "请选择",
                relationType: '0',
                userName: '',
                mobile: '',
                idNo: '',
                identity: '0',
                spouseName: '',
                isActiveFlag: false,
                isSpouseName: false,
                isName: false,
                isRelationType: false,
                isidentity: false,
                tagger: 1,
                isMobile: false,
                mobileTxt: '',
                isOtherSpouseName: false,
                otherSpouseName: ""
            }],
            dataList: null,
            num: 0,
            isChangeName: false,
            changeNameTxt: '',
            isAllRrquridSuccess: false,
            isCheckBox: false,
            checked01: false,
            textList: [],
            productCode: localStorage.getItem('productCode')
        };
    },

    filters: {
        spouceFilter: function spouceFilter(value) {
            if (value == '7') {
                return value = '朋友';
            } else if (value == '8') {
                return value = '亲戚';
            } else if (value == '6') {
                return value = '合伙人';
            } else {
                return '';
            }
        }
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        isActiveFData: function isActiveFData(item, index) {
            var arr = [];
            this.otherSpouseNameList.map(function (i) {
                arr.push(i.userName);
            });
            if (item.activeFlag == "1" && item.spouseNames != "" && arr.indexOf(item.spouseName) == -1) {
                this.relationList[index].isActiveFlag = true;
            } else {
                this.relationList[index].isActiveFlag = false;
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.productCode === '6000' && this.checked01 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },
        mobileBlur: function mobileBlur(item) {
            if (item.mobile.length < 11) {
                item.mobile = '';
                item.isMobile = true;
                item.mobileTxt = '手机号码位数不够！';
            } else {
                item.isMobile = false;
            }
        },
        init: function init() {
            var _this = this;

            text_default.a.map(function (item, index) {
                if (_this.productCode === item.code) {
                    _this.textList = item;
                    _this.getlist();
                    return;
                }
                return;
            });
        },
        getlist: function getlist() {
            var _this2 = this;

            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    if (retsult.relationList.length > 0) {
                        _this2.relationList = retsult.relationList;
                        _this2.otherSpouseNameList = [];
                        var arr = [];
                        var arr1 = [];
                        _this2.relationList.forEach(function (item, index) {
                            // 获取配偶姓名和下标
                            arr1.push({ 'data': item.spouseName, 'index': index });
                            // 存储配偶姓名，避免实施修改
                            item.spouseNames = item.spouseName;
                            // 配偶姓名的下拉选项
                            if (_this2.productCode == '6000') {
                                if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            } else if (_this2.productCode == '7000') {
                                if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            }
                        });
                        // 是否重复
                        _this2.otherSpouseNameList.map(function (item, index) {
                            arr.push(item.userName);
                        });
                        arr1.map(function (k, y) {
                            if (arr.indexOf(k.data) > -1) {
                                _this2.relationList[y].isActiveFlag = false;
                            } else {
                                _this2.relationList[y].isActiveFlag = true;
                            }
                        });
                    }
                }
            });
        },
        isAllSuccess: function isAllSuccess() {
            var item = this.relationList;
            var isAllS = 0;
            for (var i = 0; i < item.length; i++) {
                if (this.productCode === '6000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isidentity || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                } else if (this.productCode === '7000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                }
            }

            if (isAllS > 0 || this.isCheckBox) {
                return this.isAllRrquridSuccess = true;
            } else {
                return this.isAllRrquridSuccess = false;
            }
        },
        identityChange: function identityChange(item, index) {
            if (item.identity && item.identity == '0') {
                this.relationList[index].isidentity = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isidentity = false;
                this.isAllSuccess();
            }
        },
        relationTypeChange: function relationTypeChange(item, index) {
            if (item.relationType && item.relationType == '0') {
                this.relationList[index].isRelationType = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isRelationType = false;
                this.isAllSuccess();
            }
        },
        userNameChange: function userNameChange(item, index) {
            var _this3 = this;

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.userName && !reg.test(item.userName)) {
                this.lastNameText = '姓名请输入中文！';
                this.relationList[index].isName = true;
            } else {
                if (!item.userName) {
                    this.relationList[index].isName = true;
                    this.isAllSuccess();
                } else {
                    if (this.productCode === '7000') {
                        // productcode 7000
                        this.otherSpouseNameList = [];
                        //选择了 8 9 之外的需要在relationList添加人名
                        this.relationList.forEach(function (item, index) {
                            if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                _this3.otherSpouseNameList.push(item);
                            }
                        });
                        if (['8', '9'].indexOf(item.relationType) == -1) {
                            // 如果选择的不是8 9，那就隐藏请填写的input
                            this.relationList[index].isOtherSpouseName = false;
                            this.isAllSuccess();
                        }

                        console.log('7000.otherSpouseNameList', this.otherSpouseNameList);
                    }
                    this.relationList[index].isName = false;
                    this.isAllSuccess();
                }
            }
        },
        identityChangeList: function identityChangeList(item, index) {
            var _this4 = this;

            //productcode 6000
            if (this.productCode == '6000') {
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this4.otherSpouseNameList.push(item);
                    }
                });
                if (['6', '7', '8'].indexOf(item.identity) == -1) {
                    // 如果选择的不是合伙人配偶、朋友配偶、亲戚配偶，那就隐藏请填写的input
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
                console.log('6000.otherSpouseNameList', this.otherSpouseNameList);
            }
        },
        otherSpouseNameChange: function otherSpouseNameChange(item, index) {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.otherSpouseName && !reg.test(item.otherSpouseName)) {
                this.otherSpouseNameText = '请填写中文！';
                this.relationList[index].isOtherSpouseName = true;
            } else {
                if (!item.otherSpouseName) {
                    this.relationList[index].isOtherSpouseName = true;
                    this.isAllSuccess();
                } else {
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
            }
        },

        //选择此其他贷款义务人或相关人士配偶姓名
        spouseNameChange: function spouseNameChange(item, index) {
            if (!item.spouseName) {
                this.relationList[index].isSpouseName = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isSpouseName = false;
                this.isAllSuccess();
            }
        },
        addItem: function addItem() {
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            } else {
                if (this.relationList.length < 10) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            }
        },
        affirm: function affirm(item, index) {
            this.$refs.alert.showAlert();
            this.items = item;
            this.indexs = index;
        },
        cancelInfo: function cancelInfo() {
            this.$refs.alert.closeAlert();
        },
        deleteItem: function deleteItem(item, indexs) {
            var _this5 = this;

            if (item.tagger) {
                this.relationList.splice(indexs, 1);
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this5.otherSpouseNameList.push(item);
                    }
                });
                this.cancelInfo();
            } else {
                deleteRelation(item).then(function (result) {
                    if (result.responseCode === "000000") {
                        var retsult = result.responseData;
                        _this5.relationList = retsult.relationList;
                        _this5.cancelInfo();
                        _this5.init();
                    }
                });
            }
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.addNum = false;
                }
            } else {
                if (this.relationList.length < 10) {
                    this.addNum = false;
                }
            }
        },
        next: function next() {
            this.verNoticeBox();
            this.isAllRrquridSuccess = false;
            for (var i = 0; i < this.relationList.length; i++) {
                this.relationTypeChange(this.relationList[i], i);
                this.userNameChange(this.relationList[i], i);
                this.identityChange(this.relationList[i], i);
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 || this.productCode === '7000' && (this.relationList[i].relationType == '8' || this.relationList[i].relationType == '9')) {
                    this.spouseNameChange(this.relationList[i], i);
                }
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 && this.relationList[i].spouseName == "其他") {
                    this.otherSpouseNameChange(this.relationList[i], i);
                }
            }
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.pass();
            }
        },
        pass: function pass() {
            var _this6 = this;

            var param = [];
            this.relationList.map(function (item, index) {
                param.push({
                    id: item.id,
                    mobile: item.mobile,
                    userName: item.userName,
                    relationType: item.relationType,
                    identity: item.identity,
                    spouseName: item.spouseName != "其他" ? item.spouseName : item.otherSpouseName
                });
            });
            recordRelationHandler({ relationList: param, type1006: this.checked01 }).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage
                        }
                    });
                }
            });
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/stepDescription"
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-626b549f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/linkPeople.vue
var linkPeople_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linkpeople"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_vm._l((_vm.relationList),function(item,index){return _c('div',{key:index,staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isRelationType),expression:"item.isRelationType"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isRelationType,"aria-label":"错误提示，请选择关联人身份！"}},[_vm._v("关联人"+_vm._s(index+1)+"请选择关联人身份！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isName),expression:"item.isName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isName,"aria-label":'错误提示，'+ _vm.lastNameText}},[_vm._v("关联人"+_vm._s(index+1)+_vm._s(_vm.lastNameText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.productCode === '6000' && item.isidentity),expression:"productCode === '6000' && item.isidentity"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isidentity,"aria-label":"错误提示，请选择与借款申请人关系！"}},[_vm._v("关联人"+_vm._s(index+1)+"请选择与借款申请人关系！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isSpouseName),expression:"item.isSpouseName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isSpouseName,"aria-label":"错误提示，"+_vm.textList.linkpeople_error}},[_vm._v(_vm._s(_vm.textList.linkpeople_error))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isOtherSpouseName),expression:"item.isOtherSpouseName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isOtherSpouseName,"aria-label":'错误提示，'+ _vm.otherSpouseNameText}},[_vm._v("关联人"+_vm._s(index+1)+_vm._s(_vm.otherSpouseNameText))])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCheckBox","aria-label":"错误提示，请阅读并勾选！"}},[_vm._v("请阅读并勾选！")])])],2)]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-con-black"},[_c('h2',{staticClass:"global-subtitle"},[_vm._v("添加其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"point"},[(_vm.productCode === '6000')?_c('p',[_vm._v("\n                * 其他贷款义务人或相关人士是指与借款申请人为此次贷款申请相关的人士，包括但不限于借款申请人配偶，联名申请人及其配偶，担保人及其配偶，以及其他等"),_c('br'),_vm._v("\n                如无其他贷款义务人或相关人士，请在其他贷款义务人或相关人士1其他贷款义务人或相关人士身份选择“其他”、姓名栏填写“无”、与借款申请人关系选择“其他”，然后点击“下一步”\n            ")]):_vm._e(),_vm._v(" "),(_vm.productCode === '7000')?_c('p',[_vm._v("\n               * 其他贷款义务人或相关人士是指与借款申请主体此次贷款申请相关的人士，包括但不限于借款申请主体的法定代表人、实际控制人、个人保证担保人、个人抵押担保人、个人保证担保人配偶、个人抵押担保人配偶，以及其他等\n            ")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.relationList),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"listTip"},[_c('b',[_vm._v("其他贷款义务人或相关人士"+_vm._s(index+1)+"：")]),_vm._v(" "),(_vm.relationList.length>1)?_c('span',{attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.affirm(item,index)}}},[_vm._v(" \n                    删除 "),_c('img',{staticClass:"pictureTips",attrs:{"width":"18","aria-hidden":"true","src":__webpack_require__("vYue"),"alt":"删除"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"relationType"}},[_vm._v("其他贷款义务人或相关人士身份")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isRelationType'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.relationType),expression:"item.relationType"}],class:{'global-select-error':item.isRelationType},attrs:{"aria-invalid":"true","aria-describedby":"HelpText0","id":"relationType","placeholder":"请选择关联人身份"},on:{"blur":function($event){return _vm.relationTypeChange(item,index)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "relationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":"请选择关联人身份","value":"0"}},[_vm._v("请选择关联人身份")]),_vm._v(" "),_vm._l((_vm.textList.linkpeople),function(item,index){return _c('option',{key:index,attrs:{"label":item.label},domProps:{"value":item.value}},[_vm._v(_vm._s(item.label))])})],2),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isRelationType),expression:"item.isRelationType"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText0","aria-label":"错误提示，请选择关联人身份！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择关联人身份！")])])]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"Name"}},[_vm._v("姓名")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isName'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(item.userName),expression:"item.userName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':item.isName},attrs:{"id":"Name","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","type":"text","aria-invalid":"true","aria-describedby":"HelpText1","placeholder":"请填写其他贷款义务人或相关人士姓名"},domProps:{"value":(item.userName)},on:{"blur":[function($event){return _vm.userNameChange(item,index)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "userName", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isName),expression:"item.isName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1","aria-label":'错误提示，'+ _vm.lastNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.lastNameText))])]),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"identity"}},[_vm._v("与借款申请人关系")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isidentity'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.identity),expression:"item.identity"}],class:{'global-select-error':item.isIdentity},attrs:{"aria-invalid":"true","aria-describedby":"HelpText00","id":"identity","placeholder":"请选择与借款申请人关系"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "identity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.identityChangeList(item,index)}],"blur":function($event){return _vm.identityChange(item,index)}}},[_c('option',{attrs:{"label":"请选择与借款申请人关系","value":"0"}},[_vm._v("请选择与借款申请人关系")]),_vm._v(" "),_c('option',{attrs:{"label":"配偶","value":"1"}},[_vm._v("配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"合伙人","value":"5"}},[_vm._v("合伙人")]),_vm._v(" "),_c('option',{attrs:{"label":"合伙人配偶","value":"6"}},[_vm._v("合伙人配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"朋友","value":"2"}},[_vm._v("朋友")]),_vm._v(" "),_c('option',{attrs:{"label":"朋友配偶","value":"7"}},[_vm._v("朋友配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"亲戚","value":"3"}},[_vm._v("亲戚")]),_vm._v(" "),_c('option',{attrs:{"label":"亲戚配偶","value":"8"}},[_vm._v("亲戚配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"其他","value":"4"}},[_vm._v("其他")])]),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isidentity),expression:"item.isidentity"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText00","aria-label":"错误提示，请选择与借款申请人关系！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择与借款申请人关系！")])])]):_vm._e(),_vm._v(" "),(['6', '7', '8'].indexOf(item.identity) > -1 ||(_vm.productCode === '7000' &&(item.relationType == '8'|| item.relationType == '9')))?_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"spouseName"}},[_vm._v("此其他贷款义务人或相关人士配偶姓名")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isSpouseName'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.spouseName),expression:"item.spouseName"}],class:{'global-select-error':item.isSpouseName},attrs:{"aria-describedby":"HelpText7","aria-invalid":"true","disabled":item.status && item.status!='unAuth',"id":"spouseName","placeholder":"请选择此其他贷款义务人或相关人士配偶姓名"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "spouseName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.spouseNameChange(item,index)}],"focus":function($event){return _vm.isActiveFData(item,index)}}},[_vm._l((_vm.otherSpouseNameList),function(i,index){return _c('option',{key:index,attrs:{"label":i.userName},domProps:{"value":i.userName}},[_vm._v(_vm._s(i.userName))])}),_vm._v(" "),(item.isActiveFlag)?_c('option',{attrs:{"label":item.spouseNames},domProps:{"value":item.spouseNames}},[_vm._v(_vm._s(item.spouseNames))]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"label":"其他","value":"其他"}},[_vm._v("其他")])],2),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isSpouseName),expression:"item.isSpouseName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText7","aria-label":"错入提示，"+_vm.textList.linkpeople_error}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.textList.linkpeople_error))])])]):_vm._e(),_vm._v(" "),(['其他'].indexOf(item.spouseName) > -1 && ((_vm.productCode === '6000'&&['6', '7', '8'].indexOf(item.identity) > -1)||(_vm.productCode === '7000' && (item.relationType == '8'|| item.relationType == '9') )))?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"otherSpouseName"}},[_vm._v("请填写")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isOtherSpouseName'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(item.otherSpouseName),expression:"item.otherSpouseName",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"aria-describedby":"HelpText7","id":"otherSpouseName","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","type":"text","aria-invalid":"true","disabled":item.status && item.status!='unAuth',"placeholder":"请填写"},domProps:{"value":(item.otherSpouseName)},on:{"blur":[function($event){return _vm.otherSpouseNameChange(item,index)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "otherSpouseName", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isOtherSpouseName),expression:"item.isOtherSpouseName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText7","aria-label":'错误提示，'+_vm.otherSpouseNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.otherSpouseNameText))])]):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"mobile"}},[_vm._v("手机号码（选填）")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor"}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(item.mobile),expression:"item.mobile",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"id":"mobile","type":"text","maxlength":"11","onkeyup":"this.value=this.value.replace(/\\D/g,'')","placeholder":"请填写关联人手机号"},domProps:{"value":(item.mobile)},on:{"blur":[function($event){return _vm.mobileBlur(item)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "mobile", $event.target.value.trim())}}}),_vm._v(" "),(item.isMobile)?_c('div',{staticClass:"global-requrid-feedback",attrs:{"id":"isMobile"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(item.mobileTxt))]):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('p',{staticClass:"copySrc",attrs:{"tabindex":"0"},on:{"click":_vm.addItem}},[_c('span',{staticClass:"copyAdd"},[_vm._v("+")]),_c('span',{staticClass:"copyText"},[_vm._v("添加其他贷款义务人或相关人士信息")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addNum),expression:"addNum"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":"新增关联人记录数已达上限"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("新增关联人记录数已达上限")]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText8"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked01),expression:"checked01"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText8","type":"checkbox","tabindex":"-1","value":"true","name":"checked01"},domProps:{"checked":Array.isArray(_vm.checked01)?_vm._i(_vm.checked01,"true")>-1:(_vm.checked01)},on:{"change":[function($event){var $$a=_vm.checked01,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked01=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked01=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked01=$$c}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    本人特此承诺和保证本人已获得上述其他贷款义务人或相关人士的授权和同意，有权合法地将上述人士的信息提供给村镇银行，用于村镇银行对本人贷款预申请的审核和评估。\n                ")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText6","aria-label":"错误提示，请阅读并勾选！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("\n            此处需要阅读并勾选，方可进行下一步。\n        ")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button","data-key":"logon_btn_next","role":"button"},on:{"click":_vm.next}},[_vm._v("下一步")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-back",attrs:{"type":"button"},on:{"click":_vm.btnBack}},[_vm._v("上一步")])]),_vm._v(" "),_c('alert',{ref:"alert",attrs:{"data":_vm.items}},[_c('div',{attrs:{"slot":"alert_title"},slot:"alert_title"},[_vm._v("确认删除")]),_vm._v(" "),_c('div',{attrs:{"slot":"close_icon"},slot:"close_icon"},[_c('button',{staticClass:"close-icon",attrs:{"type":"button","aria-label":"关闭按钮","title":"关闭"},on:{"click":_vm.cancelInfo}},[_c('img',{attrs:{"aria-hidden":"true","src":__webpack_require__("mq5u"),"alt":""}})])]),_vm._v(" "),_c('div',{attrs:{"slot":"alert_content"},slot:"alert_content"},[_vm._v("\n                删除后将不能恢复，但可再次手动添加，是否确认删除？\n            ")]),_vm._v(" "),_c('div',{attrs:{"slot":"btn_sure"},slot:"btn_sure"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteItem(_vm.items,_vm.indexs)}}},[_vm._v("确认删除")])]),_vm._v(" "),_c('div',{attrs:{"slot":"btn_close"},slot:"btn_close"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})],2)])}
var linkPeople_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请按贷款预申请要求，填写其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])])}]
var linkPeople_esExports = { render: linkPeople_render, staticRenderFns: linkPeople_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_linkPeople = (linkPeople_esExports);
// CONCATENATED MODULE: ./src/view/linkPeople.vue
function linkPeople_injectStyle (ssrContext) {
  __webpack_require__("hmuQ")
}
var linkPeople_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var linkPeople___vue_template_functional__ = false
/* styles */
var linkPeople___vue_styles__ = linkPeople_injectStyle
/* scopeId */
var linkPeople___vue_scopeId__ = "data-v-626b549f"
/* moduleIdentifier (server only) */
var linkPeople___vue_module_identifier__ = null
var linkPeople_Component = linkPeople_normalizeComponent(
  view_linkPeople,
  selectortype_template_index_0_src_view_linkPeople,
  linkPeople___vue_template_functional__,
  linkPeople___vue_styles__,
  linkPeople___vue_scopeId__,
  linkPeople___vue_module_identifier__
)

/* harmony default export */ var src_view_linkPeople = (linkPeople_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/editAgain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var editAgain = ({
    data: function data() {
        return {
            linkPeopleList: [],
            config: {
                value: ''
            },
            textList: [],
            productCode: ""
        };
    },

    filters: {
        nullFilters: function nullFilters(value) {
            return value ? value : "--";
        },
        relationTypeFilter: function relationTypeFilter(val) {
            if (val == '1') {
                return val = '共同借款人';
            } else if (val == '2') {
                return val = '担保人';
            } else if (val == '3') {
                return val = '其他关联人';
            } else if (val == '4') {
                return val = '借款申请主体法定代表人';
            } else if (val == '5') {
                return val = '借款申请主体实际控制人';
            } else if (val == '6') {
                return val = '个人保证担保人';
            } else if (val == '7') {
                return val = '个人抵押担保人';
            } else if (val == '8') {
                return val = '个人保证担保人配偶';
            } else if (val == '9') {
                return val = '个人抵押担保人配偶';
            } else if (val == '10') {
                return val = '其他';
            } else {
                return '--';
            }
        },
        identityFilter: function identityFilter(val) {
            if (val == '1') {
                return val = '配偶';
            } else if (val == '2') {
                return val = '朋友';
            } else if (val == '7') {
                return val = '朋友配偶';
            } else if (val == '3') {
                return val = '亲戚';
            } else if (val == '8') {
                return val = '亲戚配偶';
            } else if (val == '4') {
                return val = '其他';
            } else if (val == '5') {
                return val = '合伙人';
            } else if (val == '6') {
                return val = '合伙人配偶';
            } else {
                return '--';
            }
        }
    },
    created: function created() {
        this.getProductCodeFun();
    },
    mounted: function mounted() {
        this.getloadRelation();
    },

    methods: {
        getProductCodeFun: function getProductCodeFun() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    if (_this.productCode === '6000') {
                        _this.config.value = window.location.origin + '/#/certified?loanOrderCode=' + _this.$route.query.loanOrderCode;
                        var a = document.getElementById('qrUrl').getElementsByTagName("img");
                        a[0].alt = _this.config.value;
                    }

                    text_default.a.map(function (item, index) {
                        if (_this.productCode === item.code) {
                            _this.textList = item;
                            return;
                        }
                        return;
                    });
                }
            });
        },
        getloadRelation: function getloadRelation() {
            var _this2 = this;

            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    _this2.linkPeopleList = retsult.relationList;
                }
            });
        },
        editBack: function editBack() {
            this.$router.push("/editPerson");
        },
        copyQrUrl: function copyQrUrl() {
            var input = document.getElementById('textarea');
            input.value = this.config.value;
            input.select();
            document.execCommand("Copy");
            document.getElementById('showTips').style.display = 'block';
            setTimeout(function () {
                document.getElementById('showTips').style.display = 'none';
            }, 2000);
        }
    },
    components: {
        VueQr: main["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/editAgain.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var view_editAgain = ({
    data: function data() {
        return {
            linkPeopleList: [],
            config: {
                value: ''
            },
            textList: [],
            productCode: ""
        };
    },

    filters: {
        nullFilters: function nullFilters(value) {
            return value ? value : "--";
        },
        relationTypeFilter: function relationTypeFilter(val) {
            if (val == '1') {
                return val = '共同借款人';
            } else if (val == '2') {
                return val = '担保人';
            } else if (val == '3') {
                return val = '其他关联人';
            } else if (val == '4') {
                return val = '借款申请主体法定代表人';
            } else if (val == '5') {
                return val = '借款申请主体实际控制人';
            } else if (val == '6') {
                return val = '个人保证担保人';
            } else if (val == '7') {
                return val = '个人抵押担保人';
            } else if (val == '8') {
                return val = '个人保证担保人配偶';
            } else if (val == '9') {
                return val = '个人抵押担保人配偶';
            } else if (val == '10') {
                return val = '其他';
            } else {
                return '--';
            }
        },
        identityFilter: function identityFilter(val) {
            if (val == '1') {
                return val = '配偶';
            } else if (val == '2') {
                return val = '朋友';
            } else if (val == '7') {
                return val = '朋友配偶';
            } else if (val == '3') {
                return val = '亲戚';
            } else if (val == '8') {
                return val = '亲戚配偶';
            } else if (val == '4') {
                return val = '其他';
            } else if (val == '5') {
                return val = '合伙人';
            } else if (val == '6') {
                return val = '合伙人配偶';
            } else {
                return '--';
            }
        }
    },
    created: function created() {
        this.getProductCodeFun();
    },
    mounted: function mounted() {
        this.getloadRelation();
    },

    methods: {
        getProductCodeFun: function getProductCodeFun() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    if (_this.productCode === '6000') {
                        _this.config.value = window.location.origin + '/#/certified?loanOrderCode=' + _this.$route.query.loanOrderCode;
                        var a = document.getElementById('qrUrl').getElementsByTagName("img");
                        a[0].alt = _this.config.value;
                    }

                    text_default.a.map(function (item, index) {
                        if (_this.productCode === item.code) {
                            _this.textList = item;
                            return;
                        }
                        return;
                    });
                }
            });
        },
        getloadRelation: function getloadRelation() {
            var _this2 = this;

            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    _this2.linkPeopleList = retsult.relationList;
                }
            });
        },
        editBack: function editBack() {
            this.$router.push("/editPerson");
        },
        copyQrUrl: function copyQrUrl() {
            var input = document.getElementById('textarea');
            input.value = this.config.value;
            input.select();
            document.execCommand("Copy");
            document.getElementById('showTips').style.display = 'block';
            setTimeout(function () {
                document.getElementById('showTips').style.display = 'none';
            }, 2000);
        }
    },
    components: {
        VueQr: main["a" /* default */]
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9746024","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/editAgain.vue
var editAgain_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.textList.editagain))]),_vm._v(" "),(_vm.productCode === '6000')?_c('div',[_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"redFont"},[_vm._v("长按保存下方二维码")]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"qrbox"},[_c('vue-qr',{staticClass:"qr-code-pic",attrs:{"tabindex":"0","text":_vm.config.value,"size":230,"correctLevel":4,"margin":10}}),_vm._v(" "),_c('textarea',{staticClass:"qrText",attrs:{"tabindex":"-1","name":"","id":"textarea","readonly":""}})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"copySrc",on:{"click":_vm.copyQrUrl}},[_c('img',{staticClass:"pictureTips",attrs:{"aria-hidden":"false","src":__webpack_require__("rjgy"),"alt":"点击此处复制链接"}}),_vm._v("点击此处复制链接")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("其他贷款义务人或相关人士信息详情\n        "),_c('span',{on:{"click":_vm.editBack}},[_vm._v("编辑"),_c('img',{attrs:{"aria-hidden":"true","src":__webpack_require__("KzIr"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-bgbox"},[_vm._l((_vm.linkPeopleList),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',[_vm._v("其他贷款义务人或相关人士"+_vm._s(index+1)+"：")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("其他贷款义务人或相关人士身份")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("relationTypeFilter")(item.relationType)))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("nullFilters")(item.userName)))])]),_vm._v(" "),(_vm.productCode === '6000')?_c('div',[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("与借款申请人关系")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("identityFilter")(item.identity)))])])]):_vm._e(),_vm._v(" "),(['6', '7', '8'].indexOf(item.identity) > -1 || (_vm.productCode === '7000' && item.spouseName))?_c('div',{staticClass:"global-unit-4"}):_vm._e(),_vm._v(" "),((['6', '7', '8'].indexOf(item.identity) > -1) || (_vm.productCode === '7000' && item.spouseName))?_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("此其他贷款义务人或相关人士配偶姓名")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("nullFilters")(item.spouseName)))])]):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-unit-4"}):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('dl',{staticClass:"global-bgboxList"},[_c('dt',[_vm._v("手机号码（选填）")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('dd',{staticClass:"UniversNextforHSBCMedium font-size-18"},[_vm._v(_vm._s(_vm._f("nullFilters")(item.mobile)))])]):_vm._e(),_vm._v(" "),(index != _vm.linkPeopleList.length-1)?_c('div',{staticClass:"global-unit-4"}):_vm._e(),_vm._v(" "),(index != _vm.linkPeopleList.length-1)?_c('div',{staticClass:"global-hr"}):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})],2),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var editAgain_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-title-wrap",attrs:{"role":"region"}},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("欢迎回来")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-alert-tips",attrs:{"id":"showTips"}},[_c('p',[_vm._v("复制成功")])])}]
var editAgain_esExports = { render: editAgain_render, staticRenderFns: editAgain_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_editAgain = (editAgain_esExports);
// CONCATENATED MODULE: ./src/view/editAgain.vue
function editAgain_injectStyle (ssrContext) {
  __webpack_require__("UCfD")
}
var editAgain_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editAgain___vue_template_functional__ = false
/* styles */
var editAgain___vue_styles__ = editAgain_injectStyle
/* scopeId */
var editAgain___vue_scopeId__ = "data-v-b9746024"
/* moduleIdentifier (server only) */
var editAgain___vue_module_identifier__ = null
var editAgain_Component = editAgain_normalizeComponent(
  view_editAgain,
  selectortype_template_index_0_src_view_editAgain,
  editAgain___vue_template_functional__,
  editAgain___vue_styles__,
  editAgain___vue_scopeId__,
  editAgain___vue_module_identifier__
)

/* harmony default export */ var src_view_editAgain = (editAgain_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/editperson.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var editperson = ({
    components: {
        Alert: src_components_alert
    },
    // 项目管理
    data: function data() {
        return {
            addNum: false,
            lastNameText: '姓名不能为空！',
            indexs: '',
            items: [],
            isRelationType: false,
            isName: false,
            otherSpouseNameText: '请填写！',
            otherSpouseNameList: [],
            isSpouseName: false,
            isCardId: '',
            relationList: [{
                value: "00",
                label: "请选择",
                relationType: '0',
                userName: '',
                mobile: '',
                idNo: '',
                identity: '0',
                spouseName: '',
                isName: false,
                isSpouseName: false,
                isRelationType: false,
                isidentity: false,
                isActiveFlag: false,
                tagger: 1,
                isMobile: false,
                mobileTxt: '',
                isOtherSpouseName: false,
                otherSpouseName: ""
            }],
            dataList: null,
            num: 0,
            isChangeName: false,
            changeNameTxt: '',
            isAllRrquridSuccess: false,
            isCheckBox: false,
            checked01: false,
            textList: [],
            productCode: ""
        };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        isActiveFData: function isActiveFData(item, index) {
            var arr = [];
            this.otherSpouseNameList.map(function (i) {
                arr.push(i.userName);
            });
            if (item.activeFlag == "1" && item.spouseNames != "" && arr.indexOf(item.spouseName) == -1) {
                this.relationList[index].isActiveFlag = true;
            } else {
                this.relationList[index].isActiveFlag = false;
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.checked01 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        },
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },
        mobileBlur: function mobileBlur(item) {
            if (item.mobile.length < 11) {
                item.mobile = '';
                item.isMobile = true;
                item.mobileTxt = '手机号码位数不够！';
            } else {
                item.isMobile = false;
            }
        },
        init: function init() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode', _this.productCode);
                    text_default.a.map(function (item, index) {
                        if (_this.productCode === item.code) {
                            _this.textList = item;
                            _this.getlist();
                            return;
                        }
                        return;
                    });
                }
            });
        },
        getlist: function getlist() {
            var _this2 = this;

            console.log('code', this.productCode);
            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    if (retsult.relationList.length > 0) {
                        _this2.relationList = retsult.relationList;
                        _this2.otherSpouseNameList = [];
                        var arr = [];
                        var arr1 = [];
                        _this2.relationList.forEach(function (item, index) {
                            // 获取配偶姓名和下标
                            arr1.push({ 'data': item.spouseName, 'index': index });
                            // 存储配偶姓名，避免实施修改
                            item.spouseNames = item.spouseName;
                            // 配偶姓名的下拉选项
                            if (_this2.productCode == '6000') {
                                if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            } else if (_this2.productCode == '7000') {
                                if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            }
                        });
                        // 是否重复
                        _this2.otherSpouseNameList.map(function (item, index) {
                            arr.push(item.userName);
                        });
                        arr1.map(function (k, y) {
                            if (arr.indexOf(k.data) > -1) {
                                _this2.relationList[y].isActiveFlag = false;
                            } else {
                                _this2.relationList[y].isActiveFlag = true;
                            }
                        });
                    }
                }
            });
        },
        isAllSuccess: function isAllSuccess() {
            var item = this.relationList;
            var isAllS = 0;
            for (var i = 0; i < item.length; i++) {
                if (this.productCode === '6000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isidentity || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                } else if (this.productCode === '7000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                }
            }
            if (isAllS > 0 || this.isCheckBox) {
                return this.isAllRrquridSuccess = true;
            } else {
                return this.isAllRrquridSuccess = false;
            }
        },
        identityChangeList: function identityChangeList(item, index) {
            var _this3 = this;

            if (this.productCode == '6000') {
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this3.otherSpouseNameList.push(item);
                    }
                });
                if (['6', '7', '8'].indexOf(item.identity) == -1) {
                    // 如果选择的不是合伙人配偶、朋友配偶、亲戚配偶，那就隐藏请填写的input
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
            }
        },
        identityChange: function identityChange(item, index) {
            if (item.identity && item.identity == '0') {
                this.relationList[index].isidentity = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isidentity = false;
                this.isAllSuccess();
            }
        },
        relationTypeChange: function relationTypeChange(item, index) {
            if (item.relationType && item.relationType == '0') {
                this.relationList[index].isRelationType = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isRelationType = false;
                this.isAllSuccess();
            }
        },
        userNameChange: function userNameChange(item, index) {
            var _this4 = this;

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.userName && !reg.test(item.userName)) {
                this.lastNameText = '姓名请输入中文！';
                this.relationList[index].isName = true;
            } else {
                if (!item.userName) {
                    this.relationList[index].isName = true;
                    this.isAllSuccess();
                } else {
                    if (this.productCode === '7000') {
                        // productcode 7000
                        this.otherSpouseNameList = [];
                        //选择了 8 9 之外的需要在relationList添加人名
                        this.relationList.forEach(function (item, index) {
                            if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                _this4.otherSpouseNameList.push(item);
                            }
                        });
                        if (['8', '9'].indexOf(item.relationType) == -1) {
                            // 如果选择的不是8 9，那就隐藏请填写的input
                            this.relationList[index].isOtherSpouseName = false;
                            this.isAllSuccess();
                        }
                    }
                    this.relationList[index].isName = false;
                    this.isAllSuccess();
                }
            }
        },
        otherSpouseNameChange: function otherSpouseNameChange(item, index) {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.otherSpouseName && !reg.test(item.otherSpouseName)) {
                this.otherSpouseNameText = '请填写中文！';
                this.relationList[index].isOtherSpouseName = true;
            } else {
                if (!item.otherSpouseName) {
                    this.relationList[index].isOtherSpouseName = true;
                    this.isAllSuccess();
                } else {
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
            }
        },
        spouseNameChange: function spouseNameChange(item, index) {
            if (!item.spouseName) {
                this.relationList[index].isSpouseName = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isSpouseName = false;
                this.isAllSuccess();
            }
        },
        addItem: function addItem() {
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            } else {

                if (this.relationList.length < 10) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            }
        },
        affirm: function affirm(item, index) {
            this.$refs.alert.showAlert();
            this.items = item;
            this.indexs = index;
        },
        cancelInfo: function cancelInfo() {
            this.$refs.alert.closeAlert();
        },
        deleteItem: function deleteItem(item, indexs) {
            var _this5 = this;

            if (item.tagger) {
                this.relationList.splice(indexs, 1);
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this5.otherSpouseNameList.push(item);
                    }
                });
                this.cancelInfo();
            } else {
                deleteRelation(item).then(function (result) {
                    if (result.responseCode === "000000") {
                        var retsult = result.responseData;
                        _this5.relationList = retsult.relationList;
                        _this5.cancelInfo();
                        _this5.init();
                    }
                });
            }
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.addNum = false;
                }
            } else {
                if (this.relationList.length < 10) {
                    this.addNum = false;
                }
            }
        },
        next: function next() {
            // if(this.productCode === '6000'){
            this.verNoticeBox();
            // }
            this.isAllRrquridSuccess = false;
            for (var i = 0; i < this.relationList.length; i++) {
                this.relationTypeChange(this.relationList[i], i);
                this.userNameChange(this.relationList[i], i);
                this.identityChange(this.relationList[i], i);
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 || this.productCode === '7000' && (this.relationList[i].relationType == '8' || this.relationList[i].relationType == '9')) {
                    this.spouseNameChange(this.relationList[i], i);
                }
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 && this.relationList[i].spouseName == "其他") {
                    this.otherSpouseNameChange(this.relationList[i], i);
                }
            }
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.pass();
            }
        },
        pass: function pass() {
            var _this6 = this;

            var param = [];
            this.relationList.map(function (item, index) {
                param.push({
                    id: item.id,
                    mobile: item.mobile,
                    userName: item.userName,
                    relationType: item.relationType,
                    identity: item.identity,
                    spouseName: item.spouseName != "其他" ? item.spouseName : item.otherSpouseName
                });
            });
            recordRelationHandler({ relationList: param, type1006: this.checked01 }).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage,
                            editAgain: 'edit'
                        }
                    });
                }
            });
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/editAgain"
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/editperson.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var view_editperson = ({
    components: {
        Alert: src_components_alert
    },
    // 项目管理
    data: function data() {
        return {
            addNum: false,
            lastNameText: '姓名不能为空！',
            indexs: '',
            items: [],
            isRelationType: false,
            isName: false,
            otherSpouseNameText: '请填写！',
            otherSpouseNameList: [],
            isSpouseName: false,
            isCardId: '',
            relationList: [{
                value: "00",
                label: "请选择",
                relationType: '0',
                userName: '',
                mobile: '',
                idNo: '',
                identity: '0',
                spouseName: '',
                isName: false,
                isSpouseName: false,
                isRelationType: false,
                isidentity: false,
                isActiveFlag: false,
                tagger: 1,
                isMobile: false,
                mobileTxt: '',
                isOtherSpouseName: false,
                otherSpouseName: ""
            }],
            dataList: null,
            num: 0,
            isChangeName: false,
            changeNameTxt: '',
            isAllRrquridSuccess: false,
            isCheckBox: false,
            checked01: false,
            textList: [],
            productCode: ""
        };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        isActiveFData: function isActiveFData(item, index) {
            var arr = [];
            this.otherSpouseNameList.map(function (i) {
                arr.push(i.userName);
            });
            if (item.activeFlag == "1" && item.spouseNames != "" && arr.indexOf(item.spouseName) == -1) {
                this.relationList[index].isActiveFlag = true;
            } else {
                this.relationList[index].isActiveFlag = false;
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.checked01 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        },
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },
        mobileBlur: function mobileBlur(item) {
            if (item.mobile.length < 11) {
                item.mobile = '';
                item.isMobile = true;
                item.mobileTxt = '手机号码位数不够！';
            } else {
                item.isMobile = false;
            }
        },
        init: function init() {
            var _this = this;

            var url = "/portal/" + 'getProductCode';
            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (res) {
                if (res.data.responseCode === '000000') {
                    _this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode', _this.productCode);
                    text_default.a.map(function (item, index) {
                        if (_this.productCode === item.code) {
                            _this.textList = item;
                            _this.getlist();
                            return;
                        }
                        return;
                    });
                }
            });
        },
        getlist: function getlist() {
            var _this2 = this;

            console.log('code', this.productCode);
            loadRelation({}).then(function (result) {
                if (result.responseCode === "000000") {
                    var retsult = result.responseData;
                    if (retsult.relationList.length > 0) {
                        _this2.relationList = retsult.relationList;
                        _this2.otherSpouseNameList = [];
                        var arr = [];
                        var arr1 = [];
                        _this2.relationList.forEach(function (item, index) {
                            // 获取配偶姓名和下标
                            arr1.push({ 'data': item.spouseName, 'index': index });
                            // 存储配偶姓名，避免实施修改
                            item.spouseNames = item.spouseName;
                            // 配偶姓名的下拉选项
                            if (_this2.productCode == '6000') {
                                if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            } else if (_this2.productCode == '7000') {
                                if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                    _this2.otherSpouseNameList.push(item);
                                } else {
                                    item.isActiveFlag = false;
                                }
                            }
                        });
                        // 是否重复
                        _this2.otherSpouseNameList.map(function (item, index) {
                            arr.push(item.userName);
                        });
                        arr1.map(function (k, y) {
                            if (arr.indexOf(k.data) > -1) {
                                _this2.relationList[y].isActiveFlag = false;
                            } else {
                                _this2.relationList[y].isActiveFlag = true;
                            }
                        });
                    }
                }
            });
        },
        isAllSuccess: function isAllSuccess() {
            var item = this.relationList;
            var isAllS = 0;
            for (var i = 0; i < item.length; i++) {
                if (this.productCode === '6000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isidentity || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                } else if (this.productCode === '7000' && (item[i].isRelationType || item[i].isName || item[i].isSpouseName || item[i].isOtherSpouseName)) {
                    isAllS = isAllS + 1;
                }
            }
            if (isAllS > 0 || this.isCheckBox) {
                return this.isAllRrquridSuccess = true;
            } else {
                return this.isAllRrquridSuccess = false;
            }
        },
        identityChangeList: function identityChangeList(item, index) {
            var _this3 = this;

            if (this.productCode == '6000') {
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this3.otherSpouseNameList.push(item);
                    }
                });
                if (['6', '7', '8'].indexOf(item.identity) == -1) {
                    // 如果选择的不是合伙人配偶、朋友配偶、亲戚配偶，那就隐藏请填写的input
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
            }
        },
        identityChange: function identityChange(item, index) {
            if (item.identity && item.identity == '0') {
                this.relationList[index].isidentity = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isidentity = false;
                this.isAllSuccess();
            }
        },
        relationTypeChange: function relationTypeChange(item, index) {
            if (item.relationType && item.relationType == '0') {
                this.relationList[index].isRelationType = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isRelationType = false;
                this.isAllSuccess();
            }
        },
        userNameChange: function userNameChange(item, index) {
            var _this4 = this;

            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.userName && !reg.test(item.userName)) {
                this.lastNameText = '姓名请输入中文！';
                this.relationList[index].isName = true;
            } else {
                if (!item.userName) {
                    this.relationList[index].isName = true;
                    this.isAllSuccess();
                } else {
                    if (this.productCode === '7000') {
                        // productcode 7000
                        this.otherSpouseNameList = [];
                        //选择了 8 9 之外的需要在relationList添加人名
                        this.relationList.forEach(function (item, index) {
                            if (['8', '9'].indexOf(item.relationType) == -1 && item.userName != "") {
                                _this4.otherSpouseNameList.push(item);
                            }
                        });
                        if (['8', '9'].indexOf(item.relationType) == -1) {
                            // 如果选择的不是8 9，那就隐藏请填写的input
                            this.relationList[index].isOtherSpouseName = false;
                            this.isAllSuccess();
                        }
                    }
                    this.relationList[index].isName = false;
                    this.isAllSuccess();
                }
            }
        },
        otherSpouseNameChange: function otherSpouseNameChange(item, index) {
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (item.otherSpouseName && !reg.test(item.otherSpouseName)) {
                this.otherSpouseNameText = '请填写中文！';
                this.relationList[index].isOtherSpouseName = true;
            } else {
                if (!item.otherSpouseName) {
                    this.relationList[index].isOtherSpouseName = true;
                    this.isAllSuccess();
                } else {
                    this.relationList[index].isOtherSpouseName = false;
                    this.isAllSuccess();
                }
            }
        },
        spouseNameChange: function spouseNameChange(item, index) {
            if (!item.spouseName) {
                this.relationList[index].isSpouseName = true;
                this.isAllSuccess();
            } else {
                this.relationList[index].isSpouseName = false;
                this.isAllSuccess();
            }
        },
        addItem: function addItem() {
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            } else {

                if (this.relationList.length < 10) {
                    this.relationList.push({
                        value: "00",
                        label: "请选择",
                        relationType: '0',
                        userName: '',
                        mobile: '',
                        idNo: '',
                        identity: '0',
                        spouseName: '',
                        isName: false,
                        isSpouseName: false,
                        isRelationType: false,
                        isidentity: false,
                        isActiveFlag: false,
                        tagger: '1',
                        isMobile: false,
                        mobileTxt: ''
                    });
                    this.addNum = false;
                } else {
                    this.addNum = true;
                }
            }
        },
        affirm: function affirm(item, index) {
            this.$refs.alert.showAlert();
            this.items = item;
            this.indexs = index;
        },
        cancelInfo: function cancelInfo() {
            this.$refs.alert.closeAlert();
        },
        deleteItem: function deleteItem(item, indexs) {
            var _this5 = this;

            if (item.tagger) {
                this.relationList.splice(indexs, 1);
                this.otherSpouseNameList = [];
                this.relationList.forEach(function (item, index) {
                    if (['2', '3', '5'].indexOf(item.identity) > -1 && item.userName != "") {
                        _this5.otherSpouseNameList.push(item);
                    }
                });
                this.cancelInfo();
            } else {
                deleteRelation(item).then(function (result) {
                    if (result.responseCode === "000000") {
                        var retsult = result.responseData;
                        _this5.relationList = retsult.relationList;
                        _this5.cancelInfo();
                        _this5.init();
                    }
                });
            }
            if (this.productCode == '7000') {
                if (this.relationList.length < 20) {
                    this.addNum = false;
                }
            } else {
                if (this.relationList.length < 10) {
                    this.addNum = false;
                }
            }
        },
        next: function next() {
            // if(this.productCode === '6000'){
            this.verNoticeBox();
            // }
            this.isAllRrquridSuccess = false;
            for (var i = 0; i < this.relationList.length; i++) {
                this.relationTypeChange(this.relationList[i], i);
                this.userNameChange(this.relationList[i], i);
                this.identityChange(this.relationList[i], i);
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 || this.productCode === '7000' && (this.relationList[i].relationType == '8' || this.relationList[i].relationType == '9')) {
                    this.spouseNameChange(this.relationList[i], i);
                }
                if (['6', '7', '8'].indexOf(this.relationList[i].identity) > -1 && this.relationList[i].spouseName == "其他") {
                    this.otherSpouseNameChange(this.relationList[i], i);
                }
            }
            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.pass();
            }
        },
        pass: function pass() {
            var _this6 = this;

            var param = [];
            this.relationList.map(function (item, index) {
                param.push({
                    id: item.id,
                    mobile: item.mobile,
                    userName: item.userName,
                    relationType: item.relationType,
                    identity: item.identity,
                    spouseName: item.spouseName != "其他" ? item.spouseName : item.otherSpouseName
                });
            });
            recordRelationHandler({ relationList: param, type1006: this.checked01 }).then(function (result) {
                if (result.responseCode === "000000") {
                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    _this6.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage,
                            editAgain: 'edit'
                        }
                    });
                }
            });
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/editAgain"
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113af58d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/editperson.vue
var editperson_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linkpeople"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_vm._l((_vm.relationList),function(item,index){return _c('div',{key:index,staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isRelationType),expression:"item.isRelationType"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isRelationType,"aria-label":"错误提示，请选择关联人身份！"}},[_vm._v("关联人"+_vm._s(index+1)+"请选择关联人身份！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isName),expression:"item.isName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isName,"aria-label":'错误提示，'+ _vm.lastNameText}},[_vm._v("关联人"+_vm._s(index+1)+_vm._s(_vm.lastNameText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.productCode === '6000' && item.isidentity),expression:"productCode === '6000' && item.isidentity"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isidentity,"aria-label":"错误提示，请选择与借款申请人关系！"}},[_vm._v("关联人"+_vm._s(index+1)+"请选择与借款申请人关系！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isSpouseName),expression:"item.isSpouseName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isSpouseName,"aria-label":"错误提示，"+_vm.textList.linkpeople_error}},[_vm._v(_vm._s(_vm.textList.linkpeople_error))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isOtherSpouseName),expression:"item.isOtherSpouseName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":'#'+item.isOtherSpouseName,"aria-label":'错误提示，'+ _vm.otherSpouseNameText}},[_vm._v("关联人"+_vm._s(index+1)+_vm._s(_vm.otherSpouseNameText))])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCheckBox","aria-label":"错误提示，请阅读并勾选！"}},[_vm._v("请阅读并勾选！")])])],2)]),_vm._v(" "),_c('div',{staticClass:"global-con-black"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"point"},[(_vm.productCode === '6000')?_c('p',[_vm._v("\n                * 其他贷款义务人或相关人士是指与借款申请人为此次贷款申请相关的人士，包括但不限于借款申请人配偶，联名申请人及其配偶，担保人及其配偶，以及其他等"),_c('br'),_vm._v("\n                如无其他贷款义务人或相关人士，请在其他贷款义务人或相关人士1其他贷款义务人或相关人士身份选择“其他”、姓名栏填写“无”、与借款申请人关系选择“其他”，然后点击“下一步”\n            ")]):_vm._e(),_vm._v(" "),(_vm.productCode === '7000')?_c('p',[_vm._v("\n               * 其他贷款义务人或相关人士是指与借款申请主体此次贷款申请相关的人士，包括但不限于借款申请主体的法定代表人、实际控制人、个人保证担保人、个人抵押担保人、个人保证担保人配偶、个人抵押担保人配偶，以及其他等\n            ")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.relationList),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"listTip"},[_c('b',[_vm._v("其他贷款义务人或相关人士"+_vm._s(index+1)+"：")]),_vm._v(" "),((_vm.relationList.length > 1 && item.tagger == '1') || (item.creditStatus == null))?_c('span',{attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.affirm(item,index)}}},[_vm._v(" \n                    删除 "),_c('img',{staticClass:"pictureTips",attrs:{"width":"18","aria-hidden":"true","src":__webpack_require__("vYue"),"alt":"删除"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"relationType"}},[_vm._v("其他贷款义务人或相关人士身份")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isRelationType'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.relationType),expression:"item.relationType"}],class:{'global-select-error':item.isRelationType},attrs:{"aria-invalid":"true","aria-describedby":"HelpText0","disabled":item.status && item.status!='unAuth',"id":"relationType","placeholder":"请选择关联人身份"},on:{"blur":function($event){return _vm.relationTypeChange(item,index)},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "relationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":"请选择关联人身份","value":"0"}},[_vm._v("请选择关联人身份")]),_vm._v(" "),_vm._l((_vm.textList.linkpeople),function(item,index){return _c('option',{key:index,attrs:{"label":item.label},domProps:{"value":item.value}},[_vm._v(_vm._s(item.label))])})],2),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isRelationType),expression:"item.isRelationType"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText0","aria-label":"错误提示，请选择关联人身份！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择关联人身份！")])])]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"Name"}},[_vm._v("姓名")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isName'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(item.userName),expression:"item.userName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':item.isName},attrs:{"id":"Name","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","type":"text","aria-invalid":"true","aria-describedby":"HelpText1","disabled":item.status && item.status!='unAuth',"placeholder":"请填写其他贷款义务人或相关人士姓名"},domProps:{"value":(item.userName)},on:{"blur":[function($event){return _vm.userNameChange(item,index)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "userName", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isName),expression:"item.isName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1","aria-label":'错误提示，'+_vm.lastNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.lastNameText))])]),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"identity"}},[_vm._v("与借款申请人关系")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isIdentity'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.identity),expression:"item.identity"}],class:{'global-select-error':item.isIdentity},attrs:{"aria-invalid":"true","disabled":item.status && item.status!='unAuth',"id":"identity","placeholder":"请选择与借款申请人关系"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "identity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.identityChangeList(item,index)}]}},[_c('option',{attrs:{"label":"请选择与借款申请人关系","value":"0"}},[_vm._v("请选择与借款申请人关系")]),_vm._v(" "),_c('option',{attrs:{"label":"配偶","value":"1"}},[_vm._v("配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"合伙人","value":"5"}},[_vm._v("合伙人")]),_vm._v(" "),_c('option',{attrs:{"label":"合伙人配偶","value":"6"}},[_vm._v("合伙人配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"朋友","value":"2"}},[_vm._v("朋友")]),_vm._v(" "),_c('option',{attrs:{"label":"朋友配偶","value":"7"}},[_vm._v("朋友配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"亲戚","value":"3"}},[_vm._v("亲戚")]),_vm._v(" "),_c('option',{attrs:{"label":"亲戚配偶","value":"8"}},[_vm._v("亲戚配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"其他","value":"4"}},[_vm._v("其他")])]),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isidentity),expression:"item.isidentity"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText00","aria-label":"错误提示，请选择与借款申请人关系！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择与借款申请人关系！")])])]):_vm._e(),_vm._v(" "),(['6', '7', '8'].indexOf(item.identity) > -1 ||(_vm.productCode === '7000' &&(item.relationType == '8'|| item.relationType == '9')))?_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"spouseName"}},[_vm._v("此其他贷款义务人或相关人士配偶姓名")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isSpouseName'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.spouseName),expression:"item.spouseName"}],class:{'global-select-error':item.isSpouseName},attrs:{"aria-describedby":"HelpText7","aria-invalid":"true","disabled":item.status && item.status!='unAuth',"id":"spouseName","placeholder":"请选择此其他贷款义务人或相关人士配偶姓名"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "spouseName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.spouseNameChange(item,index)}],"focus":function($event){return _vm.isActiveFData(item,index)}}},[_vm._l((_vm.otherSpouseNameList),function(i,index){return _c('option',{key:index,attrs:{"label":i.userName},domProps:{"value":i.userName}},[_vm._v(" "+_vm._s(i.userName)+"\n                        ")])}),_vm._v(" "),(item.isActiveFlag)?_c('option',{attrs:{"label":item.spouseNames},domProps:{"value":item.spouseNames}},[_vm._v(" "+_vm._s(item.spouseNames)+" ")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"label":"其他","value":"其他"}},[_vm._v("其他")])],2),_vm._v(" "),_c('span'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isSpouseName),expression:"item.isSpouseName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText7","aria-label":"错入提示，"+_vm.textList.linkpeople_error}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.textList.linkpeople_error))])])]):_vm._e(),_vm._v(" "),(['其他'].indexOf(item.spouseName) > -1 && ['6', '7', '8'].indexOf(item.identity) > -1)?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"otherSpouseName"}},[_vm._v("请填写")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":index+1+'isOtherSpouseName'}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(item.otherSpouseName),expression:"item.otherSpouseName",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"aria-describedby":"HelpText9","id":"otherSpouseName","onkeyup":"this.value=this.value.replace(/\\u4e00-\\u9fa5/g,'')","type":"text","aria-invalid":"true","disabled":item.status && item.status!='unAuth',"placeholder":"请填写"},domProps:{"value":(item.otherSpouseName)},on:{"blur":[function($event){return _vm.otherSpouseNameChange(item,index)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "otherSpouseName", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(item.isOtherSpouseName),expression:"item.isOtherSpouseName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText9","aria-label":'错误提示，'+_vm.otherSpouseNameText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.otherSpouseNameText))])]):_vm._e(),_vm._v(" "),(_vm.productCode === '6000')?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"form":"mobile"}},[_vm._v("手机号码（选填）")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor"}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(item.mobile),expression:"item.mobile",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"id":"mobile","type":"text","maxlength":"11","disabled":item.status && item.status!='unAuth',"onkeyup":"this.value=this.value.replace(/\\D/g,'')","placeholder":"请填写关联人手机号"},domProps:{"value":(item.mobile)},on:{"blur":[function($event){return _vm.mobileBlur(item)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "mobile", $event.target.value.trim())}}}),_vm._v(" "),(item.isMobile)?_c('div',{staticClass:"global-requrid-feedback",attrs:{"id":"isMobile"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(item.mobileTxt))]):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('p',{staticClass:"copySrc",attrs:{"tabindex":"0"},on:{"click":_vm.addItem}},[_c('span',{staticClass:"copyAdd"},[_vm._v("+")]),_c('span',{staticClass:"copyText"},[_vm._v("添加其他贷款义务人或相关人士信息")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addNum),expression:"addNum"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":"新增关联人记录数已达上限"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("新增关联人记录数已达上限")]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText8"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked01),expression:"checked01"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText8","type":"checkbox","tabindex":"-1","value":"true","name":"checked01"},domProps:{"checked":Array.isArray(_vm.checked01)?_vm._i(_vm.checked01,"true")>-1:(_vm.checked01)},on:{"change":[function($event){var $$a=_vm.checked01,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked01=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked01=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked01=$$c}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),(_vm.productCode === '6000')?_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    本人特此承诺和保证本人已获得上述其他贷款义务人或相关人士的授权和同意，有权合法地将上述人士的信息提供给村镇银行，用于村镇银行对本人贷款预申请的审核和评估。\n                ")]):_vm._e(),_vm._v(" "),(_vm.productCode === '7000')?_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    我司和本人特此确认已获得上述其他贷款义务人或相关人士的授权和同意，有权合法地将上述人士的信息提供给汇丰村镇银行，用于汇丰村镇银行对本人贷款预申请的审核和评估。\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText6","aria-label":"错误提示，请阅读并勾选！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("\n            此处需要阅读并勾选，方可进行下一步。\n        ")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button","data-key":"logon_btn_next","role":"button"},on:{"click":_vm.next}},[_vm._v("确认修改")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-back",attrs:{"type":"button"},on:{"click":_vm.btnBack}},[_vm._v("取消")])]),_vm._v(" "),_c('alert',{ref:"alert",attrs:{"data":_vm.items}},[_c('div',{attrs:{"slot":"alert_title"},slot:"alert_title"},[_vm._v("确认删除")]),_vm._v(" "),_c('div',{attrs:{"slot":"close_icon"},slot:"close_icon"},[_c('button',{staticClass:"close-icon",attrs:{"type":"button","aria-label":"关闭按钮","title":"关闭"},on:{"click":_vm.cancelInfo}},[_c('img',{attrs:{"aria-hidden":"true","src":__webpack_require__("mq5u"),"alt":""}})])]),_vm._v(" "),_c('div',{attrs:{"slot":"alert_content"},slot:"alert_content"},[_vm._v("\n                删除后将不能恢复，但可再次手动添加，是否确认删除？\n            ")]),_vm._v(" "),_c('div',{attrs:{"slot":"btn_sure"},slot:"btn_sure"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteItem(_vm.items,_vm.indexs)}}},[_vm._v("确认删除")])]),_vm._v(" "),_c('div',{attrs:{"slot":"btn_close"},slot:"btn_close"},[_vm._v("取消")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})],2)])}
var editperson_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("修改其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请按照贷款与申请要求，填写其他贷款义务人或相关人士信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])])}]
var editperson_esExports = { render: editperson_render, staticRenderFns: editperson_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_editperson = (editperson_esExports);
// CONCATENATED MODULE: ./src/view/editperson.vue
function editperson_injectStyle (ssrContext) {
  __webpack_require__("thTP")
}
var editperson_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editperson___vue_template_functional__ = false
/* styles */
var editperson___vue_styles__ = editperson_injectStyle
/* scopeId */
var editperson___vue_scopeId__ = "data-v-113af58d"
/* moduleIdentifier (server only) */
var editperson___vue_module_identifier__ = null
var editperson_Component = editperson_normalizeComponent(
  view_editperson,
  selectortype_template_index_0_src_view_editperson,
  editperson___vue_template_functional__,
  editperson___vue_styles__,
  editperson___vue_scopeId__,
  editperson___vue_module_identifier__
)

/* harmony default export */ var src_view_editperson = (editperson_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/peopleVerification.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var peopleVerification = ({
    components: {
        photoCode: src_components_code,
        Alert: src_components_alert
    },
    data: function data() {
        return {

            isGender: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt: 'waring', //负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg: 'waring',
            sendInfo: {
                loanOrderCode: hashmap.get('loanOrderCode'),
                bankCode: hashmap.get('bankCode'),
                id: '',
                verifyCode: '', //验证码
                gender: '', //性别
                userNamePY: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '', // 名
                idCardNum: '', //身份证号码
                bankNum: '', // 银行卡
                mobile: '', //手机号
                identity: '', //关联人身份
                relationType: '', //与借款申请人关系
                spouseName: ''
            },
            //倒计时
            isSendPhone: false,
            isSendCode: true, //发送验证码按钮不可点击样式
            hint: '发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo: {
                checked01: false,
                checked02: false,
                // checked03: false,
                checked07: false,
                checked08: false
            },
            isCheckBox: false,
            isChecked: false,
            lastNEng: "",
            firstNEng: "",

            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode: false
        };
    },
    mounted: function mounted() {
        this.info();
        this.getImage();
    },

    methods: {
        info: function info() {
            var _this = this;

            loadRelationByUserName(hashmap.get('sendInfo')).then(function (result) {
                if (result.responseCode === "000000") {
                    _this.sendInfo.identity = result.responseData.identity;
                    _this.sendInfo.relationType = result.responseData.relationType;
                    _this.sendInfo.lastName = result.responseData.lastName;
                    _this.sendInfo.firstName = result.responseData.firstName;
                    _this.sendInfo.firstNameEng = result.responseData.firstNameEng;
                    _this.sendInfo.lastNameEng = result.responseData.lastNameEng;
                    _this.sendInfo.id = result.responseData.id;
                    _this.sendInfo.spouseName = result.responseData.spouseName;
                }
            });
        },

        // 获取图形验证码
        getImage: function getImage() {
            var _this2 = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this2.imgSrc = result.data.responseData.verCode;
                _this2.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/index"
            });
            return false;
        },

        //验证码
        getPhotoCode: function getPhotoCode(val) {
            this.sendInfo.verifyCode = val;
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            this.isUserName = true;
            if (!this.sendInfo.lastName) {
                this.isAllSuccess();
                this.verlastNamePY();
                return;
            }
            var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
            if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                this.sendInfo.lastNameEng = PinYin;
            }
            this.isUserName = false;
            this.isAllSuccess();
            this.verlastNamePY();
            this.lastNEng = PinYin;
        },
        verName: function verName() {
            this.isUserName = true;
            if (!this.sendInfo.firstName) {
                this.isAllSuccess();
                this.verNamePY();
                return;
            }
            var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
            if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                this.sendInfo.firstNameEng = PinYin;
            }
            this.isUserName = false;
            this.isAllSuccess();
            this.verNamePY();
            this.firstNEng = PinYin;
        },

        // 身份证校验
        verificationIdCoder: function verificationIdCoder() {
            var sex = null;
            this.isCardId = true;
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            if (this.sendInfo.idCardNum.length === 0) {
                this.cardIdTxt = "身份证号不能为空！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.idCardNum.length && this.sendInfo.idCardNum.length < 18) {
                this.cardIdTxt = "身份证号长度不够！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!this.sendInfo.idCardNum || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(this.sendInfo.idCardNum)) {
                this.cardIdTxt = "身份证号格式有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!city[this.sendInfo.idCardNum.substr(0, 2)]) {
                this.cardIdTxt = "地址编码有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else {
                //18位身份证需要验证最后一位校验位
                if (this.sendInfo.idCardNum.length === 18) {
                    var Code = this.sendInfo.idCardNum.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    //校验位
                    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++) {
                        ai = Code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];
                    if (parity[sum % 11] != Code[17]) {
                        this.cardIdTxt = "身份证号不正确！";
                        this.sendInfo.gender = '';
                        this.isAllSuccess();
                        return;
                    }
                    sex = this.sendInfo.idCardNum.substring(16, 17);
                } else {
                    sex = this.sendInfo.idCardNum.substring(13, 14);
                }
            }
            if (sex % 2 === 0) {
                this.sendInfo.gender = '02';
            } else {
                this.sendInfo.gender = '01';
            }
            this.isCardId = false;
            this.cardIdTxt = "waring";
            this.isAllSuccess();
        },

        //银行卡校验
        verBankCard: function verBankCard(e) {
            if (e.target) {
                this.sendInfo.bankNum = e.target.value;
            }
            this.isBankCard = true;
            if (this.sendInfo.bankNum === '') {
                this.bankCardTxt = '银行卡号不能为空！';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.bankNum && this.sendInfo.bankNum.length < 13) {
                this.bankCardTxt = '银行卡位数有误！';
                this.isAllSuccess();
                return;
            }
            this.isBankCard = false;
            this.bankCardTxt = 'waring';
            this.isAllSuccess();
        },

        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.sendInfo.mobile = e.target.value;
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.sendInfo.mobile == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.mobile && this.sendInfo.mobile.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.sendInfo.mobile)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess();
        },

        //获取验证码
        getVerifyCode: function getVerifyCode() {
            var _this3 = this;

            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode = this.verCode;
            this.valiCodeParams.uuId = this.uuId;
            getRelationValidCode(this.valiCodeParams).then(function (result) {
                if (result.responseCode === "000000") {

                    _this3.isDisabled = false;

                    //开始倒计时
                    _this3.countdownTime();
                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                } else if (result.responseCode == "000405") {
                    _this3.isVerCodeError = true;
                    _this3.isAllSuccess();
                    _this3.verCodeErrorText = result.responseMessage;
                }
            });
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this4 = this;

            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.imageValidCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this4.countdown.count > 0 && _this4.countdown.count <= _this4.countdown.TIME_COUNT) {
                        _this4.countdown.counts = '重发验证码（' + _this4.countdown.count + "s）";
                        _this4.countdown.count--;
                    } else {
                        clearInterval(_this4.countdown.timer);
                        _this4.imageValidCode = false;
                        _this4.getCursorCode = false;
                        _this4.countdown.timer = null;
                        _this4.countdown.counts = _this4.hint;
                        _this4.isSendPhone = false;
                        _this4.isSendCode = false;
                    }
                }, 1000);
            }
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.sendInfo.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
            }
        },


        //四要素认证
        callFourEleCheck: function callFourEleCheck() {
            var _this5 = this;

            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC';
            this.sendInfo.appName = "00PACIFIC";

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret;
            // 授权协议
            this.sendInfo.cup1002 = this.verNoticeInfo.checked01;
            this.sendInfo.type1004 = this.verNoticeInfo.checked02, this.sendInfo.type1007 = this.verNoticeInfo.checked07, this.sendInfo.type1008 = this.verNoticeInfo.checked08, hashmap.set('sendInfo', this.sendInfo);
            registerRelation(this.sendInfo).then(function (result) {
                _this5.isBindPhotoError = false;
                _this5.isAllRrquridSuccess = false;
                if (result.responseCode === "000000") {

                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var loginName = result.responseData.loginName || '';
                    var retryBtn = result.responseData.retryBtn || '';
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    _this5.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage, //认证失败还有所少次变化 后端返回
                            retryBtn: retryBtn, // '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName: loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this5.isBindPhotoError = true;
                    _this5.toastMsg = result.responseMessage;
                    _this5.isAllRrquridSuccess = true;

                    window.scrollTo(0, 0);
                }
            });
        },

        // 下一步
        pass: function pass() {
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            this.verificationIdCoder();
            this.verBankCard(1);
            this.verMobilePhone(1);
            this.verPhotoCode();

            // this.verNotice()
            this.verNoticeBox();
            this.genderChange();

            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.callFourEleCheck();
            } else {
                window.scrollTo(0, 0);
            }
        },
        genderChange: function genderChange() {
            if (!this.sendInfo.gender) {
                this.isGender = true;
                this.isAllSuccess();
            } else {
                this.isGender = false;
                this.isAllSuccess();
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isCheckBox && !this.isChecked && !this.isTaxCode && !this.isCardId && !this.isUserName && !this.isUserNamePY && !this.isBankCard && !this.isBindPhoto && !this.isBindPhotoError && !this.isGender && !this.isVerCodeError) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },
        keyEvent: function keyEvent(e) {
            if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                var a = void 0;
                if (e.currentTarget.previousElementSibling.value == '01') {
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0];
                } else {
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0];
                }
                a.focus();
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            } else {
                return;
            }
        },
        spaceEvent: function spaceEvent(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },

        //认证须知校验
        verNotice: function verNotice() {
            if (this.verNoticeInfo.checked02 === false) {
                this.isChecked = true;
                this.isAllSuccess();
            } else {
                this.isChecked = false;
                this.isAllSuccess();
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.verNoticeInfo.checked07 === false || this.verNoticeInfo.checked08 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/peopleVerification.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var view_peopleVerification = ({
    components: {
        photoCode: src_components_code,
        Alert: src_components_alert
    },
    data: function data() {
        return {

            isGender: false,

            isDisabled: true,

            isAllRrquridSuccess: false,
            isBindPhotoError: false,
            isCardId: false,
            cardIdTxt: 'waring', //负默认值是因为 无障碍测试工具要求必须要有默认值
            isUserName: false,
            isUserNamePY: false,
            isBankCard: false,
            bankCardTxt: 'waring',
            isBindPhoto: false,
            bindPhotoTxt: 'waring',
            toastMsg: 'waring',
            sendInfo: {
                loanOrderCode: hashmap.get('loanOrderCode'),
                bankCode: hashmap.get('bankCode'),
                id: '',
                verifyCode: '', //验证码
                gender: '', //性别
                userNamePY: '', //姓名（拼音）
                userName: '', // 姓名
                lastNameEng: '', //姓（拼音）
                lastName: '', //姓
                firstNameEng: '', //名（拼音）
                firstName: '', // 名
                idCardNum: '', //身份证号码
                bankNum: '', // 银行卡
                mobile: '', //手机号
                identity: '', //关联人身份
                relationType: '', //与借款申请人关系
                spouseName: ''
            },
            //倒计时
            isSendPhone: false,
            isSendCode: true, //发送验证码按钮不可点击样式
            hint: '发送验证码',
            countdown: {
                timer: null,
                count: null,
                TIME_COUNT: 120,
                counts: "发送验证码"
            },
            // 获取验证码
            photoCodeBool: false,
            valiCodeParams: {
                mobile: "",
                productCode: hashmap.get('productCode'),
                bankCode: hashmap.get('bankCode')
            },
            //认证须知是否选中
            verNoticeInfo: {
                checked01: false,
                checked02: false,
                // checked03: false,
                checked07: false,
                checked08: false
            },
            isCheckBox: false,
            isChecked: false,
            lastNEng: "",
            firstNEng: "",

            // 图形验证码
            uuId: "",
            verCodeErrorText: "",
            isVerCodeError: false,
            getVerCode: false,
            verCode: "",
            imgSrc: "",
            getCursorCode: false,
            imageValidCode: false
        };
    },
    mounted: function mounted() {
        this.info();
        this.getImage();
    },

    methods: {
        info: function info() {
            var _this = this;

            loadRelationByUserName(hashmap.get('sendInfo')).then(function (result) {
                if (result.responseCode === "000000") {
                    _this.sendInfo.identity = result.responseData.identity;
                    _this.sendInfo.relationType = result.responseData.relationType;
                    _this.sendInfo.lastName = result.responseData.lastName;
                    _this.sendInfo.firstName = result.responseData.firstName;
                    _this.sendInfo.firstNameEng = result.responseData.firstNameEng;
                    _this.sendInfo.lastNameEng = result.responseData.lastNameEng;
                    _this.sendInfo.id = result.responseData.id;
                    _this.sendInfo.spouseName = result.responseData.spouseName;
                }
            });
        },

        // 获取图形验证码
        getImage: function getImage() {
            var _this2 = this;

            var url = "/portal/" + 'image/signCaptcha';

            axios_default()({
                method: 'post',
                url: url,
                data: {}
            }).then(function (result) {
                console.log('result', result);
                _this2.imgSrc = result.data.responseData.verCode;
                _this2.uuId = result.data.responseData.uuId;
            });
        },
        verCodeChange: function verCodeChange() {
            if (this.verCode != "") {
                this.isVerCodeError = false;
                this.getCursorCode = false;
            } else {
                this.isVerCodeError = true;
                this.getCursorCode = true;
                this.isBindPhotoError = false;
                this.isAllSuccess();
            }
        },
        btnBack: function btnBack() {
            this.$router.push({
                path: "/index"
            });
            return false;
        },

        //验证码
        getPhotoCode: function getPhotoCode(val) {
            this.sendInfo.verifyCode = val;
        },

        //姓名校验
        verNamePY: function verNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.firstNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastNamePY: function verlastNamePY() {
            this.isUserNamePY = true;
            if (!this.sendInfo.lastNameEng) {
                this.isAllSuccess();
                return;
            }
            this.isUserNamePY = false;
            this.isAllSuccess();
        },
        verlastName: function verlastName() {
            this.isUserName = true;
            if (!this.sendInfo.lastName) {
                this.isAllSuccess();
                this.verlastNamePY();
                return;
            }
            var PinYin = vue_py.chineseToPinYin(this.sendInfo.lastName);
            if (this.sendInfo.lastNameEng == "" || this.sendInfo.lastNameEng == this.lastNEng) {
                this.sendInfo.lastNameEng = PinYin;
            }
            this.isUserName = false;
            this.isAllSuccess();
            this.verlastNamePY();
            this.lastNEng = PinYin;
        },
        verName: function verName() {
            this.isUserName = true;
            if (!this.sendInfo.firstName) {
                this.isAllSuccess();
                this.verNamePY();
                return;
            }
            var PinYin = vue_py.chineseToPinYin(this.sendInfo.firstName);
            if (this.sendInfo.firstNameEng == "" || this.sendInfo.firstNameEng == this.firstNEng) {
                this.sendInfo.firstNameEng = PinYin;
            }
            this.isUserName = false;
            this.isAllSuccess();
            this.verNamePY();
            this.firstNEng = PinYin;
        },

        // 身份证校验
        verificationIdCoder: function verificationIdCoder() {
            var sex = null;
            this.isCardId = true;
            var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
            if (this.sendInfo.idCardNum.length === 0) {
                this.cardIdTxt = "身份证号不能为空！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.idCardNum.length && this.sendInfo.idCardNum.length < 18) {
                this.cardIdTxt = "身份证号长度不够！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!this.sendInfo.idCardNum || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(this.sendInfo.idCardNum)) {
                this.cardIdTxt = "身份证号格式有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else if (!city[this.sendInfo.idCardNum.substr(0, 2)]) {
                this.cardIdTxt = "地址编码有误！";
                this.sendInfo.gender = '';
                this.isAllSuccess();
                return;
            } else {
                //18位身份证需要验证最后一位校验位
                if (this.sendInfo.idCardNum.length === 18) {
                    var Code = this.sendInfo.idCardNum.split('');
                    //∑(ai×Wi)(mod 11)
                    //加权因子
                    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                    //校验位
                    var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                    var sum = 0;
                    var ai = 0;
                    var wi = 0;
                    for (var i = 0; i < 17; i++) {
                        ai = Code[i];
                        wi = factor[i];
                        sum += ai * wi;
                    }
                    var last = parity[sum % 11];
                    if (parity[sum % 11] != Code[17]) {
                        this.cardIdTxt = "身份证号不正确！";
                        this.sendInfo.gender = '';
                        this.isAllSuccess();
                        return;
                    }
                    sex = this.sendInfo.idCardNum.substring(16, 17);
                } else {
                    sex = this.sendInfo.idCardNum.substring(13, 14);
                }
            }
            if (sex % 2 === 0) {
                this.sendInfo.gender = '02';
            } else {
                this.sendInfo.gender = '01';
            }
            this.isCardId = false;
            this.cardIdTxt = "waring";
            this.isAllSuccess();
        },

        //银行卡校验
        verBankCard: function verBankCard(e) {
            if (e.target) {
                this.sendInfo.bankNum = e.target.value;
            }
            this.isBankCard = true;
            if (this.sendInfo.bankNum === '') {
                this.bankCardTxt = '银行卡号不能为空！';
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.bankNum && this.sendInfo.bankNum.length < 13) {
                this.bankCardTxt = '银行卡位数有误！';
                this.isAllSuccess();
                return;
            }
            this.isBankCard = false;
            this.bankCardTxt = 'waring';
            this.isAllSuccess();
        },

        // 验证手机号码
        verMobilePhone: function verMobilePhone(e) {
            if (e.target) {
                this.sendInfo.mobile = e.target.value;
            }
            this.isBindPhoto = true;
            this.isSendPhone = true;
            this.isSendCode = true;
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (this.sendInfo.mobile == '') {
                this.bindPhotoTxt = '手机号码不能为空！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (this.sendInfo.mobile && this.sendInfo.mobile.length < 11) {
                this.bindPhotoTxt = '手机号码位数不够！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            } else if (!reg.test(this.sendInfo.mobile)) {
                this.bindPhotoTxt = '手机号码格式有误！';
                this.isSendPhone = false;
                this.isAllSuccess();
                return;
            }
            this.isBindPhoto = false;
            this.isSendPhone = false;
            this.isSendCode = false;
            this.bindPhotoTxt = 'waring';
            this.isAllSuccess();
        },

        //获取验证码
        getVerifyCode: function getVerifyCode() {
            var _this3 = this;

            this.valiCodeParams.mobile = this.sendInfo.mobile;
            this.valiCodeParams.verCode = this.verCode;
            this.valiCodeParams.uuId = this.uuId;
            getRelationValidCode(this.valiCodeParams).then(function (result) {
                if (result.responseCode === "000000") {

                    _this3.isDisabled = false;

                    //开始倒计时
                    _this3.countdownTime();
                    // this.showToast('验证码获取成功!') 尼古拉斯说不要这个提示
                } else if (result.responseCode == "000405") {
                    _this3.isVerCodeError = true;
                    _this3.isAllSuccess();
                    _this3.verCodeErrorText = result.responseMessage;
                }
            });
        },

        // 倒计时 方法
        countdownTime: function countdownTime() {
            var _this4 = this;

            if (!this.countdown.timer) {
                this.getCursorCode = true;
                this.imageValidCode = true;
                this.isSendPhone = true;
                this.isSendCode = true;
                this.countdown.count = this.countdown.TIME_COUNT;
                this.countdown.timer = setInterval(function () {
                    if (_this4.countdown.count > 0 && _this4.countdown.count <= _this4.countdown.TIME_COUNT) {
                        _this4.countdown.counts = '重发验证码（' + _this4.countdown.count + "s）";
                        _this4.countdown.count--;
                    } else {
                        clearInterval(_this4.countdown.timer);
                        _this4.imageValidCode = false;
                        _this4.getCursorCode = false;
                        _this4.countdown.timer = null;
                        _this4.countdown.counts = _this4.hint;
                        _this4.isSendPhone = false;
                        _this4.isSendCode = false;
                    }
                }, 1000);
            }
        },

        //验证码校验
        verPhotoCode: function verPhotoCode() {
            if (this.sendInfo.verifyCode.length !== 6) {
                this.photoCodeBool = true;
                this.isBindPhotoError = true;
                this.toastMsg = '验证码位数不够！';
                this.isAllSuccess();
                return false;
            } else {
                this.photoCodeBool = false;
                this.isBindPhotoError = false;
                this.toastMsg = 'waring';
                this.isAllSuccess();
            }
        },


        //四要素认证
        callFourEleCheck: function callFourEleCheck() {
            var _this5 = this;

            // 四要素需要添加项目id和用户渠道名称
            this.sendInfo.projectId = 'PACIFIC';
            this.sendInfo.appName = "00PACIFIC";

            this.sendInfo.userName = this.sendInfo.lastName + this.sendInfo.firstName;
            // this.sendInfo.userNamePY =  this.sendInfo.firstNameEng + this.sendInfo.lastNameEng
            // 拼音加空格
            var capital = this.sendInfo.firstNameEng + this.sendInfo.lastNameEng;
            var ret = "";
            for (var i = 0; i < capital.length; i++) {
                var c = capital.charAt(i);
                if (/^[A-Z]+$/.test(c) && i > 0) {
                    ret += " " + c;
                } else {
                    ret += c;
                }
            }

            this.sendInfo.userNamePY = ret;
            // 授权协议
            this.sendInfo.cup1002 = this.verNoticeInfo.checked01;
            this.sendInfo.type1004 = this.verNoticeInfo.checked02, this.sendInfo.type1007 = this.verNoticeInfo.checked07, this.sendInfo.type1008 = this.verNoticeInfo.checked08, hashmap.set('sendInfo', this.sendInfo);
            registerRelation(this.sendInfo).then(function (result) {
                _this5.isBindPhotoError = false;
                _this5.isAllRrquridSuccess = false;
                if (result.responseCode === "000000") {

                    var fbCode = result.responseData.fbCode;
                    var fbMessage = result.responseData.fbMessage;
                    var loginName = result.responseData.loginName || '';
                    var retryBtn = result.responseData.retryBtn || '';
                    var messageInfo = utils.routerJump.returnUrl(fbCode);
                    var url = messageInfo.url;
                    // this.$router.push({
                    //     path:'stepDescription'
                    // })//锚点会改变路由
                    _this5.$router.push({
                        path: url,
                        query: {
                            code: fbCode,
                            fbMessage: fbMessage, //认证失败还有所少次变化 后端返回
                            retryBtn: retryBtn, // '0' 不显示重新认证 ‘1’显示重新认证按钮
                            loginName: loginName //四要素认证登录提示，手机尾号提示 fbcode为0041
                        }
                    });
                } else if (result.responseCode === "000405") {
                    _this5.isBindPhotoError = true;
                    _this5.toastMsg = result.responseMessage;
                    _this5.isAllRrquridSuccess = true;

                    window.scrollTo(0, 0);
                }
            });
        },

        // 下一步
        pass: function pass() {
            this.isAllRrquridSuccess = false;
            this.verlastName();
            this.verName();
            this.verlastNamePY();
            this.verNamePY();
            this.verificationIdCoder();
            this.verBankCard(1);
            this.verMobilePhone(1);
            this.verPhotoCode();

            // this.verNotice()
            this.verNoticeBox();
            this.genderChange();

            var statusInfo = this.isAllSuccess();
            if (!statusInfo) {
                this.callFourEleCheck();
            } else {
                window.scrollTo(0, 0);
            }
        },
        genderChange: function genderChange() {
            if (!this.sendInfo.gender) {
                this.isGender = true;
                this.isAllSuccess();
            } else {
                this.isGender = false;
                this.isAllSuccess();
            }
        },
        isAllSuccess: function isAllSuccess() {
            if (!this.isCheckBox && !this.isChecked && !this.isTaxCode && !this.isCardId && !this.isUserName && !this.isUserNamePY && !this.isBankCard && !this.isBindPhoto && !this.isBindPhotoError && !this.isGender && !this.isVerCodeError) {
                this.isAllRrquridSuccess = false;
                return false;
            } else {
                this.isAllRrquridSuccess = true;
                return true;
            }
        },
        keyEvent: function keyEvent(e) {
            if ([37, 38, 39, 40].indexOf(e.keyCode) > -1) {
                var a = void 0;
                if (e.currentTarget.previousElementSibling.value == '01') {
                    a = e.currentTarget.parentElement.parentElement.nextElementSibling.children[0].children[0];
                } else {
                    a = e.currentTarget.parentElement.parentElement.previousElementSibling.children[0].children[0];
                }
                a.focus();
                var aa = a.name;
                this.sendInfo[aa] = a.value;
            } else {
                return;
            }
        },
        spaceEvent: function spaceEvent(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.sendInfo[aa] = e.currentTarget.previousElementSibling.value;
        },

        // 授权
        spaceEventCheckBox: function spaceEventCheckBox(e) {
            e.currentTarget.previousElementSibling.focus();
            var aa = e.currentTarget.previousElementSibling.name;
            this.verNoticeInfo[aa] = !this.verNoticeInfo[aa];
        },

        //认证须知校验
        verNotice: function verNotice() {
            if (this.verNoticeInfo.checked02 === false) {
                this.isChecked = true;
                this.isAllSuccess();
            } else {
                this.isChecked = false;
                this.isAllSuccess();
            }
        },
        verNoticeBox: function verNoticeBox() {
            if (this.verNoticeInfo.checked07 === false || this.verNoticeInfo.checked08 === false) {
                this.isCheckBox = true;
                this.isAllSuccess();
            } else {
                this.isCheckBox = false;
                this.isAllSuccess();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-997cf7b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/peopleVerification.vue
var peopleVerification_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verified"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAllRrquridSuccess),expression:"isAllRrquridSuccess"}]},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-error-tip-wrap",attrs:{"aria-live":"assertive"}},[_c('div',{staticClass:"tit-info"},[_vm._v("请更正以下问题")]),_vm._v(" "),_c('div',{staticClass:"con"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserName","aria-label":"错误提示，姓名不能为空！"}},[_vm._v("姓名不能为空！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserNamePY),expression:"isUserNamePY"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isUserNamePY","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_vm._v("姓名（英文/拼音）不能为空！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCardId),expression:"isCardId"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCardId","aria-label":'错误提示，' + _vm.cardIdTxt}},[_vm._v(_vm._s(_vm.cardIdTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBankCard),expression:"isBankCard"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBankCard","aria-label":'错误提示，' + _vm.bankCardTxt}},[_vm._v(_vm._s(_vm.bankCardTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhoto),expression:"isBindPhoto"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhoto","aria-label":'错误提示，' + _vm.bindPhotoTxt}},[_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isBindPhotoError","aria-label":'错误提示，' + _vm.toastMsg}},[_vm._v(_vm._s(_vm.toastMsg))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGender),expression:"isGender"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isGender","aria-label":"错误提示，请选择性别！"}},[_vm._v("请选择性别！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isVerCodeError","aria-label":'错误提示，'+_vm.verCodeErrorText}},[_vm._v(_vm._s(_vm.verCodeErrorText))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isCheckBox","aria-label":"错误提示，请阅读授权及声明的内容并勾选！"}},[_vm._v("请阅读授权及声明的内容并勾选！")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isChecked),expression:"isChecked"}],staticClass:"global-requrid-feedback global-bg-none"},[_c('a',{attrs:{"href":"#isChecked","aria-label":"错误提示，错误提示，请阅读完毕后勾选作出授权！"}},[_vm._v("请阅读完毕后勾选作出授权！")])])])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("身份信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserName"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastName),expression:"sendInfo.lastName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"disabled":"","aria-invalid":"true","aria-labelledby":"chineseNameR","aria-describedby":"HelpText0","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastName)},on:{"blur":[_vm.verlastName,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastName", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstName),expression:"sendInfo.firstName",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserName},attrs:{"disabled":"","aria-invalid":"true","aria-labelledby":"chineseNameL","aria-describedby":"HelpText0","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstName)},on:{"blur":[_vm.verName,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstName", $event.target.value.trim())}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserName),expression:"isUserName"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText0","aria-label":"错误提示，姓名不能为空！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("姓名不能为空！")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('div',[_vm._m(2),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isUserNamePY"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-input-wrap countryL"},[_c('label',{attrs:{"for":"lNameEng"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.lastNameEng),expression:"sendInfo.lastNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserNamePY},attrs:{"id":"lNameEng","aria-labelledby":"englishNameR","disabled":"","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.lastNameEng)},on:{"blur":[_vm.verlastNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "lastNameEng", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{staticClass:"global-input-wrap countryR"},[_c('label',{attrs:{"for":"fNameEng"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.firstNameEng),expression:"sendInfo.firstNameEng",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isUserNamePY},attrs:{"id":"fNameEng","aria-labelledby":"englishNameL","disabled":"","aria-invalid":"true","aria-describedby":"HelpText1","type":"text","maxlength":"20","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.firstNameEng)},on:{"blur":[_vm.verNamePY,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "firstNameEng", $event.target.value.trim())}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isUserNamePY),expression:"isUserNamePY"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText1","aria-label":"错误提示，姓名（英文/拼音）不能为空！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("姓名（英文/拼音）不能为空！")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"cardId"}},[_vm._v("身份证号码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"isCardId"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.idCardNum),expression:"sendInfo.idCardNum",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isCardId},attrs:{"onkeyup":"this.value=this.value.replace(/\\s/g,'')","aria-invalid":"true","aria-describedby":"HelpText2","type":"text","id":"cardId","maxlength":"18","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.idCardNum)},on:{"blur":[_vm.verificationIdCoder,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "idCardNum", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCardId),expression:"isCardId"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText2","aria-label":'错误提示，' + _vm.cardIdTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.cardIdTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap",attrs:{"role":"radiogroup","aria-labelledby":"HelpText8"}},[_c('label',{staticClass:"global-lable"},[_vm._v("性别")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"isGender"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"isChain"},[_c('div',{staticClass:"radio-margin-no-top over-flow-hidden"},[_c('label',{staticClass:"global-radioLab",attrs:{"for":"gender1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendInfo.gender),expression:"sendInfo.gender"}],staticClass:"global-radioInp",attrs:{"id":"gender1","tabindex":"-1","type":"radio","aria-describedby":"HelpText8","name":"isGender","value":"01"},domProps:{"checked":_vm._q(_vm.sendInfo.gender,"01")},on:{"change":[function($event){return _vm.$set(_vm.sendInfo, "gender", "01")},_vm.genderChange]}}),_vm._v(" "),_c('span',{staticClass:"global-radioSpa",attrs:{"tabindex":"0","aria-checked":"false","role":"radio"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEvent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEvent.apply(null, arguments)},_vm.keyEvent]}}),_vm._v("\n                        男\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"over-flow-hidden"},[_c('label',{staticClass:"global-radioLab",attrs:{"for":"gender2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendInfo.gender),expression:"sendInfo.gender"}],staticClass:"global-radioInp",attrs:{"id":"gender2","tabindex":"-1","type":"radio","aria-describedby":"HelpText8","name":"isGender","value":"02"},domProps:{"checked":_vm._q(_vm.sendInfo.gender,"02")},on:{"change":[function($event){return _vm.$set(_vm.sendInfo, "gender", "02")},_vm.genderChange]}}),_vm._v(" "),_c('span',{staticClass:"global-radioSpa",attrs:{"tabindex":"0","aria-checked":"false","role":"radio"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEvent.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEvent.apply(null, arguments)},_vm.keyEvent]}}),_vm._v("\n                        女\n                    ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGender),expression:"isGender"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText8","aria-label":"错误提示，请选择性别"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("请选择性别")])]),_vm._v(" "),_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"relationType"}},[_vm._v("其他贷款义务人或相关人士身份")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor"}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendInfo.relationType),expression:"sendInfo.relationType"}],attrs:{"aria-invalid":"true","disabled":"","id":"relationType","placeholder":"全部"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sendInfo, "relationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":"共同借款人","value":"1"}},[_vm._v("共同借款人")]),_vm._v(" "),_c('option',{attrs:{"label":"担保人","value":"2"}},[_vm._v("担保人")]),_vm._v(" "),_c('option',{attrs:{"label":"其他","value":"3"}},[_vm._v("其他")])]),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"global-select-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"identity"}},[_vm._v("与借款申请人关系")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-select select-margin"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendInfo.identity),expression:"sendInfo.identity"}],attrs:{"id":"identity","aria-invalid":"true","disabled":"","aria-describedby":"HelpText1","placeholder":"全部"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sendInfo, "identity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"label":"配偶","value":"1"}},[_vm._v("配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"合伙人","value":"5"}},[_vm._v("合伙人")]),_vm._v(" "),_c('option',{attrs:{"label":"合伙人配偶","value":"6"}},[_vm._v("合伙人配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"朋友","value":"2"}},[_vm._v("朋友")]),_vm._v(" "),_c('option',{attrs:{"label":"朋友配偶","value":"7"}},[_vm._v("朋友配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"亲戚","value":"3"}},[_vm._v("亲戚")]),_vm._v(" "),_c('option',{attrs:{"label":"亲戚配偶","value":"8"}},[_vm._v("亲戚配偶")]),_vm._v(" "),_c('option',{attrs:{"label":"其他","value":"4"}},[_vm._v("其他")])]),_vm._v(" "),_c('span')])]),_vm._v(" "),(['6', '7', '8'].indexOf(_vm.sendInfo.identity) > -1)?_c('div',{staticClass:"global-input-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('label',{staticClass:"global-lable",attrs:{"for":"spouseName"}},[_vm._v("此其他贷款义务人或相关人士配偶姓名")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor"}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.spouseName),expression:"sendInfo.spouseName",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"id":"spouseName","disabled":"","type":"text","aria-invalid":"true","placeholder":"请填写关联人姓名"},domProps:{"value":(_vm.sendInfo.spouseName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "spouseName", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("银行卡信息")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"bankCard"}},[_vm._v("银行卡号")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBankCard"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"verified-bank-tip"},[_vm._v("\n                请输入您持有的带有中国银联标志的中国内地银行卡卡号及该卡的预留手机号码，您点击发送验证码即视为您同意并授权汇丰村镇银行向中国银联股份有限公司提供您的姓名、身份证号、银联卡卡号及手机号码用于身份验证。\n            ")]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.bankNum),expression:"sendInfo.bankNum",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isBankCard},attrs:{"type":"tel","aria-invalid":"true","aria-describedby":"HelpText3","id":"bankCard","maxlength":"19","onkeyup":"this.value=this.value.replace(/\\D/g,'')","onblur":"this.value=this.value.replace(/\\D/g,'')","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.bankNum)},on:{"blur":[_vm.verBankCard,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "bankNum", $event.target.value.trim())}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBankCard),expression:"isBankCard"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText3","aria-label":'错误提示，' + _vm.bankCardTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.bankCardTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"bindPhoto"}},[_vm._v("预留手机号")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhoto"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.sendInfo.mobile),expression:"sendInfo.mobile",modifiers:{"trim":true}}],staticClass:"global-input",class:{'global-input-error':_vm.isBindPhoto},attrs:{"disabled":_vm.isSendPhone,"aria-invalid":"true","aria-describedby":"HelpText4","type":"tel","maxlength":"11","onkeyup":"this.value=this.value.replace(/\\D/g,'')","onblur":"this.value=this.value.replace(/\\D/g,'')","id":"bindPhoto","placeholder":"请填写"},domProps:{"value":(_vm.sendInfo.mobile)},on:{"keyup":_vm.verMobilePhone,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendInfo, "mobile", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhoto),expression:"isBindPhoto"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText4","aria-label":'错误提示，' + _vm.bindPhotoTxt}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.bindPhotoTxt))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.getVerCode},attrs:{"type":"button","disabled":_vm.getVerCode,"aria-live":"polite","aria-atomic":"true"},on:{"click":_vm.getImage}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"验证码，激活刷新"}})])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"global-input-wrap"},[_c('label',{staticClass:"global-lable",attrs:{"for":"photo"}},[_vm._v("图形验证码")]),_vm._v(" "),_c('a',{staticClass:"global-placeholder-anchor",attrs:{"id":"labelVerText"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.verCode),expression:"verCode",modifiers:{"trim":true}}],staticClass:"global-input",attrs:{"disabled":_vm.imageValidCode,"maxlength":"4","id":"verCode","aria-invalid":"true","aria-describedby":"HelpText","placeholder":"请填写图形验证码"},domProps:{"value":(_vm.verCode)},on:{"blur":[_vm.verCodeChange,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.verCode=$event.target.value.trim()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVerCodeError),expression:"isVerCodeError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，'+_vm.verCodeErrorText}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(this.verCodeErrorText))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-default",class:{'btn-disabled':_vm.isSendCode||_vm.getCursorCode},attrs:{"type":"button","disabled":_vm.getCursorCode || _vm.isSendCode},on:{"click":_vm.getVerifyCode}},[_vm._v(_vm._s(_vm.countdown.counts))])]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('photo-code',{attrs:{"isDisabled":_vm.isDisabled,"photoCodeBool":_vm.photoCodeBool}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBindPhotoError),expression:"isBindPhotoError"}],staticClass:"global-requrid-feedback",attrs:{"aria-label":'错误提示，' + _vm.toastMsg}},[_c('div',{staticClass:"global-unit-2"}),_vm._v(_vm._s(_vm.toastMsg))]),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('h2',{staticClass:"global-subtitle"},[_vm._v("其他贷款义务人或相关人士授权及声明")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请仔细阅读下列内容，勾选作出相应的授权/确认后，点击下一步继续申请流程。")]),_vm._v(" "),_c('a',{attrs:{"name":"isCheckBox"}}),_vm._v(" "),_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText10"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked07),expression:"verNoticeInfo.checked07"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText10","type":"checkbox","tabindex":"-1","value":"true","name":"checked07"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked07)?_vm._i(_vm.verNoticeInfo.checked07,"true")>-1:(_vm.verNoticeInfo.checked07)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked07,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked07", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked07", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked07", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    本人知晓在申请人提交的贷款预申请及申请项下本人向汇丰村镇银行（“贵行”）提供的所有信息须经过贵行及贵行指定人员的调查确认，如有需要，本人同意根据要求配合贵行及贵行指定人员的调查、检查。本人并在此同意并授权贵行根据办理前述贷款业务、审核贷款申请和风险管理的需要向金融信用信息基础数据库查询本人的信用报告；同时授权贵行向金融信用信息基础数据库提供本人的个人信息及个人信用信息（包括不良信用信息，下称“个人信用信息”）。贵行已在此告知本人贵行将向金融信用信息基础数据库提供本人的个人信用信息，本人对此确认知悉。本人同时确认，本人知悉并理解本条款中的授权和声明及其后果。上述授权有效期截止于前述申请项下贷款得以完全清偿之日，若贷款申请未通过审核，则截止于贵行通知申请人贷款申请未能通过审核之日。贵行将对超出本授权查询本人个人信用信息的行为承担法律责任。同时，本人确认并理解，贵行为了系统维护、数据的分析、储存、管理等目的，需要将本人的个人信息披露给为上述目的向贵行提供相关服务的第三方（无论申请人的申请是否被贵行接受），本人特此授权贵行在法律法规允许的范围内向该等第三方披露本人的个人信息。\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"global-checkbox",attrs:{"role":"group"}},[_c('label',{staticClass:"global-checkboxLab",attrs:{"aria-labelledby":"HelpText11"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verNoticeInfo.checked08),expression:"verNoticeInfo.checked08"}],staticClass:"global-checkboxInp",attrs:{"aria-describedby":"HelpText11","type":"checkbox","tabindex":"-1","value":"true","name":"checked08"},domProps:{"checked":Array.isArray(_vm.verNoticeInfo.checked08)?_vm._i(_vm.verNoticeInfo.checked08,"true")>-1:(_vm.verNoticeInfo.checked08)},on:{"change":[function($event){var $$a=_vm.verNoticeInfo.checked08,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.verNoticeInfo, "checked08", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.verNoticeInfo, "checked08", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.verNoticeInfo, "checked08", $$c)}},_vm.verNoticeBox]}}),_vm._v(" "),_c('span',{staticClass:"global-checkboxSpa",attrs:{"role":"checkbox","aria-checked":"false","tabindex":"0"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.spaceEventCheckBox.apply(null, arguments)}]}}),_vm._v(" "),_c('p',{staticClass:"global-checkboxCont"},[_vm._v("\n                    本人知晓贵行将根据并依赖本人所提供的信息就相关贷款业务进行评估、预审等。本人充分了解并自愿填写、提供信息并保证本人填写、提供的信息真实、准确且在任何方面不存在误导。本人同意贵行向相关的权力机关、雇主或其他有关单位、其他贷款义务人或相关人士及其他人士收集、查询、核实、验证本人的个人信息。本人清楚了解并同意：若贵行认定或有理由怀疑本人提供的信息在任何方面不真实、不准确、不完整或已过时或存在误导，贵行有权全部或部分暂停或终止向申请人提供贷款服务，贵行对此不承担任何责任。\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckBox),expression:"isCheckBox"}],staticClass:"global-requrid-feedback",attrs:{"id":"HelpText6","aria-label":"错误提示，请阅读授权及声明的内容并勾选！"}},[_c('div',{staticClass:"global-unit-2"}),_vm._v("\n            请仔细阅读授权及声明的内容，并逐项勾选作出确认，方可继续预申请流程。\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button","data-key":"logon_btn_next","role":"button"},on:{"click":_vm.pass}},[_vm._v("下一步")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}
var peopleVerification_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-title-wrap"},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("其他贷款义务人或相关人士基本信息及身份验证")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("请提供您的个人信息及身份证和银行卡信息以完成实名认证")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"chineseNameR"}},[_vm._v("姓（中文）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"chineseNameL"}},[_vm._v("名（中文）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countryWrap"},[_c('div',{staticClass:"global-lable countryL",attrs:{"id":"englishNameR"}},[_vm._v("姓（拼音）")]),_vm._v(" "),_c('div',{staticClass:"global-lable countryR",attrs:{"id":"englishNameL"}},[_vm._v("名（拼音）")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isVerCodeError"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('a',{staticClass:"global-placeholder-anchor",attrs:{"name":"isBindPhotoError"}})])}]
var peopleVerification_esExports = { render: peopleVerification_render, staticRenderFns: peopleVerification_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_peopleVerification = (peopleVerification_esExports);
// CONCATENATED MODULE: ./src/view/peopleVerification.vue
function peopleVerification_injectStyle (ssrContext) {
  __webpack_require__("ZY3G")
}
var peopleVerification_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var peopleVerification___vue_template_functional__ = false
/* styles */
var peopleVerification___vue_styles__ = peopleVerification_injectStyle
/* scopeId */
var peopleVerification___vue_scopeId__ = "data-v-997cf7b6"
/* moduleIdentifier (server only) */
var peopleVerification___vue_module_identifier__ = null
var peopleVerification_Component = peopleVerification_normalizeComponent(
  view_peopleVerification,
  selectortype_template_index_0_src_view_peopleVerification,
  peopleVerification___vue_template_functional__,
  peopleVerification___vue_styles__,
  peopleVerification___vue_scopeId__,
  peopleVerification___vue_module_identifier__
)

/* harmony default export */ var src_view_peopleVerification = (peopleVerification_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/complete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var complete = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/complete.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var view_complete = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8ac1ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/complete.vue
var complete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var complete_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-wrap"},[_c('div',{staticClass:"global-title-wrap",attrs:{"role":"region"}},[_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"icon"},[_c('img',{attrs:{"aria-hidden":"true","alt":"成功图标","src":__webpack_require__("4N50")}})]),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("恭喜您，认证授权已完成")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',[_vm._v("您已完成个人身份验证及征信信息查询授权，感谢您的配合。我们的客户经理将尽快与您或借款申请人联系。")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{},[_vm._v("\n        如需了解汇丰村镇银行的产品和服务，您可拨打客户服务热线：400-820-3919，或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/\n    ")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"index-tip"},[_vm._v("\n        请直接关闭页面即可退出。\n    ")]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])}]
var complete_esExports = { render: complete_render, staticRenderFns: complete_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_complete = (complete_esExports);
// CONCATENATED MODULE: ./src/view/complete.vue
function complete_injectStyle (ssrContext) {
  __webpack_require__("0jK8")
}
var complete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var complete___vue_template_functional__ = false
/* styles */
var complete___vue_styles__ = complete_injectStyle
/* scopeId */
var complete___vue_scopeId__ = "data-v-5f8ac1ae"
/* moduleIdentifier (server only) */
var complete___vue_module_identifier__ = null
var complete_Component = complete_normalizeComponent(
  view_complete,
  selectortype_template_index_0_src_view_complete,
  complete___vue_template_functional__,
  complete___vue_styles__,
  complete___vue_scopeId__,
  complete___vue_module_identifier__
)

/* harmony default export */ var src_view_complete = (complete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/corpLegalFail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var corpLegalFail = ({
    data: function data() {
        return {
            fbCode: '',
            fbMessage: '',
            retryBtn: ''
        };
    },
    mounted: function mounted() {
        //实名认证message有数字次数变化后台返回
        this.fbCode = this.$route.query.code;
        this.fbMessage = this.$route.query.fbMessage;
        this.retryBtn = this.$route.query.retryBtn;
    },

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        },
        retryInfo: function retryInfo() {
            this.$router.go(-1);return false;
        }
    }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/corpLegalFail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_corpLegalFail = ({
    data: function data() {
        return {
            fbCode: '',
            fbMessage: '',
            retryBtn: ''
        };
    },
    mounted: function mounted() {
        //实名认证message有数字次数变化后台返回
        this.fbCode = this.$route.query.code;
        this.fbMessage = this.$route.query.fbMessage;
        this.retryBtn = this.$route.query.retryBtn;
    },

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        },
        retryInfo: function retryInfo() {
            this.$router.go(-1);return false;
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cbec569","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/corpLegalFail.vue
var corpLegalFail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-wrap"},[_c('div',{staticClass:"context"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap",attrs:{"role":"region"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("信息不匹配")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.fbMessage))]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[(_vm.retryBtn == '1')?_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":_vm.retryInfo}},[_vm._v("重新认证")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"global-btn btn-back",attrs:{"type":"button"},on:{"click":_vm.btnBack}},[_vm._v("返回首页 ")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])])}
var corpLegalFail_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"alt":"错误图标","aria-hidden":"true","src":__webpack_require__("FPiP")}})])}]
var corpLegalFail_esExports = { render: corpLegalFail_render, staticRenderFns: corpLegalFail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_corpLegalFail = (corpLegalFail_esExports);
// CONCATENATED MODULE: ./src/view/corpLegalFail.vue
function corpLegalFail_injectStyle (ssrContext) {
  __webpack_require__("WopM")
}
var corpLegalFail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var corpLegalFail___vue_template_functional__ = false
/* styles */
var corpLegalFail___vue_styles__ = corpLegalFail_injectStyle
/* scopeId */
var corpLegalFail___vue_scopeId__ = "data-v-2cbec569"
/* moduleIdentifier (server only) */
var corpLegalFail___vue_module_identifier__ = null
var corpLegalFail_Component = corpLegalFail_normalizeComponent(
  view_corpLegalFail,
  selectortype_template_index_0_src_view_corpLegalFail,
  corpLegalFail___vue_template_functional__,
  corpLegalFail___vue_styles__,
  corpLegalFail___vue_scopeId__,
  corpLegalFail___vue_module_identifier__
)

/* harmony default export */ var src_view_corpLegalFail = (corpLegalFail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/cupLoginTip.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cupLoginTip = ({
    data: function data() {
        return {
            loginName: ''
        };
    },
    mounted: function mounted() {
        this.loginName = this.$route.query.loginName;
    },

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        },
        loginInfo: function loginInfo() {
            this.$router.push("/login");
        }
    }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/cupLoginTip.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_cupLoginTip = ({
    data: function data() {
        return {
            loginName: ''
        };
    },
    mounted: function mounted() {
        this.loginName = this.$route.query.loginName;
    },

    methods: {
        btnBack: function btnBack() {
            this.$router.push("/index");
        },
        loginInfo: function loginInfo() {
            this.$router.push("/login");
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518649f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/cupLoginTip.vue
var cupLoginTip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-wrap"},[_c('div',{staticClass:"context"},[_c('div',{staticClass:"global-unit-5"}),_vm._v(" "),_c('div',{staticClass:"global-title-wrap",attrs:{"role":"region"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"global-unit-2"}),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("请勿重复提交申请")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("该用户已存在申请记录，您可使用手机尾号"+_vm._s(_vm.loginName.substr(_vm.loginName.length-4,4))+"直接登录，以提取/继续上一次的申请。如您手机号发生变更，请致电汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理")]),_vm._v(" "),_c('div',{staticClass:"global-unit-4"})]),_vm._v(" "),_c('div',{staticClass:"global-unit-6"}),_vm._v(" "),_c('div',{staticClass:"global-btn-wrap"},[_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":_vm.loginInfo}},[_vm._v("登录")])]),_vm._v(" "),_c('div',{staticClass:"global-unit-8"})])])}
var cupLoginTip_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"alt":"错误图标","aria-hidden":"true","src":__webpack_require__("FPiP")}})])}]
var cupLoginTip_esExports = { render: cupLoginTip_render, staticRenderFns: cupLoginTip_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_view_cupLoginTip = (cupLoginTip_esExports);
// CONCATENATED MODULE: ./src/view/cupLoginTip.vue
function cupLoginTip_injectStyle (ssrContext) {
  __webpack_require__("Za2K")
}
var cupLoginTip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cupLoginTip___vue_template_functional__ = false
/* styles */
var cupLoginTip___vue_styles__ = cupLoginTip_injectStyle
/* scopeId */
var cupLoginTip___vue_scopeId__ = "data-v-518649f0"
/* moduleIdentifier (server only) */
var cupLoginTip___vue_module_identifier__ = null
var cupLoginTip_Component = cupLoginTip_normalizeComponent(
  view_cupLoginTip,
  selectortype_template_index_0_src_view_cupLoginTip,
  cupLoginTip___vue_template_functional__,
  cupLoginTip___vue_styles__,
  cupLoginTip___vue_scopeId__,
  cupLoginTip___vue_module_identifier__
)

/* harmony default export */ var src_view_cupLoginTip = (cupLoginTip_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js
/* eslint-disable */


 //首页
 //feedback页面
 //贷款产品offer页面
 //企业信息确认页面
 //关联人认证授权
 //登录页面
 //步骤说明


 //关联人信息
 //登录信息

 //修改关联人信息
 //关联人信息
 //关联人授权成功
 //实名认证失败，有剩余次数 后端返回信息
 //请勿重复提交
vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    //静态路由
    routes: [{
        path: '/',
        name: 'Index',
        component: src_view_Index
    }, {
        path: '/index',
        name: 'Index',
        component: src_view_Index
    }, {
        path: '/feedBack',
        name: 'feedBack',
        component: src_view_feedBack
    }, {
        path: '/certified',
        name: 'certified',
        component: src_view_certified
    }, {
        path: '/stepDescription',
        name: 'stepDescription',
        component: src_view_stepDescription
    }, {
        path: '/linkPeople',
        name: 'linkPeople',
        component: src_view_linkPeople
    }, {
        path: '/editAgain',
        name: 'editAgain',
        component: src_view_editAgain
    }, {
        path: '/editperson',
        name: 'editperson',
        component: src_view_editperson
    }, {
        path: '/peopleVerification',
        name: 'peopleVerification',
        component: src_view_peopleVerification
    }, {
        path: '/complete',
        name: 'complete',
        component: src_view_complete
    }, {
        path: '/informationConfirmed',
        name: 'informationConfirmed',
        component: src_view_informationConfirmed
    }, {
        path: '/acceptLoan',
        name: 'acceptLoan',
        component: src_view_acceptLoan
    }, {
        path: '/login',
        name: 'login',
        component: src_view_login
    }, {
        path: '/corpLegalFail',
        name: 'corpLegalFail',
        component: src_view_corpLegalFail
    }, {
        path: '/cupLoginTip',
        name: 'cupLoginTip',
        component: src_view_cupLoginTip
    }]
}));
// CONCATENATED MODULE: ./src/assets/utils/request.js




 //为了使用vux的loading
// create an axios instance
var service = axios_default.a.create({
    // 刘洋本地地址
    // baseURL : 'http://10.189.41.123/portal/loan/apply/6000',
    baseURL: "/portal/loan/apply/",
    timeout: 1000000 // request timeout,
});

// request interceptor
service.interceptors.request.use(function (config) {
    config.headers['x-frame-options'] = 'SAMEORIGIN';
    if (config.formType && config.formType === 1) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        config.transformRequest = [function (data) {
            // Do whatever you want to transform the data
            var ret = '';
            for (var it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            return ret.substring(0, ret.length - 1);
        }];
    }
    if (config.formType && config.formType === 2) {
        config.headers['Content-Type'] = config.fileUploadHeaders['Content-Type'];
        config.headers['client_id'] = config.fileUploadHeaders['client_id'];
        config.headers['client_secret'] = config.fileUploadHeaders['client_secret'];
    }
    if (config.formType && config.formType === 3) {
        config.headers['client_secret'] = config.fileUploadHeaders['client_secret'];
        config.headers['client_id2'] = config.fileUploadHeaders['client_id2'];
        config.headers['client_secret2'] = config.fileUploadHeaders['client_secret2'];
        config.headers['client_id'] = config.fileUploadHeaders['client_id'];
    }
    if (config.formType && config.formType === 4) {
        config.headers['dspSession'] = config.getKeyHeaders['dspSession'];
    }
    if (config.showLoading) {
        showFullScreenLoading();
    }
    return config;
}, function (error) {
    // Do something with request error
    promise_default.a.reject(error);
});

// respone interceptor
service.interceptors.response.use(function (response) {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    // 是否需要全局loading
    if (response.config.showLoading) {
        tryHideFullScreenLoading();
    }
    var res = response.data;
    // 000405  实名认证 手机号认证失败
    // 网络连接超时也返回000000 通用超时(fbcode=0026) 贷款类型选择超时(fbcode=0036)
    // RECEIVED,SAVED 银行流水资料补充页面
    if (res.responseCode === '000000' || res.responseCode === '000405' || res.status === "RECEIVED" || res.status === "SAVED") {
        return res;
    } else {
        if (res.responseCode === '000406') {
            src_main.showToast(res.responseMessage + '！', '15rem', 4000);
            setTimeout(function () {
                src_main.$vux.toast.hide();
                router.push({ path: '/index' });
            }, 5000);
        } else if (res.responseCode === '000403') {
            src_main.showToast(res.responseMessage + '！', '15rem', 4000);
            setTimeout(function () {
                src_main.$vux.toast.hide();
                router.push({ path: '/index' });
            }, 5000);
        } else if (res.responseCode === '000500') {
            src_main.showToast(res.responseMessage + '！', '10rem');
        } else if (res.responseCode === undefined) {} else {
            src_main.showToast('网络异常，请稍后重试！', '15rem');
        }
        return promise_default.a.reject(res);
    }
}, function (error) {
    tryHideFullScreenLoading();
    console.log('interceptors', error.message);
    router.push({
        path: '/feedback',
        query: { code: '0026' }
    });
    return promise_default.a.reject(error);
});

//加载封装
function startLoading() {
    src_main.$vux.loading.show({
        text: '请稍等...'
    });
}
function endLoading() {
    src_main.$vux.loading.hide();
}
var needLoadingRequestCount = 0;
function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        endLoading();
    }
}
/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/assets/api/dataBase.js


// demo.vue 接口调用示例
function findtodolist(params) {
    return request({
        url: '/runtimeflow/findTodoList',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 首页分发接口
function index(params) {
    return request({
        url: '/index',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 首页分发接口
function logout(params) {
    return request({
        url: '/logout',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 初始化
function dataBase_init(params) {
    return request({
        url: '/init',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 获取贷款公司列表
function getCompanyList(params) {
    return request({
        url: '/getCompanyList',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 贷款公司选择列表
function companSelect(params) {
    return request({
        url: '/companySelect',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 登录 / 注册
function dataBase_login(params) {
    return request({
        url: '/login',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 获取短信验证码 登录
function getLoginPhoneValidCode(params) {
    return request({
        url: '/getLoginPhoneValidCode',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 获取短信验证吗 四要素认证
function getValiCode(params) {
    return request({
        url: '/getValidCode',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 获取短信验证吗 四要素认证
function getRelationValidCode(params) {
    return request({
        url: '/getRelationValidCode',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 贷款审批额度 贷款状态更新
function loanDetailHandler(params) {
    return request({
        url: '/loanDetailHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 确认贷款申请 贷款状态更新
function loanAmtConfirmHandler(params) {
    return request({
        url: '/loanAmtConfirmHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 企业信息获取
function queryCompanyInfo(params) {
    return request({
        url: '/queryCompanyInfo',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 企业信息确认放弃申请
function giveUpApplication(params) {
    return request({
        url: '/giveUpApplication',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 问卷调查确认放弃申请
function abandonApplication(params) {
    return request({
        url: '/abandonApplication',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 贷款类型选择
function loanChannelSelect(params) {
    return request({
        url: '/loanChannelSelect',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 四要素认证
function fourEleCheck(params) {
    return request({
        url: '/fourEleCheck',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 四要素认证反显
function getUserFourElementsInfo(params) {
    return request({
        url: '/getUserFourElementsInfo',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 四要素认证反显提交
function repeatApplyAuth(params) {
    return request({
        url: '/repeatApplyAuth',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 获取税局url地址
function getLoanTaxAuthUrl(params) {
    return request({
        url: '/getLoanTaxAuthUrl',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 问卷调查页面生成订单
function saveQuestionnaireSurvey(params) {
    return request({
        url: '/saveQuestionnaireSurvey',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// kyc 信息反显
function getKycCorpInfo(params) {
    return request({
        url: '/kycCorpInfo',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// kyc 信息反显
function sendKycSurvey(params) {
    return request({
        url: '/kycSurvey',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 税局回调
function loanTaxAuthCallback(params) {
    return request({
        url: '/getLoanTaxResult',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 测试-文件上传
function dataBase_fileUpload(params) {
    return request({
        // url: 'https://rbwm-api.hsbc.com.hk/gdu-document-upload--zz-prod-proxy/v1/documents/',    //生产
        url: 'https://devcluster.api.p2g.netd2.hsbc.com.hk/gdu-document-upload--zz-cert-proxy/v2/documents', //测试
        method: 'post',
        data: params,
        formType: 2, //文件上传接口
        fileUploadHeaders: {
            // 'client_id':'8c0fef628dd94e30a0c7bcd7b1fd34e5',      //生产
            // 'client_secret':'461044D526404E9C97968a73f3b32Eb7',  //生产
            'client_id': '92bd3df2096049229307af50a4aa397a',
            'client_secret': 'D84C1422480f4A5897a70fD902227e11',

            'Content-Type': 'multipart/form-data'
        },
        showLoading: true
    });
}
// 上传第二步
function fileUploadSec(params) {
    return request({
        // url: 'https://rbwm-api.hsbc.com.hk/gdu-document-upload-status--zz-prod-proxy/v1/documentStatus?ids=' + params.ids,               //生产
        url: 'https://devcluster.api.p2g.netd2.hsbc.com.hk/gdu-do cument-upload-status--zz-cert-proxy/v2/documentStatus?ids=' + params.ids, // 测试
        method: 'get',
        // data: ,
        formType: 3, //文件上传接口
        fileUploadHeaders: {
            "client_secret": "461044D526404E9C97968a73f3b32Eb7",
            "client_id2": "8c0fef628dd94e30a0c7bcd7b1fd34e5",
            "client_secret2": "461044D526404E9C97968a73f3b32Eb7",
            "client_id": "8c0fef628dd94e30a0c7bcd7b1fd34e5"
        },
        showLoading: true
    });
}

function fileUploadThr(params) {
    return request({
        url: '/fileUploadHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 公司信息反显
function companyInformationQuery(params) {
    return request({
        url: '/getCompanyInfo',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 授权成功页面 下一步
function getTaxCodeCheck(params) {
    return request({
        url: '/taxCodeCheck',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 上传补充资料 反显
function fileListloadHandler(params) {
    return request({
        url: '/fileListLoadHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 上传补充资料信息反显 删除
function fileListDelete(params) {
    return request({
        url: '/fileDetailDeleteHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 上传补充资料 图片下载
function GetFileDownloadKeyHandler(params) {
    return request({
        url: '/getFileDownloadKeyHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 社会信用代码
function businessVerifyHandler(params) {
    return request({
        url: '/businessVerifyHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 贷款目的和类型选择
function loanPurposeAndTypeSelect(params) {
    return request({
        url: '/loanPurposeAndTypeSelect',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 支付方式
function paymentSelectHandler(params) {
    return request({
        url: '/paymentSelectHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 上传文件
function submitOrderSuccessHandler(params) {
    return request({
        url: '/submitOrderSuccessHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// offerId反选
function retrieveOfferHandler(params) {
    return request({
        url: '/retrieveOfferHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 反显数据
function pageDetailLoad(params) {
    return request({
        url: '/pageDetailLoad',
        method: 'post',
        data: params,
        showLoading: true
    });
}

function commonPageDetailLoadHandler(params) {
    return request({
        url: '/commonPageDetailLoadHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 贷款发放信息反显数据
function loadAnchorInfoHandler(params) {
    return request({
        url: '/loadAnchorInfoHandler',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 关联人添加
function recordRelationHandler(params) {
    return request({
        url: '/recordRelation',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 关联人确认
function loadRelation(params) {
    return request({
        url: '/loadRelation',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 提交订单
function submitOrderSuccess(params) {
    return request({
        url: '/submitOrderSuccess',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 删除关联人
function deleteRelation(params) {
    return request({
        url: '/deleteRelation',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 关联人认证授权
function commonPageDetailLoad(params) {
    return request({
        url: '/commonPageDetailLoad',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 关联人认证授权
function registerRelation(params) {
    return request({
        url: '/registerRelation',
        method: 'post',
        data: params,
        showLoading: true
    });
}
// 关联人认证授权
function loadRelationByUserName(params) {
    return request({
        url: '/loadRelationByUserName',
        method: 'post',
        data: params,
        showLoading: true
    });
}

// 获取图片验证码
// export function signCaptcha(params) {
//     return request({
//         url: '/image/signCaptcha',
//         method: 'post',
//         data: params,
//         showLoading: true
//     })
// }
// CONCATENATED MODULE: ./src/assets/utils/gps.js
var gps_location = {
  initMap: function initMap(id) {
    var mapObj = new AMap.Map(id, {});
    var geolocation = void 0;
    mapObj.plugin(['AMap.Geolocation'], function () {
      geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, //  是否使用高精度定位，默认:true
        timeout: 10000, //  超过10秒后停止定位，默认：无穷大
        maximumAge: 0, // 定位结果缓存0毫秒，默认：0
        convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        showButton: true, //  显示定位按钮，默认：true
        buttonPosition: 'LB', // 定位按钮停靠位置，默认：'LB'，左下角
        buttonOffset: new AMap.Pixel(10, 20), //  定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        showMarker: true, //  定位成功后在定位到的位置显示点标记，默认：true
        showCircle: true, //  定位成功后用圆圈表示定位精度范围，默认：true
        panToLocation: true, //  定位成功后将定位到的位置作为地图中心点，默认：true
        zoomToAccuracy: true //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
      });
      mapObj.addControl(geolocation);
      geolocation.getCurrentPosition();
    });
    return geolocation;
  }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 //经纬度信息

/* harmony default export */ var App = ({
    name: 'app',
    data: function data() {
        return {
            isConfirmInf: false,
            jumpCode: '',
            gps: {} //经纬度信息
        };
    },
    mounted: function mounted() {
        //获取经纬度
        // this.getLocation();
    },

    methods: {
        jumpPage: function jumpPage(data) {
            this.isConfirmInf = true;
            this.jumpCode = data;
        },
        proceed: function proceed(data) {
            if (data === '1') {
                window.open("https://beian.miit.gov.cn/");
            } else if (data === '2') {
                window.open("http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020170821174538000002010036-SAIC_SHOW_310000-20171101111325737110&signData=MEUCIQCHH0AE1EpV+6swwZ5EXSTVqcbF2K1KRJFO6oJAyzvMuAIgDaPz3iuhsqJKwkFNGAtxSG/0T/hnc7FIV273241+8b0=");
            } else if (data === '3') {
                window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502400282");
            }
            this.isConfirmInf = false;
        },
        loginOut: function loginOut() {
            var _this = this;

            logout({}).then(function (result) {
                if (result.responseCode == "000000") {
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    _this.$router.push({
                        path: url
                    });
                }
            });
        },
        getLocation: function getLocation() {
            //1
            if (window.returnCitySN) {
                var createdIp = returnCitySN['cip'];
                hashmap.set('createdIp', createdIp);
                console.log('createdIp', createdIp);
            }

            // 判断是否支持 获取本地位置 2
            // if (navigator.geolocation) {
            //     var n = navigator.geolocation.getCurrentPosition(function(res){
            //         console.log('h5gps',res);
            //     },function(error){
            //         console.log('h5gpserror',error)
            //     });
            // } else {
            //     console.log('h5gps该浏览器不支持定位');
            // }

            //3
            if (window.AMap) {
                var _that = this;
                var geolocation = gps_location.initMap("map-container"); //定位
                AMap.event.addListener(geolocation, "complete", function (result) {
                    _that.gps.lat = result.position.lat;
                    _that.gps.lng = result.position.lng;
                    _that.gps.province = result.addressComponent.province;
                    _that.gps.city = result.addressComponent.city;
                    _that.gps.district = result.addressComponent.district;
                    console.log('gps', _that.gps);
                    var createdLongitude = _that.gps.lat;
                    var createdLatitude = _that.gps.lng;
                    var createdAddress = _that.gps.province + '|' + _that.gps.city;
                    hashmap.set('createdLongitude', createdLongitude);
                    hashmap.set('createdLatitude', createdLatitude);
                    hashmap.set('createdAddress', createdAddress);
                }, function (err) {
                    console.log('gpserr', err);
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 //经纬度信息

/* harmony default export */ var selectortype_script_index_0_src_App = ({
    name: 'app',
    data: function data() {
        return {
            isConfirmInf: false,
            jumpCode: '',
            gps: {} //经纬度信息
        };
    },
    mounted: function mounted() {
        //获取经纬度
        // this.getLocation();
    },

    methods: {
        jumpPage: function jumpPage(data) {
            this.isConfirmInf = true;
            this.jumpCode = data;
        },
        proceed: function proceed(data) {
            if (data === '1') {
                window.open("https://beian.miit.gov.cn/");
            } else if (data === '2') {
                window.open("http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020170821174538000002010036-SAIC_SHOW_310000-20171101111325737110&signData=MEUCIQCHH0AE1EpV+6swwZ5EXSTVqcbF2K1KRJFO6oJAyzvMuAIgDaPz3iuhsqJKwkFNGAtxSG/0T/hnc7FIV273241+8b0=");
            } else if (data === '3') {
                window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502400282");
            }
            this.isConfirmInf = false;
        },
        loginOut: function loginOut() {
            var _this = this;

            logout({}).then(function (result) {
                if (result.responseCode == "000000") {
                    var message = utils.routerJump.returnUrl(result.responseData.fbCode);
                    var url = message.url;
                    _this.$router.push({
                        path: url
                    });
                }
            });
        },
        getLocation: function getLocation() {
            //1
            if (window.returnCitySN) {
                var createdIp = returnCitySN['cip'];
                hashmap.set('createdIp', createdIp);
                console.log('createdIp', createdIp);
            }

            // 判断是否支持 获取本地位置 2
            // if (navigator.geolocation) {
            //     var n = navigator.geolocation.getCurrentPosition(function(res){
            //         console.log('h5gps',res);
            //     },function(error){
            //         console.log('h5gpserror',error)
            //     });
            // } else {
            //     console.log('h5gps该浏览器不支持定位');
            // }

            //3
            if (window.AMap) {
                var _that = this;
                var geolocation = gps_location.initMap("map-container"); //定位
                AMap.event.addListener(geolocation, "complete", function (result) {
                    _that.gps.lat = result.position.lat;
                    _that.gps.lng = result.position.lng;
                    _that.gps.province = result.addressComponent.province;
                    _that.gps.city = result.addressComponent.city;
                    _that.gps.district = result.addressComponent.district;
                    console.log('gps', _that.gps);
                    var createdLongitude = _that.gps.lat;
                    var createdLatitude = _that.gps.lng;
                    var createdAddress = _that.gps.province + '|' + _that.gps.city;
                    hashmap.set('createdLongitude', createdLongitude);
                    hashmap.set('createdLatitude', createdLatitude);
                    hashmap.set('createdAddress', createdAddress);
                }, function (err) {
                    console.log('gpserr', err);
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-085763f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-fixed-01",attrs:{"id":"app"}},[_c('header',{staticClass:"global-header"},[_c('nav',{staticClass:"wrapper"},[_vm._m(0),_vm._v(" "),_c('b',{staticClass:"loginOut"},[_c('span',{attrs:{"id":"spans"},on:{"click":_vm.loginOut}},[_vm._v("退出登录")])])])]),_vm._v(" "),_c('div',{staticClass:"global-context",attrs:{"role":"banner"}},[_c('div',{staticClass:"global-top-height"}),_vm._v(" "),_c('div',{staticClass:"global-wrapper"},[_c('div',{staticClass:"container",attrs:{"role":"main"}},[_c('router-view')],1),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"map-container"}})])]),_vm._v(" "),_c('footer',{staticClass:"global-footer",attrs:{"role":"contentinfo"}},[_c('div',{staticClass:"wrapper"},[_vm._m(1),_vm._v(" "),_c('p',[_c('span',{on:{"click":function($event){return _vm.jumpPage('1')}}},[_vm._v("沪ICP备15029387号")])]),_vm._v(" "),_c('p',[_c('span',{on:{"click":function($event){return _vm.jumpPage('2')}}},[_vm._v("上海工商")])]),_vm._v(" "),_c('p',[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":"https://www.hsbc.com/-/files/hsbc/footer/icp-license-icon.png?h=20&w=20&la=en-GB&hash=CFCA12915EADD30B64F5F0E751F42834","alt":""}}),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.jumpPage('3')}}},[_vm._v("沪公网安备 31011502400282号")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),(_vm.isConfirmInf)?_c('div',{staticClass:"confirmInformation"},[_c('div',{staticClass:"confirmInformations"},[_c('p',{staticClass:"title"},[_vm._v("您正在离开汇丰村镇银行个人贷款在线预申请平台")]),_vm._v(" "),_c('p',{staticClass:"cont"},[_vm._v("请注意，外部网站的政策与我们网站的条款和条件以及隐私政策不同。将在新浏览器窗口或选项卡中打开下一个网站。")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-cancel f-right",attrs:{"type":"button"},on:{"click":function($event){_vm.isConfirmInf = false}}},[_vm._v("\n                取消\n            ")]),_vm._v(" "),_c('button',{staticClass:"global-btn btn-primary f-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.proceed(_vm.jumpCode)}}},[_vm._v("\n                我明白，让我们继续\n            ")])])]):_vm._e()])}
var App_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logo",attrs:{"tabindex":"-1","href":"","title":"HSBC Logo"}},[_c('img',{attrs:{"alt":"HSBC Logo","src":__webpack_require__("cH+4")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("©版权所有。汇丰银行（中国）有限公司2021。不得转载。"),_c('br'),_vm._v("本网站支持IPv6")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("本网站为在中国大陆地区使用而设计。"),_c('a',{attrs:{"href":"https://www.hsbc.com.cn/legal/cross-border-banking/","target":"_blank"}},[_c('span',[_vm._v("网站跨境免责声明")])])])}]
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("D6Ou")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/permission.js


router.afterEach(function (to, from, next) {
  window.scrollTo(0, 0);
});
// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/components/loading/index.vue + 3 modules
var components_loading = __webpack_require__("Bfwr");

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var components_toast = __webpack_require__("rLAy");

// CONCATENATED MODULE: ./src/main.js














vue_esm["default"].use(lib_date_picker_default.a);






vue_esm["default"].component('loading', components_loading["a" /* default */]);
vue_esm["default"].component('toast', components_toast["a" /* default */]);
vue_esm["default"].use(toast["a" /* default */], { position: 'middle', isShowMask: true });
vue_esm["default"].use(loading["a" /* default */]);
vue_esm["default"].use(vue_router_esm["a" /* default */]);

vue_esm["default"].config.productionTip = false;
/* eslint-disable no-new */
var myThis = new vue_esm["default"]({
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

vue_esm["default"].prototype.showToast = function (text) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "12rem";
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;

  this.$vux.toast.show({
    text: text,
    width: width,
    time: time,
    type: 'text',
    position: 'middle'
  });
};
/* harmony default export */ var src_main = __webpack_exports__["default"] = (myThis);

utils.getInfomation.init();

/***/ }),

/***/ "PU+M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UCfD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VgBI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WPfM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WopM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZY3G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Za2K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cH+4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "dfSi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "edMS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fOqk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmuQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxFq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/vue-qr/src/util.js
var util = __webpack_require__("e7FP");

// EXTERNAL MODULE: ./node_modules/vue-qr/src/awesome-qr.js
var awesome_qr = __webpack_require__("SXdm");
var awesome_qr_default = /*#__PURE__*/__webpack_require__.n(awesome_qr);

// EXTERNAL MODULE: ./node_modules/vue-qr/src/imgLoaded.js
var imgLoaded = __webpack_require__("8Oqb");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-qr/src/vue-qr.vue


//
//
//
//
//
//

var uuidv4 = __webpack_require__("DtRx");



/* harmony default export */ var vue_qr = ({
  props: {
    text: {
      type: String,
      required: true
    },
    qid: {
      type: String
    },
    size: {
      type: Number,
      default: 200
    },
    margin: {
      type: Number,
      default: 20
    },
    colorDark: {
      type: String,
      default: '#000000'
    },
    colorLight: {
      type: String,
      default: '#FFFFFF'
    },
    bgSrc: {
      type: String,
      default: undefined
    },
    backgroundDimming: {
      type: String,
      default: 'rgba(0,0,0,0)'
    },
    logoSrc: {
      type: String,
      default: undefined
    },
    logoScale: {
      type: Number,
      default: 0.2
    },
    logoMargin: {
      type: Number,
      default: 0
    },
    logoCornerRadius: {
      type: Number,
      default: 8
    },
    whiteMargin: {
      type: [Boolean, String],
      default: true
    },
    dotScale: {
      type: Number,
      default: 1
    },
    autoColor: {
      type: [Boolean, String],
      default: true
    },
    binarize: {
      type: [Boolean, String],
      default: false
    },
    binarizeThreshold: {
      type: Number,
      default: 128
    },
    callback: {
      type: Function,
      default: function _default() {
        return undefined;
      }
    },
    bindElement: {
      type: Boolean,
      default: true
    }
  },
  name: 'vue-qr',
  data: function data() {
    return {
      uuid: ''
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler() {
        this.main();
      }
    }
  },
  mounted: function mounted() {
    this.uuid = uuidv4();
    this.main();
  },

  methods: {
    main: function main() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var that, bgImg, logoImg, img, _img;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;

                if (!(_this.bgSrc && _this.logoSrc)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return Object(imgLoaded["a" /* default */])(_this.bgSrc);

              case 4:
                bgImg = _context.sent;
                _context.next = 7;
                return Object(imgLoaded["a" /* default */])(_this.logoSrc);

              case 7:
                logoImg = _context.sent;

                _this.render(bgImg, logoImg);
                return _context.abrupt('return');

              case 10:
                if (!_this.bgSrc) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return Object(imgLoaded["a" /* default */])(_this.bgSrc);

              case 13:
                img = _context.sent;

                _this.render(img);
                return _context.abrupt('return');

              case 16:
                if (!_this.logoSrc) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return Object(imgLoaded["a" /* default */])(_this.logoSrc);

              case 19:
                _img = _context.sent;

                _this.render(undefined, _img);
                return _context.abrupt('return');

              case 22:

                setTimeout(function () {
                  that.render();
                }, 0);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    render: function render(img, logoImg) {
      var that = this;
      new awesome_qr_default.a().create({
        text: that.text,
        size: that.size,
        margin: that.margin,
        colorDark: that.colorDark,
        colorLight: that.colorLight,
        backgroundImage: img,
        backgroundDimming: that.backgroundDimming,
        logoImage: logoImg,
        logoScale: that.logoScale,
        logoMargin: that.logoMargin,
        logoCornerRadius: that.logoCornerRadius,
        whiteMargin: Object(util["a" /* toBoolean */])(that.whiteMargin),
        dotScale: that.dotScale,
        autoColor: Object(util["a" /* toBoolean */])(that.autoColor),
        binarize: Object(util["a" /* toBoolean */])(that.binarize),
        binarizeThreshold: that.binarizeThreshold,
        callback: function callback(dataURI) {
          that.callback && that.callback(dataURI, that.qid);
        },
        bindElement: that.bindElement ? that.uuid : undefined
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-qr/src/vue-qr.vue


//
//
//
//
//
//

var vue_qr_uuidv4 = __webpack_require__("DtRx");



/* harmony default export */ var src_vue_qr = ({
  props: {
    text: {
      type: String,
      required: true
    },
    qid: {
      type: String
    },
    size: {
      type: Number,
      default: 200
    },
    margin: {
      type: Number,
      default: 20
    },
    colorDark: {
      type: String,
      default: '#000000'
    },
    colorLight: {
      type: String,
      default: '#FFFFFF'
    },
    bgSrc: {
      type: String,
      default: undefined
    },
    backgroundDimming: {
      type: String,
      default: 'rgba(0,0,0,0)'
    },
    logoSrc: {
      type: String,
      default: undefined
    },
    logoScale: {
      type: Number,
      default: 0.2
    },
    logoMargin: {
      type: Number,
      default: 0
    },
    logoCornerRadius: {
      type: Number,
      default: 8
    },
    whiteMargin: {
      type: [Boolean, String],
      default: true
    },
    dotScale: {
      type: Number,
      default: 1
    },
    autoColor: {
      type: [Boolean, String],
      default: true
    },
    binarize: {
      type: [Boolean, String],
      default: false
    },
    binarizeThreshold: {
      type: Number,
      default: 128
    },
    callback: {
      type: Function,
      default: function _default() {
        return undefined;
      }
    },
    bindElement: {
      type: Boolean,
      default: true
    }
  },
  name: 'vue-qr',
  data: function data() {
    return {
      uuid: ''
    };
  },

  watch: {
    $props: {
      deep: true,
      handler: function handler() {
        this.main();
      }
    }
  },
  mounted: function mounted() {
    this.uuid = vue_qr_uuidv4();
    this.main();
  },

  methods: {
    main: function main() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var that, bgImg, logoImg, img, _img;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;

                if (!(_this.bgSrc && _this.logoSrc)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return Object(imgLoaded["a" /* default */])(_this.bgSrc);

              case 4:
                bgImg = _context.sent;
                _context.next = 7;
                return Object(imgLoaded["a" /* default */])(_this.logoSrc);

              case 7:
                logoImg = _context.sent;

                _this.render(bgImg, logoImg);
                return _context.abrupt('return');

              case 10:
                if (!_this.bgSrc) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return Object(imgLoaded["a" /* default */])(_this.bgSrc);

              case 13:
                img = _context.sent;

                _this.render(img);
                return _context.abrupt('return');

              case 16:
                if (!_this.logoSrc) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return Object(imgLoaded["a" /* default */])(_this.logoSrc);

              case 19:
                _img = _context.sent;

                _this.render(undefined, _img);
                return _context.abrupt('return');

              case 22:

                setTimeout(function () {
                  that.render();
                }, 0);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    render: function render(img, logoImg) {
      var that = this;
      new awesome_qr_default.a().create({
        text: that.text,
        size: that.size,
        margin: that.margin,
        colorDark: that.colorDark,
        colorLight: that.colorLight,
        backgroundImage: img,
        backgroundDimming: that.backgroundDimming,
        logoImage: logoImg,
        logoScale: that.logoScale,
        logoMargin: that.logoMargin,
        logoCornerRadius: that.logoCornerRadius,
        whiteMargin: Object(util["a" /* toBoolean */])(that.whiteMargin),
        dotScale: that.dotScale,
        autoColor: Object(util["a" /* toBoolean */])(that.autoColor),
        binarize: Object(util["a" /* toBoolean */])(that.binarize),
        binarizeThreshold: that.binarizeThreshold,
        callback: function callback(dataURI) {
          that.callback && that.callback(dataURI, that.qid);
        },
        bindElement: that.bindElement ? that.uuid : undefined
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a574806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-qr/src/vue-qr.vue
var vue_qr_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bindElement)?_c('div',[_c('img',_vm._b({},'img',{id:_vm.uuid},false))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: vue_qr_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vue_qr_src_vue_qr = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-qr/src/vue-qr.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_vue_qr,
  vue_qr_src_vue_qr,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vue_qr_src_vue_qr = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mq5u":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT7otYTmupAgMTwvdGl0bGU+PGcgaWQ9IuWbvuWxgl8yIiBkYXRhLW5hbWU9IuWbvuWxgiAyIj48ZyBpZD0i5Zu+5bGCXzEtMiIgZGF0YS1uYW1lPSLlm77lsYIgMSI+PHJlY3QgaWQ9IlJlY3RhbmdsZS1wYXRoIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIvPjxwb2x5Z29uIHBvaW50cz0iMTYuNDIgMi40MiAxNS41OCAxLjU4IDkgOC4xNSAyLjQyIDEuNTggMS41OCAyLjQyIDguMTUgOSAxLjU4IDE1LjU4IDIuNDIgMTYuNDIgOSA5Ljg1IDE1LjU4IDE2LjQyIDE2LjQyIDE1LjU4IDkuODUgOSAxNi40MiAyLjQyIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ "oyZ0":
/***/ (function(module, exports) {

module.exports = [{"code":"6000","h1":"欢迎进入汇丰村镇银行个人贷款在线预申请平台","desc1":"为“三农”及广大个人客户提供量身定制的贷款产品，助力个人客户惠享生活、发展事业","h2":"个人经营性贷款产品","desc":"村镇银行为农户、个体经营者、小微企业主等量身定制的贷款产品，可为您提供1年至3年期、最高达50万元额度的个人无抵押贷款，也可以为您提供最长可达5年的个人抵押贷款，帮助您增强资金流动性或用于生产性的固定资产投资。 ","protitle2":"个人经营性贷款","feature":["最高达50万额度*，最长贷3年：贷款过程中若您保持按时还款，贷款额度可随着您个人信用的提高而逐步增加，贷款最高额度可以达到50万","资料完整3-5日快速核批：银行获取完整贷款申请材料后3-5个工作日内快速审批/放贷；对于续贷老客户，贷款申请材料进一步简化，加快审批效率","还款灵活，循环信贷：1-3年期按月/季/现金流分期还款，或给与您循环授信","审核务实，免手续费：贷款评估公正、务实、透明，不额外收取客户任何手续费"],"tips":"注：部分优质客户专享免担保特别权益，详洽当地汇丰村镇银行。","feature2":["最高额度可达抵押物评估价值的70%，最长期限可达5年","还款灵活，多种还款方式可选：随借随还，到期一次性还款，分期还款等","可接受的抵押物包括住宅、商铺、办公楼","审核务实，免手续费：贷款评估公正、务实、透明，不额外收取客户任何手续费"],"object":["农户（指从事养殖、种植和销售农产品等的农户）","个体工商户（指从事生产、贸易和服务业等经营的个人）","小微企业主（指经营小微企业的个人）"],"linkpeople":[{"label":"共同借款人","value":"1"},{"label":"担保人","value":"2"},{"label":"其他","value":"3"}],"setup_title":"借款申请人基本信息及验证授权","setup_desc":"请提供您的个人信息及身份证和银行卡信息以完成实名认证","setup_title2":"借款申请人身份信息","setup_check0":"本人知晓在本贷款预申请及申请项下本人向汇丰村镇银行（“贵行”）提供的所有信息须经过贵行及贵行指定人员的调查确认，如有需要，本人同意根据要求配合贵行及贵行指定人员的调查、检查。本人并在此同意并授权贵行根据办理贷款业务、审核贷款申请和风险管理的需要向金融信用信息基础数据库查询本人的信用报告；同时授权贵行向金融信用信息基础数据库提供本人的个人信息及个人信用信息（包括但不限于不良信用信息和其他个人不良信息，下称“个人信用信息”）。贵行已在此告知本人贵行将向金融信用信息基础数据库提供本人的个人信用信息，本人对此确认知悉。本人同时确认，本人知悉并理解本条款中的授权和声明及其后果。上述授权有效期截止于本申请项下贷款得以完全清偿之日，若贷款申请未通过审核，则截止于贵行通知本人贷款申请未能通过审核之日。贵行将对超出本授权查询本人个人信用信息的行为承担法律责任。同时，本人确认并理解，贵行为了系统维护、数据的分析、储存、管理等目的，需要将本人的个人信息披露给为上述目的向贵行提供相关服务的第三方（无论本人的申请是否被贵行接受），本人特此授权贵行在法律法规允许的范围内向该等第三方披露本人的个人信息。","setup_check1":"本人知晓贵行将根据并依赖本人所题写的申请信息和提供的个人信息就相关贷款业务进行评估、预审等。本人充分了解并自愿填写、提供的申请信息及其他贷款义务人或相关人士信息并保证本人填写、提供的信息真实、准确且在任何方面不存在误导。本人同意贵行向相关的权力机关、雇主或其他有关单位、其他贷款义务人或相关人士及其他人士收集、查询、核实、验证本人的个人信息。本人清楚了解并同意：若贵行认定或有理由怀疑本人提供的信息在任何方面不真实、不准确、不完整或已过时或存在误导，贵行有权全部或部分暂停或终止向本人提供贷款服务，贵行对此不承担任何责任。","setup_check2":"本人知晓并同意，预申请结果将根据本人提交的信息综合评估得出，仅供参考。本人是否具备办理相关贷款业务的条件及贷款业务的具体安排须以本人正式提出贷款申请后贵行的最终审核结果为准。","acceptloan_h1":"恭喜您，已完成个人贷款在线预申请流程","acceptloan_next":"接下来，请将以下二维码分享给您提供的其他贷款义务人或相关人士，完成征信信息查询授权。已填写手机号码的其他贷款义务人或相关人士也将收到短信通知。","acceptloan_tip1":"感谢您对汇丰村镇银行服务的关注和支持。我们的客户经理将尽快与您联系。","acceptloan_tip2":"如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/","editagain":"现在，您可再次编辑其他贷款义务人或相关人士信息，将二维码或链接分享给他们吧。","linkpeople_error":"请选择此其他贷款义务人或相关人士配偶姓名！"},{"code":"7000","h1":"欢迎进入汇丰村镇银行贷款在线预申请平台","desc1":"为“三农”及广大个人和企业客户提供量身定制的贷款产品，助力客户发展事业，事半功倍","h2":"小微企业贷款","desc":"为小微企业提供额度宽裕、抵押多样、还款灵活的抵押或者信用贷款，一对一专属服务，满足不同贷款需求。","protitle2":"小微企业贷款","feature":["贷款用途：借款人从事生产经营过程中的流动资金需求或固定资产投资贷款","贷款期限：流动资金贷款最长可达3年，固定资产贷款最长可达10年","贷款金额：最高额度可达800万元","贷款类型：抵押贷款，信用贷款，抵押+信用组合贷款","抵押方式：住宅、商铺、办公楼、厂房及土地使用权、土地使用权、机器设备、存货、应收账款等","还款方式：随借随还，到期一次性还款，分期还款等","年化利率（以单利方法计算）：平均利率4%-6%"],"tips":"注：此利率为全国12家汇丰村镇银行本产品年化利率最高值，根据2023年12月20日的1年期贷款市场报价利率（LPR）估算，将依据LPR变动而调整。此外，满足条件可获得更低利率，如：特有的各类政府/第三方合作项目","tips2":"更多产品信息请询当地汇丰村镇银行。","object":["小微企业"],"linkpeople":[{"label":"借款申请主体法定代表人","value":"4"},{"label":"借款申请主体实际控制人","value":"5"},{"label":"个人保证担保人","value":"6"},{"label":"个人抵押担保人","value":"7"},{"label":"个人保证担保人配偶","value":"8"},{"label":"个人抵押担保人配偶","value":"9"},{"label":"其他","value":"10"}],"setup_title":"借款申请主体基本信息及验证授权","setup_desc":"请提供企业信息及您的个人信息及身份证和银行卡信息以完成实名认证","setup_title2":"借款申请主体经办人身份信息","setup_check0":"本人知晓在本贷款预申请及申请项下本人向汇丰村镇银行（“贵行”）提供的所有信息须经过贵行及贵行指定人员的调查确认，如有需要，本人同意根据要求配合贵行及贵行指定人员的调查、检查。本人并在此同意并授权贵行根据办理贷款业务、审核贷款申请和风险管理的需要向金融信用信息基础数据库查询本人的信用报告；同时授权贵行向金融信用信息基础数据库提供本人的个人信息及个人信用信息（包括但不限于不良信用信息和其他个人不良信息，下称“个人信用信息”）。贵行已在此告知本人贵行将向金融信用信息基础数据库提供本人的个人信用信息，本人对此确认知悉。本人同时确认，本人知悉并理解本条款中的授权和声明及其后果。上述授权有效期截止于本申请项下贷款得以完全清偿之日，若贷款申请未通过审核，则截止于贵行通知本人贷款申请未能通过审核之日。贵行将对超出本授权查询本人个人信用信息的行为承担法律责任。同时，本人确认并理解，贵行为了系统维护、数据的分析、储存、管理等目的，需要将本人的个人信息披露给为上述目的向贵行提供相关服务的第三方（无论本人的申请是否被贵行接受），本人特此授权贵行在法律法规允许的范围内向该等第三方披露本人的个人信息。","setup_check1":"本人确认已取得上述借款申请主体（“我司”）授权代表提交贷款预申请，知晓并同意汇丰村镇银行将根据并依赖本人所填写的贷款预申请信息和提供的其他贷款义务人及相关人士信息就相关贷款业务进行评估、预审等。我司及本人充分了解并自愿填写、提供的贷款预申请信息及其他贷款义务人和相关人士信息的信息，并保证填写、提供的信息真实、准确且在任何方面不存在误导。我司及本人清楚了解并同意：若汇丰村镇银行认定或有理由怀疑我司或本人提供的信息在任何方面不真实、不准确、不完整或已过时或存在误导，汇丰村镇银行有权全部或部分暂停或终止向我司提供贷款服务，而无须对此承担任何责任。本人确认已阅读、理解《汇丰村镇银行个人信息和隐私保护政策》（可通过汇丰村镇银行网站www.hsbc.com.cn/rural-bank查阅）的条款和条件，并同意汇丰村镇银行按该等条款和条件处理（包括收集、存储、使用、加工、传输、提供、公开、删除等）本人的个人信息。","setup_check2":"我司及本人确认知晓并同意，预申请结果将根据提交的信息综合评估得出，仅供参考。我司是否具备办理相关贷款业务的条件及贷款业务的具体安排须以我司正式提出贷款申请后汇丰村镇银行的最终审核结果为准。","setup_check3":"我司和本人确认已获得其他贷款义务人和相关人士的授权和同意，有权合法地将其信息提供给汇丰村镇银行，用于汇丰村镇银行对我司贷款预申请的审核和评估。","acceptloan_h1":"恭喜您，已完成小微企业贷款在线预申请流程","acceptloan_next":"接下来，请联系贵司客户经理完成其他贷款义务人或相关人士的线下征信信息查询授权。","acceptloan_tip1":"感谢贵司对汇丰村镇银行服务的关注和支持。我们的客户经理将尽快与您联系。","acceptloan_tip2":"如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系贵司的客户经理或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/","editagain":"现在，您可再次编辑其他贷款义务人或相关人士信息。","linkpeople_error":"请填写此其他贷款义务人或相关人士配偶姓名！"}]

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("edMS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rjgy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "thTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uul/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vYue":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fS5jbHMtMntmaWxsOm5vbmU7fS5jbHMtM3tmaWxsOiMyNTI1MjU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT7otYTmupAgNzwvdGl0bGU+PGcgaWQ9IuWbvuWxgl8yIiBkYXRhLW5hbWU9IuWbvuWxgiAyIj48ZyBpZD0i5Zu+5bGCXzEtMiIgZGF0YS1uYW1lPSLlm77lsYIgMSI+PGcgaWQ9ImRlbGV0ZSI+PHBhdGggaWQ9InBhdGgtMSIgY2xhc3M9ImNscy0xIiBkPSJNMTIsNy41aC0uNzV2Ni4zN0gxMlptLTUuMjUsMEg2djYuMzdoLjc1Wk0xNC4yNSwzaC0zVjIuNjNhMS41LDEuNSwwLDAsMC0xLjUtMS41SDguMjVhMS41LDEuNSwwLDAsMC0xLjUsMS41VjNoLTNBMS4xMiwxLjEyLDAsMCwwLDIuNjMsNC4xMnYxLjVoLjc1VjE2Ljg4SDE0LjYzVjUuNjJoLjc1VjQuMTJBMS4xMywxLjEzLDAsMCwwLDE0LjI1LDNaTTcuNSwyLjYzYS43NS43NSwwLDAsMSwuNzUtLjc1aDEuNWEuNzUuNzUsMCwwLDEsLjc1Ljc1VjNoLTNabTYuMzgsMTMuNUg0LjEzVjUuNjJoOS43NVptLjc1LTExLjI1SDMuMzhWNC4xMmEuMzguMzgsMCwwLDEsLjM4LS4zOGgxMC41YS4zOC4zOCwwLDAsMSwuMzguMzhaTTkuMzcsNy41SDguNjJ2Ni4zN2guNzVaIi8+PC9nPjxyZWN0IGlkPSJjb2xvdXJzIiBjbGFzcz0iY2xzLTIiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIvPjxnIGlkPSJtYXNrLTIiPjxwYXRoIGlkPSJwYXRoLTEtMiIgZGF0YS1uYW1lPSJwYXRoLTEiIGNsYXNzPSJjbHMtMyIgZD0iTTEyLDcuNWgtLjc1djYuMzdIMTJabS01LjI1LDBINnY2LjM3aC43NVpNMTQuMjUsM2gtM1YyLjYzYTEuNSwxLjUsMCwwLDAtMS41LTEuNUg4LjI1YTEuNSwxLjUsMCwwLDAtMS41LDEuNVYzaC0zQTEuMTIsMS4xMiwwLDAsMCwyLjYzLDQuMTJ2MS41aC43NVYxNi44OEgxNC42M1Y1LjYyaC43NVY0LjEyQTEuMTMsMS4xMywwLDAsMCwxNC4yNSwzWk03LjUsMi42M2EuNzUuNzUsMCwwLDEsLjc1LS43NWgxLjVhLjc1Ljc1LDAsMCwxLC43NS43NVYzaC0zWm02LjM4LDEzLjVINC4xM1Y1LjYyaDkuNzVabS43NS0xMS4yNUgzLjM4VjQuMTJhLjM4LjM4LDAsMCwxLC4zOC0uMzhoMTAuNWEuMzguMzgsMCwwLDEsLjM4LjM4Wk05LjM3LDcuNUg4LjYydjYuMzdoLjc1WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.477bbe92591f46243098.js